import { createRequire as Gr } from "module";
var Uc = function(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, a = e.length, u; r < a; r++)
    (u || !(r in e)) && (u || (u = Array.prototype.slice.call(e, 0, r)), u[r] = e[r]);
  return t.concat(u || Array.prototype.slice.call(e));
};
function Cc(t) {
  return t;
}
function ce(t, e, n, r, a, u, o, c, f) {
  switch (arguments.length) {
    case 1:
      return t;
    case 2:
      return e(t);
    case 3:
      return n(e(t));
    case 4:
      return r(n(e(t)));
    case 5:
      return a(r(n(e(t))));
    case 6:
      return u(a(r(n(e(t)))));
    case 7:
      return o(u(a(r(n(e(t))))));
    case 8:
      return c(o(u(a(r(n(e(t)))))));
    case 9:
      return f(c(o(u(a(r(n(e(t))))))));
    default: {
      for (var l = arguments[0], d = 1; d < arguments.length; d++)
        l = arguments[d](l);
      return l;
    }
  }
}
var Ji = function(t, e) {
  var n = typeof t == "number" ? function(r) {
    return r.length >= t;
  } : t;
  return function() {
    var r = Array.from(arguments);
    return n(arguments) ? e.apply(this, r) : function(a) {
      return e.apply(void 0, Uc([a], r, !1));
    };
  };
}, C = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, oe = {}, me = {}, St = {}, ft = {};
(function(t) {
  var e = C && C.__spreadArray || function(s, m, T) {
    if (T || arguments.length === 2) for (var O = 0, L = m.length, D; O < L; O++)
      (D || !(O in m)) && (D || (D = Array.prototype.slice.call(m, 0, O)), D[O] = m[O]);
    return s.concat(D || Array.prototype.slice.call(m));
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.dual = t.getEndomorphismMonoid = t.SK = t.hole = t.constVoid = t.constUndefined = t.constNull = t.constFalse = t.constTrue = t.unsafeCoerce = t.apply = t.getRing = t.getSemiring = t.getMonoid = t.getSemigroup = t.getBooleanAlgebra = void 0, t.identity = f, t.constant = l, t.flip = d, t.flow = p, t.tuple = E, t.increment = R, t.decrement = U, t.absurd = q, t.tupled = F, t.untupled = J, t.pipe = A, t.not = B;
  var n = function(s) {
    return function() {
      return {
        meet: function(m, T) {
          return function(O) {
            return s.meet(m(O), T(O));
          };
        },
        join: function(m, T) {
          return function(O) {
            return s.join(m(O), T(O));
          };
        },
        zero: function() {
          return s.zero;
        },
        one: function() {
          return s.one;
        },
        implies: function(m, T) {
          return function(O) {
            return s.implies(m(O), T(O));
          };
        },
        not: function(m) {
          return function(T) {
            return s.not(m(T));
          };
        }
      };
    };
  };
  t.getBooleanAlgebra = n;
  var r = function(s) {
    return function() {
      return {
        concat: function(m, T) {
          return function(O) {
            return s.concat(m(O), T(O));
          };
        }
      };
    };
  };
  t.getSemigroup = r;
  var a = function(s) {
    var m = (0, t.getSemigroup)(s);
    return function() {
      return {
        concat: m().concat,
        empty: function() {
          return s.empty;
        }
      };
    };
  };
  t.getMonoid = a;
  var u = function(s) {
    return {
      add: function(m, T) {
        return function(O) {
          return s.add(m(O), T(O));
        };
      },
      zero: function() {
        return s.zero;
      },
      mul: function(m, T) {
        return function(O) {
          return s.mul(m(O), T(O));
        };
      },
      one: function() {
        return s.one;
      }
    };
  };
  t.getSemiring = u;
  var o = function(s) {
    var m = (0, t.getSemiring)(s);
    return {
      add: m.add,
      mul: m.mul,
      one: m.one,
      zero: m.zero,
      sub: function(T, O) {
        return function(L) {
          return s.sub(T(L), O(L));
        };
      }
    };
  };
  t.getRing = o;
  var c = function(s) {
    return function(m) {
      return m(s);
    };
  };
  t.apply = c;
  function f(s) {
    return s;
  }
  t.unsafeCoerce = f;
  function l(s) {
    return function() {
      return s;
    };
  }
  t.constTrue = l(!0), t.constFalse = l(!1), t.constNull = l(null), t.constUndefined = l(void 0), t.constVoid = t.constUndefined;
  function d(s) {
    return function() {
      for (var m = [], T = 0; T < arguments.length; T++)
        m[T] = arguments[T];
      return m.length > 1 ? s(m[1], m[0]) : function(O) {
        return s(O)(m[0]);
      };
    };
  }
  function p(s, m, T, O, L, D, ct, $, K) {
    switch (arguments.length) {
      case 1:
        return s;
      case 2:
        return function() {
          return m(s.apply(this, arguments));
        };
      case 3:
        return function() {
          return T(m(s.apply(this, arguments)));
        };
      case 4:
        return function() {
          return O(T(m(s.apply(this, arguments))));
        };
      case 5:
        return function() {
          return L(O(T(m(s.apply(this, arguments)))));
        };
      case 6:
        return function() {
          return D(L(O(T(m(s.apply(this, arguments))))));
        };
      case 7:
        return function() {
          return ct(D(L(O(T(m(s.apply(this, arguments)))))));
        };
      case 8:
        return function() {
          return $(ct(D(L(O(T(m(s.apply(this, arguments))))))));
        };
      case 9:
        return function() {
          return K($(ct(D(L(O(T(m(s.apply(this, arguments)))))))));
        };
    }
  }
  function E() {
    for (var s = [], m = 0; m < arguments.length; m++)
      s[m] = arguments[m];
    return s;
  }
  function R(s) {
    return s + 1;
  }
  function U(s) {
    return s - 1;
  }
  function q(s) {
    throw new Error("Called `absurd` function which should be uncallable");
  }
  function F(s) {
    return function(m) {
      return s.apply(void 0, m);
    };
  }
  function J(s) {
    return function() {
      for (var m = [], T = 0; T < arguments.length; T++)
        m[T] = arguments[T];
      return s(m);
    };
  }
  function A(s, m, T, O, L, D, ct, $, K) {
    switch (arguments.length) {
      case 1:
        return s;
      case 2:
        return m(s);
      case 3:
        return T(m(s));
      case 4:
        return O(T(m(s)));
      case 5:
        return L(O(T(m(s))));
      case 6:
        return D(L(O(T(m(s)))));
      case 7:
        return ct(D(L(O(T(m(s))))));
      case 8:
        return $(ct(D(L(O(T(m(s)))))));
      case 9:
        return K($(ct(D(L(O(T(m(s))))))));
      default: {
        for (var G = arguments[0], lt = 1; lt < arguments.length; lt++)
          G = arguments[lt](G);
        return G;
      }
    }
  }
  t.hole = q;
  var b = function(s, m) {
    return m;
  };
  t.SK = b;
  function B(s) {
    return function(m) {
      return !s(m);
    };
  }
  var x = function() {
    return {
      concat: function(s, m) {
        return p(s, m);
      },
      empty: f
    };
  };
  t.getEndomorphismMonoid = x;
  var j = function(s, m) {
    var T = typeof s == "number" ? function(O) {
      return O.length >= s;
    } : s;
    return function() {
      var O = Array.from(arguments);
      return T(arguments) ? m.apply(this, O) : function(L) {
        return m.apply(void 0, e([L], O, !1));
      };
    };
  };
  t.dual = j;
})(ft);
var zt = {};
(function(t) {
  var e = C && C.__spreadArray || function(s, m, T) {
    if (T || arguments.length === 2) for (var O = 0, L = m.length, D; O < L; O++)
      (D || !(O in m)) && (D || (D = Array.prototype.slice.call(m, 0, O)), D[O] = m[O]);
    return s.concat(D || Array.prototype.slice.call(m));
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.flatMapReader = t.flatMapTask = t.flatMapIO = t.flatMapEither = t.flatMapOption = t.flatMapNullable = t.liftOption = t.liftNullable = t.fromReadonlyNonEmptyArray = t.has = t.emptyRecord = t.emptyReadonlyArray = t.tail = t.head = t.isNonEmpty = t.singleton = t.right = t.left = t.isRight = t.isLeft = t.some = t.none = t.isSome = t.isNone = void 0;
  var n = ft, r = function(s) {
    return s._tag === "None";
  };
  t.isNone = r;
  var a = function(s) {
    return s._tag === "Some";
  };
  t.isSome = a, t.none = { _tag: "None" };
  var u = function(s) {
    return { _tag: "Some", value: s };
  };
  t.some = u;
  var o = function(s) {
    return s._tag === "Left";
  };
  t.isLeft = o;
  var c = function(s) {
    return s._tag === "Right";
  };
  t.isRight = c;
  var f = function(s) {
    return { _tag: "Left", left: s };
  };
  t.left = f;
  var l = function(s) {
    return { _tag: "Right", right: s };
  };
  t.right = l;
  var d = function(s) {
    return [s];
  };
  t.singleton = d;
  var p = function(s) {
    return s.length > 0;
  };
  t.isNonEmpty = p;
  var E = function(s) {
    return s[0];
  };
  t.head = E;
  var R = function(s) {
    return s.slice(1);
  };
  t.tail = R, t.emptyReadonlyArray = [], t.emptyRecord = {}, t.has = Object.prototype.hasOwnProperty;
  var U = function(s) {
    return e([s[0]], s.slice(1), !0);
  };
  t.fromReadonlyNonEmptyArray = U;
  var q = function(s) {
    return function(m, T) {
      return function() {
        for (var O = [], L = 0; L < arguments.length; L++)
          O[L] = arguments[L];
        var D = m.apply(void 0, O);
        return s.fromEither(D == null ? (0, t.left)(T.apply(void 0, O)) : (0, t.right)(D));
      };
    };
  };
  t.liftNullable = q;
  var F = function(s) {
    return function(m, T) {
      return function() {
        for (var O = [], L = 0; L < arguments.length; L++)
          O[L] = arguments[L];
        var D = m.apply(void 0, O);
        return s.fromEither((0, t.isNone)(D) ? (0, t.left)(T.apply(void 0, O)) : (0, t.right)(D.value));
      };
    };
  };
  t.liftOption = F;
  var J = function(s, m) {
    return /* @__PURE__ */ (0, n.dual)(3, function(T, O, L) {
      return m.flatMap(T, (0, t.liftNullable)(s)(O, L));
    });
  };
  t.flatMapNullable = J;
  var A = function(s, m) {
    return /* @__PURE__ */ (0, n.dual)(3, function(T, O, L) {
      return m.flatMap(T, (0, t.liftOption)(s)(O, L));
    });
  };
  t.flatMapOption = A;
  var b = function(s, m) {
    return /* @__PURE__ */ (0, n.dual)(2, function(T, O) {
      return m.flatMap(T, function(L) {
        return s.fromEither(O(L));
      });
    });
  };
  t.flatMapEither = b;
  var B = function(s, m) {
    return /* @__PURE__ */ (0, n.dual)(2, function(T, O) {
      return m.flatMap(T, function(L) {
        return s.fromIO(O(L));
      });
    });
  };
  t.flatMapIO = B;
  var x = function(s, m) {
    return /* @__PURE__ */ (0, n.dual)(2, function(T, O) {
      return m.flatMap(T, function(L) {
        return s.fromTask(O(L));
      });
    });
  };
  t.flatMapTask = x;
  var j = function(s, m) {
    return /* @__PURE__ */ (0, n.dual)(2, function(T, O) {
      return m.flatMap(T, function(L) {
        return s.fromReader(O(L));
      });
    });
  };
  t.flatMapReader = j;
})(zt);
var Fc = C && C.__createBinding || (Object.create ? function(t, e, n, r) {
  r === void 0 && (r = n);
  var a = Object.getOwnPropertyDescriptor(e, n);
  (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, a);
} : function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
}), $c = C && C.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), Lc = C && C.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null) for (var n in t) n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && Fc(e, t, n);
  return $c(e, t), e;
};
Object.defineProperty(St, "__esModule", { value: !0 });
St.ap = Dc;
St.apFirst = Kc;
St.apSecond = Zc;
St.apS = Vc;
St.getApplySemigroup = Bc;
St.sequenceT = Hc;
St.sequenceS = Gc;
var Wc = ft, qc = Lc(zt);
function Dc(t, e) {
  return function(n) {
    return function(r) {
      return t.ap(t.map(r, function(a) {
        return function(u) {
          return e.ap(a, u);
        };
      }), n);
    };
  };
}
function Kc(t) {
  return function(e) {
    return function(n) {
      return t.ap(t.map(n, function(r) {
        return function() {
          return r;
        };
      }), e);
    };
  };
}
function Zc(t) {
  return function(e) {
    return function(n) {
      return t.ap(t.map(n, function() {
        return function(r) {
          return r;
        };
      }), e);
    };
  };
}
function Vc(t) {
  return function(e, n) {
    return function(r) {
      return t.ap(t.map(r, function(a) {
        return function(u) {
          var o;
          return Object.assign({}, a, (o = {}, o[e] = u, o));
        };
      }), n);
    };
  };
}
function Bc(t) {
  return function(e) {
    return {
      concat: function(n, r) {
        return t.ap(t.map(n, function(a) {
          return function(u) {
            return e.concat(a, u);
          };
        }), r);
      }
    };
  };
}
function Yr(t, e, n) {
  return function(r) {
    for (var a = Array(n.length + 1), u = 0; u < n.length; u++)
      a[u] = n[u];
    return a[n.length] = r, e === 0 ? t.apply(null, a) : Yr(t, e - 1, a);
  };
}
var wr = {
  1: function(t) {
    return [t];
  },
  2: function(t) {
    return function(e) {
      return [t, e];
    };
  },
  3: function(t) {
    return function(e) {
      return function(n) {
        return [t, e, n];
      };
    };
  },
  4: function(t) {
    return function(e) {
      return function(n) {
        return function(r) {
          return [t, e, n, r];
        };
      };
    };
  },
  5: function(t) {
    return function(e) {
      return function(n) {
        return function(r) {
          return function(a) {
            return [t, e, n, r, a];
          };
        };
      };
    };
  }
};
function zc(t) {
  return qc.has.call(wr, t) || (wr[t] = Yr(Wc.tuple, t - 1, [])), wr[t];
}
function Hc(t) {
  return function() {
    for (var e = [], n = 0; n < arguments.length; n++)
      e[n] = arguments[n];
    for (var r = e.length, a = zc(r), u = t.map(e[0], a), o = 1; o < r; o++)
      u = t.ap(u, e[o]);
    return u;
  };
}
function Jc(t) {
  var e = t.length;
  switch (e) {
    case 1:
      return function(n) {
        var r;
        return r = {}, r[t[0]] = n, r;
      };
    case 2:
      return function(n) {
        return function(r) {
          var a;
          return a = {}, a[t[0]] = n, a[t[1]] = r, a;
        };
      };
    case 3:
      return function(n) {
        return function(r) {
          return function(a) {
            var u;
            return u = {}, u[t[0]] = n, u[t[1]] = r, u[t[2]] = a, u;
          };
        };
      };
    case 4:
      return function(n) {
        return function(r) {
          return function(a) {
            return function(u) {
              var o;
              return o = {}, o[t[0]] = n, o[t[1]] = r, o[t[2]] = a, o[t[3]] = u, o;
            };
          };
        };
      };
    case 5:
      return function(n) {
        return function(r) {
          return function(a) {
            return function(u) {
              return function(o) {
                var c;
                return c = {}, c[t[0]] = n, c[t[1]] = r, c[t[2]] = a, c[t[3]] = u, c[t[4]] = o, c;
              };
            };
          };
        };
      };
    default:
      return Yr(function() {
        for (var n = [], r = 0; r < arguments.length; r++)
          n[r] = arguments[r];
        for (var a = {}, u = 0; u < e; u++)
          a[t[u]] = n[u];
        return a;
      }, e - 1, []);
  }
}
function Gc(t) {
  return function(e) {
    for (var n = Object.keys(e), r = n.length, a = Jc(n), u = t.map(e[n[0]], a), o = 1; o < r; o++)
      u = t.ap(u, e[n[o]]);
    return u;
  };
}
var Ot = {};
Object.defineProperty(Ot, "__esModule", { value: !0 });
Ot.map = Gi;
Ot.flap = Qc;
Ot.bindTo = Xc;
Ot.let = xc;
Ot.getFunctorComposition = tl;
Ot.as = Yi;
Ot.asUnit = el;
var Yc = ft;
function Gi(t, e) {
  return function(n) {
    return function(r) {
      return t.map(r, function(a) {
        return e.map(a, n);
      });
    };
  };
}
function Qc(t) {
  return function(e) {
    return function(n) {
      return t.map(n, function(r) {
        return r(e);
      });
    };
  };
}
function Xc(t) {
  return function(e) {
    return function(n) {
      return t.map(n, function(r) {
        var a;
        return a = {}, a[e] = r, a;
      });
    };
  };
}
function xc(t) {
  return function(e, n) {
    return function(r) {
      return t.map(r, function(a) {
        var u;
        return Object.assign({}, a, (u = {}, u[e] = n(a), u));
      });
    };
  };
}
function tl(t, e) {
  var n = Gi(t, e);
  return {
    map: function(r, a) {
      return (0, Yc.pipe)(r, n(a));
    }
  };
}
function Yi(t) {
  return function(e, n) {
    return t.map(e, function() {
      return n;
    });
  };
}
function el(t) {
  var e = Yi(t);
  return function(n) {
    return e(n, void 0);
  };
}
Object.defineProperty(me, "__esModule", { value: !0 });
me.getApplicativeMonoid = al;
me.getApplicativeComposition = il;
var Qi = St, nl = ft, rl = Ot;
function al(t) {
  var e = (0, Qi.getApplySemigroup)(t);
  return function(n) {
    return {
      concat: e(n).concat,
      empty: t.of(n.empty)
    };
  };
}
function il(t, e) {
  var n = (0, rl.getFunctorComposition)(t, e).map, r = (0, Qi.ap)(t, e);
  return {
    map: n,
    of: function(a) {
      return t.of(e.of(a));
    },
    ap: function(a, u) {
      return (0, nl.pipe)(a, r(u));
    }
  };
}
var Ft = {};
Object.defineProperty(Ft, "__esModule", { value: !0 });
Ft.chainFirst = ul;
Ft.tap = Xi;
Ft.bind = ol;
function ul(t) {
  var e = Xi(t);
  return function(n) {
    return function(r) {
      return e(r, n);
    };
  };
}
function Xi(t) {
  return function(e, n) {
    return t.chain(e, function(r) {
      return t.map(n(r), function() {
        return r;
      });
    });
  };
}
function ol(t) {
  return function(e, n) {
    return function(r) {
      return t.chain(r, function(a) {
        return t.map(n(a), function(u) {
          var o;
          return Object.assign({}, a, (o = {}, o[e] = u, o));
        });
      });
    };
  };
}
var $e = {}, Qr = {}, jt = {}, cl = C && C.__createBinding || (Object.create ? function(t, e, n, r) {
  r === void 0 && (r = n);
  var a = Object.getOwnPropertyDescriptor(e, n);
  (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, a);
} : function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
}), ll = C && C.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), fl = C && C.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null) for (var n in t) n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && cl(e, t, n);
  return ll(e, t), e;
};
Object.defineProperty(jt, "__esModule", { value: !0 });
jt.fromOption = tu;
jt.fromPredicate = dl;
jt.fromOptionK = eu;
jt.chainOptionK = hl;
jt.fromEitherK = Xr;
jt.chainEitherK = ml;
jt.chainFirstEitherK = vl;
jt.filterOrElse = gl;
jt.tapEither = nu;
var sl = Ft, xi = ft, le = fl(zt);
function tu(t) {
  return function(e) {
    return function(n) {
      return t.fromEither(le.isNone(n) ? le.left(e()) : le.right(n.value));
    };
  };
}
function dl(t) {
  return function(e, n) {
    return function(r) {
      return t.fromEither(e(r) ? le.right(r) : le.left(n(r)));
    };
  };
}
function eu(t) {
  var e = tu(t);
  return function(n) {
    var r = e(n);
    return function(a) {
      return (0, xi.flow)(a, r);
    };
  };
}
function hl(t, e) {
  var n = eu(t);
  return function(r) {
    var a = n(r);
    return function(u) {
      return function(o) {
        return e.chain(o, a(u));
      };
    };
  };
}
function Xr(t) {
  return function(e) {
    return (0, xi.flow)(e, t.fromEither);
  };
}
function ml(t, e) {
  var n = Xr(t);
  return function(r) {
    return function(a) {
      return e.chain(a, n(r));
    };
  };
}
function vl(t, e) {
  var n = nu(t, e);
  return function(r) {
    return function(a) {
      return n(a, r);
    };
  };
}
function gl(t, e) {
  return function(n, r) {
    return function(a) {
      return e.chain(a, function(u) {
        return t.fromEither(n(u) ? le.right(u) : le.left(r(u)));
      });
    };
  };
}
function nu(t, e) {
  var n = Xr(t), r = (0, sl.tap)(e);
  return function(a, u) {
    return r(a, n(u));
  };
}
var xr = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.and = t.or = t.not = t.Contravariant = t.getMonoidAll = t.getSemigroupAll = t.getMonoidAny = t.getSemigroupAny = t.URI = t.contramap = void 0;
  var e = ft, n = function(p, E) {
    return (0, e.pipe)(p, (0, t.contramap)(E));
  }, r = function(p) {
    return function(E) {
      return (0, e.flow)(p, E);
    };
  };
  t.contramap = r, t.URI = "Predicate";
  var a = function() {
    return {
      concat: function(p, E) {
        return (0, e.pipe)(p, (0, t.or)(E));
      }
    };
  };
  t.getSemigroupAny = a;
  var u = function() {
    return {
      concat: (0, t.getSemigroupAny)().concat,
      empty: e.constFalse
    };
  };
  t.getMonoidAny = u;
  var o = function() {
    return {
      concat: function(p, E) {
        return (0, e.pipe)(p, (0, t.and)(E));
      }
    };
  };
  t.getSemigroupAll = o;
  var c = function() {
    return {
      concat: (0, t.getSemigroupAll)().concat,
      empty: e.constTrue
    };
  };
  t.getMonoidAll = c, t.Contravariant = {
    URI: t.URI,
    contramap: n
  };
  var f = function(p) {
    return function(E) {
      return !p(E);
    };
  };
  t.not = f;
  var l = function(p) {
    return function(E) {
      return function(R) {
        return E(R) || p(R);
      };
    };
  };
  t.or = l;
  var d = function(p) {
    return function(E) {
      return function(R) {
        return E(R) && p(R);
      };
    };
  };
  t.and = d;
})(xr);
var ru = {}, Pt = {};
Object.defineProperty(Pt, "__esModule", { value: !0 });
Pt.concatAll = Pt.endo = Pt.filterSecond = Pt.filterFirst = Pt.reverse = void 0;
var pl = function(t) {
  return {
    concat: function(e, n) {
      return t.concat(n, e);
    }
  };
};
Pt.reverse = pl;
var yl = function(t) {
  return function(e) {
    return {
      concat: function(n, r) {
        return t(n) ? e.concat(n, r) : r;
      }
    };
  };
};
Pt.filterFirst = yl;
var _l = function(t) {
  return function(e) {
    return {
      concat: function(n, r) {
        return t(r) ? e.concat(n, r) : n;
      }
    };
  };
};
Pt.filterSecond = _l;
var bl = function(t) {
  return function(e) {
    return {
      concat: function(n, r) {
        return e.concat(t(n), t(r));
      }
    };
  };
};
Pt.endo = bl;
var Ol = function(t) {
  return function(e) {
    return function(n) {
      return n.reduce(function(r, a) {
        return t.concat(r, a);
      }, e);
    };
  };
};
Pt.concatAll = Ol;
var au = {}, iu = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.eqDate = t.eqNumber = t.eqString = t.eqBoolean = t.eq = t.strictEqual = t.getStructEq = t.getTupleEq = t.Contravariant = t.getMonoid = t.getSemigroup = t.eqStrict = t.URI = t.contramap = t.tuple = t.struct = t.fromEquals = void 0;
  var e = ft, n = function(d) {
    return {
      equals: function(p, E) {
        return p === E || d(p, E);
      }
    };
  };
  t.fromEquals = n;
  var r = function(d) {
    return (0, t.fromEquals)(function(p, E) {
      for (var R in d)
        if (!d[R].equals(p[R], E[R]))
          return !1;
      return !0;
    });
  };
  t.struct = r;
  var a = function() {
    for (var d = [], p = 0; p < arguments.length; p++)
      d[p] = arguments[p];
    return (0, t.fromEquals)(function(E, R) {
      return d.every(function(U, q) {
        return U.equals(E[q], R[q]);
      });
    });
  };
  t.tuple = a;
  var u = function(d, p) {
    return (0, e.pipe)(d, (0, t.contramap)(p));
  }, o = function(d) {
    return function(p) {
      return (0, t.fromEquals)(function(E, R) {
        return p.equals(d(E), d(R));
      });
    };
  };
  t.contramap = o, t.URI = "Eq", t.eqStrict = {
    equals: function(d, p) {
      return d === p;
    }
  };
  var c = {
    equals: function() {
      return !0;
    }
  }, f = function() {
    return {
      concat: function(d, p) {
        return (0, t.fromEquals)(function(E, R) {
          return d.equals(E, R) && p.equals(E, R);
        });
      }
    };
  };
  t.getSemigroup = f;
  var l = function() {
    return {
      concat: (0, t.getSemigroup)().concat,
      empty: c
    };
  };
  t.getMonoid = l, t.Contravariant = {
    URI: t.URI,
    contramap: u
  }, t.getTupleEq = t.tuple, t.getStructEq = t.struct, t.strictEqual = t.eqStrict.equals, t.eq = t.Contravariant, t.eqBoolean = t.eqStrict, t.eqString = t.eqStrict, t.eqNumber = t.eqStrict, t.eqDate = {
    equals: function(d, p) {
      return d.valueOf() === p.valueOf();
    }
  };
})(iu);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.ordDate = t.ordNumber = t.ordString = t.ordBoolean = t.ord = t.getDualOrd = t.getTupleOrd = t.between = t.clamp = t.max = t.min = t.geq = t.leq = t.gt = t.lt = t.equals = t.trivial = t.Contravariant = t.getMonoid = t.getSemigroup = t.URI = t.contramap = t.reverse = t.tuple = t.fromCompare = t.equalsDefault = void 0;
  var e = iu, n = ft, r = function(j) {
    return function(s, m) {
      return s === m || j(s, m) === 0;
    };
  };
  t.equalsDefault = r;
  var a = function(j) {
    return {
      equals: (0, t.equalsDefault)(j),
      compare: function(s, m) {
        return s === m ? 0 : j(s, m);
      }
    };
  };
  t.fromCompare = a;
  var u = function() {
    for (var j = [], s = 0; s < arguments.length; s++)
      j[s] = arguments[s];
    return (0, t.fromCompare)(function(m, T) {
      for (var O = 0; O < j.length - 1; O++) {
        var L = j[O].compare(m[O], T[O]);
        if (L !== 0)
          return L;
      }
      return j[O].compare(m[O], T[O]);
    });
  };
  t.tuple = u;
  var o = function(j) {
    return (0, t.fromCompare)(function(s, m) {
      return j.compare(m, s);
    });
  };
  t.reverse = o;
  var c = function(j, s) {
    return (0, n.pipe)(j, (0, t.contramap)(s));
  }, f = function(j) {
    return function(s) {
      return (0, t.fromCompare)(function(m, T) {
        return s.compare(j(m), j(T));
      });
    };
  };
  t.contramap = f, t.URI = "Ord";
  var l = function() {
    return {
      concat: function(j, s) {
        return (0, t.fromCompare)(function(m, T) {
          var O = j.compare(m, T);
          return O !== 0 ? O : s.compare(m, T);
        });
      }
    };
  };
  t.getSemigroup = l;
  var d = function() {
    return {
      concat: (0, t.getSemigroup)().concat,
      empty: (0, t.fromCompare)(function() {
        return 0;
      })
    };
  };
  t.getMonoid = d, t.Contravariant = {
    URI: t.URI,
    contramap: c
  }, t.trivial = {
    equals: n.constTrue,
    compare: /* @__PURE__ */ (0, n.constant)(0)
  };
  var p = function(j) {
    return function(s) {
      return function(m) {
        return m === s || j.compare(m, s) === 0;
      };
    };
  };
  t.equals = p;
  var E = function(j) {
    return function(s, m) {
      return j.compare(s, m) === -1;
    };
  };
  t.lt = E;
  var R = function(j) {
    return function(s, m) {
      return j.compare(s, m) === 1;
    };
  };
  t.gt = R;
  var U = function(j) {
    return function(s, m) {
      return j.compare(s, m) !== 1;
    };
  };
  t.leq = U;
  var q = function(j) {
    return function(s, m) {
      return j.compare(s, m) !== -1;
    };
  };
  t.geq = q;
  var F = function(j) {
    return function(s, m) {
      return s === m || j.compare(s, m) < 1 ? s : m;
    };
  };
  t.min = F;
  var J = function(j) {
    return function(s, m) {
      return s === m || j.compare(s, m) > -1 ? s : m;
    };
  };
  t.max = J;
  var A = function(j) {
    var s = (0, t.min)(j), m = (0, t.max)(j);
    return function(T, O) {
      return function(L) {
        return m(s(L, O), T);
      };
    };
  };
  t.clamp = A;
  var b = function(j) {
    var s = (0, t.lt)(j), m = (0, t.gt)(j);
    return function(T, O) {
      return function(L) {
        return !(s(L, T) || m(L, O));
      };
    };
  };
  t.between = b, t.getTupleOrd = t.tuple, t.getDualOrd = t.reverse, t.ord = t.Contravariant;
  function B(j, s) {
    return j < s ? -1 : j > s ? 1 : 0;
  }
  var x = {
    equals: e.eqStrict.equals,
    compare: B
  };
  t.ordBoolean = x, t.ordString = x, t.ordNumber = x, t.ordDate = (0, n.pipe)(
    t.ordNumber,
    /* @__PURE__ */ (0, t.contramap)(function(j) {
      return j.valueOf();
    })
  );
})(au);
(function(t) {
  var e = C && C.__createBinding || (Object.create ? function(A, b, B, x) {
    x === void 0 && (x = B);
    var j = Object.getOwnPropertyDescriptor(b, B);
    (!j || ("get" in j ? !b.__esModule : j.writable || j.configurable)) && (j = { enumerable: !0, get: function() {
      return b[B];
    } }), Object.defineProperty(A, x, j);
  } : function(A, b, B, x) {
    x === void 0 && (x = B), A[x] = b[B];
  }), n = C && C.__setModuleDefault || (Object.create ? function(A, b) {
    Object.defineProperty(A, "default", { enumerable: !0, value: b });
  } : function(A, b) {
    A.default = b;
  }), r = C && C.__importStar || function(A) {
    if (A && A.__esModule) return A;
    var b = {};
    if (A != null) for (var B in A) B !== "default" && Object.prototype.hasOwnProperty.call(A, B) && e(b, A, B);
    return n(b, A), b;
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.semigroupProduct = t.semigroupSum = t.semigroupString = t.getFunctionSemigroup = t.semigroupAny = t.semigroupAll = t.getIntercalateSemigroup = t.getMeetSemigroup = t.getJoinSemigroup = t.getDualSemigroup = t.getStructSemigroup = t.getTupleSemigroup = t.getFirstSemigroup = t.getLastSemigroup = t.getObjectSemigroup = t.semigroupVoid = t.concatAll = t.last = t.first = t.intercalate = t.tuple = t.struct = t.reverse = t.constant = t.max = t.min = void 0, t.fold = J;
  var a = ft, u = r(zt), o = r(Pt), c = r(au), f = function(A) {
    return {
      concat: c.min(A)
    };
  };
  t.min = f;
  var l = function(A) {
    return {
      concat: c.max(A)
    };
  };
  t.max = l;
  var d = function(A) {
    return {
      concat: function() {
        return A;
      }
    };
  };
  t.constant = d, t.reverse = o.reverse;
  var p = function(A) {
    return {
      concat: function(b, B) {
        var x = {};
        for (var j in A)
          u.has.call(A, j) && (x[j] = A[j].concat(b[j], B[j]));
        return x;
      }
    };
  };
  t.struct = p;
  var E = function() {
    for (var A = [], b = 0; b < arguments.length; b++)
      A[b] = arguments[b];
    return {
      concat: function(B, x) {
        return A.map(function(j, s) {
          return j.concat(B[s], x[s]);
        });
      }
    };
  };
  t.tuple = E;
  var R = function(A) {
    return function(b) {
      return {
        concat: function(B, x) {
          return b.concat(B, b.concat(A, x));
        }
      };
    };
  };
  t.intercalate = R;
  var U = function() {
    return { concat: a.identity };
  };
  t.first = U;
  var q = function() {
    return { concat: function(A, b) {
      return b;
    } };
  };
  t.last = q, t.concatAll = o.concatAll, t.semigroupVoid = (0, t.constant)(void 0);
  var F = function() {
    return {
      concat: function(A, b) {
        return Object.assign({}, A, b);
      }
    };
  };
  t.getObjectSemigroup = F, t.getLastSemigroup = t.last, t.getFirstSemigroup = t.first, t.getTupleSemigroup = t.tuple, t.getStructSemigroup = t.struct, t.getDualSemigroup = t.reverse, t.getJoinSemigroup = t.max, t.getMeetSemigroup = t.min, t.getIntercalateSemigroup = t.intercalate;
  function J(A) {
    var b = (0, t.concatAll)(A);
    return function(B, x) {
      return x === void 0 ? b(B) : b(B)(x);
    };
  }
  t.semigroupAll = {
    concat: function(A, b) {
      return A && b;
    }
  }, t.semigroupAny = {
    concat: function(A, b) {
      return A || b;
    }
  }, t.getFunctionSemigroup = a.getSemigroup, t.semigroupString = {
    concat: function(A, b) {
      return A + b;
    }
  }, t.semigroupSum = {
    concat: function(A, b) {
      return A + b;
    }
  }, t.semigroupProduct = {
    concat: function(A, b) {
      return A * b;
    }
  };
})(ru);
var Pn = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.right = t.left = t.flap = t.Functor = t.Bifunctor = t.URI = t.bimap = t.mapLeft = t.map = t.separated = void 0;
  var e = ft, n = Ot, r = function(E, R) {
    return { left: E, right: R };
  };
  t.separated = r;
  var a = function(E, R) {
    return (0, e.pipe)(E, (0, t.map)(R));
  }, u = function(E, R) {
    return (0, e.pipe)(E, (0, t.mapLeft)(R));
  }, o = function(E, R, U) {
    return (0, e.pipe)(E, (0, t.bimap)(R, U));
  }, c = function(E) {
    return function(R) {
      return (0, t.separated)((0, t.left)(R), E((0, t.right)(R)));
    };
  };
  t.map = c;
  var f = function(E) {
    return function(R) {
      return (0, t.separated)(E((0, t.left)(R)), (0, t.right)(R));
    };
  };
  t.mapLeft = f;
  var l = function(E, R) {
    return function(U) {
      return (0, t.separated)(E((0, t.left)(U)), R((0, t.right)(U)));
    };
  };
  t.bimap = l, t.URI = "Separated", t.Bifunctor = {
    URI: t.URI,
    mapLeft: u,
    bimap: o
  }, t.Functor = {
    URI: t.URI,
    map: a
  }, t.flap = (0, n.flap)(t.Functor);
  var d = function(E) {
    return E.left;
  };
  t.left = d;
  var p = function(E) {
    return E.right;
  };
  t.right = p;
})(Pn);
var Le = {}, El = C && C.__createBinding || (Object.create ? function(t, e, n, r) {
  r === void 0 && (r = n);
  var a = Object.getOwnPropertyDescriptor(e, n);
  (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, a);
} : function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
}), Il = C && C.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), Al = C && C.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null) for (var n in t) n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && El(e, t, n);
  return Il(e, t), e;
};
Object.defineProperty(Le, "__esModule", { value: !0 });
Le.wiltDefault = wl;
Le.witherDefault = Tl;
Le.filterE = Ml;
var Da = Al(zt);
function wl(t, e) {
  return function(n) {
    var r = t.traverse(n);
    return function(a, u) {
      return n.map(r(a, u), e.separate);
    };
  };
}
function Tl(t, e) {
  return function(n) {
    var r = t.traverse(n);
    return function(a, u) {
      return n.map(r(a, u), e.compact);
    };
  };
}
function Ml(t) {
  return function(e) {
    var n = t.wither(e);
    return function(r) {
      return function(a) {
        return n(a, function(u) {
          return e.map(r(u), function(o) {
            return o ? Da.some(u) : Da.none;
          });
        });
      };
    };
  };
}
var ta = {};
Object.defineProperty(ta, "__esModule", { value: !0 });
ta.guard = Sl;
function Sl(t, e) {
  return function(n) {
    return n ? e.of(void 0) : t.zero();
  };
}
(function(t) {
  var e = C && C.__createBinding || (Object.create ? function(v, y, w, it) {
    it === void 0 && (it = w);
    var vt = Object.getOwnPropertyDescriptor(y, w);
    (!vt || ("get" in vt ? !y.__esModule : vt.writable || vt.configurable)) && (vt = { enumerable: !0, get: function() {
      return y[w];
    } }), Object.defineProperty(v, it, vt);
  } : function(v, y, w, it) {
    it === void 0 && (it = w), v[it] = y[w];
  }), n = C && C.__setModuleDefault || (Object.create ? function(v, y) {
    Object.defineProperty(v, "default", { enumerable: !0, value: y });
  } : function(v, y) {
    v.default = y;
  }), r = C && C.__importStar || function(v) {
    if (v && v.__esModule) return v;
    var y = {};
    if (v != null) for (var w in v) w !== "default" && Object.prototype.hasOwnProperty.call(v, w) && e(y, v, w);
    return n(y, v), y;
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.throwError = t.Witherable = t.wilt = t.wither = t.Traversable = t.sequence = t.traverse = t.Filterable = t.partitionMap = t.partition = t.filterMap = t.filter = t.Compactable = t.separate = t.compact = t.Extend = t.extend = t.Alternative = t.guard = t.Zero = t.zero = t.Alt = t.alt = t.altW = t.orElse = t.Foldable = t.reduceRight = t.foldMap = t.reduce = t.Monad = t.Chain = t.flatMap = t.Applicative = t.Apply = t.ap = t.Pointed = t.of = t.asUnit = t.as = t.Functor = t.map = t.getMonoid = t.getOrd = t.getEq = t.getShow = t.URI = t.getRight = t.getLeft = t.some = t.none = void 0, t.getLastMonoid = t.getFirstMonoid = t.getApplyMonoid = t.getApplySemigroup = t.option = t.mapNullable = t.chainFirst = t.chain = t.sequenceArray = t.traverseArray = t.traverseArrayWithIndex = t.traverseReadonlyArrayWithIndex = t.traverseReadonlyNonEmptyArrayWithIndex = t.ApT = t.apS = t.bind = t.let = t.bindTo = t.Do = t.exists = t.toUndefined = t.toNullable = t.chainNullableK = t.fromNullableK = t.tryCatchK = t.tryCatch = t.fromNullable = t.chainFirstEitherK = t.chainEitherK = t.fromEitherK = t.duplicate = t.tapEither = t.tap = t.flatten = t.apSecond = t.apFirst = t.flap = t.getOrElse = t.getOrElseW = t.fold = t.match = t.foldW = t.matchW = t.isNone = t.isSome = t.FromEither = t.fromEither = t.MonadThrow = void 0, t.fromPredicate = F, t.elem = Yt, t.getRefinement = _;
  var a = me, u = St, o = r(Ft), c = jt, f = ft, l = Ot, d = r(zt), p = xr, E = ru, R = Pn, U = Le, q = ta;
  t.none = d.none, t.some = d.some;
  function F(v) {
    return function(y) {
      return v(y) ? (0, t.some)(y) : t.none;
    };
  }
  var J = function(v) {
    return v._tag === "Right" ? t.none : (0, t.some)(v.left);
  };
  t.getLeft = J;
  var A = function(v) {
    return v._tag === "Left" ? t.none : (0, t.some)(v.right);
  };
  t.getRight = A;
  var b = function(v, y) {
    return (0, f.pipe)(v, (0, t.map)(y));
  }, B = function(v, y) {
    return (0, f.pipe)(v, (0, t.ap)(y));
  }, x = function(v, y, w) {
    return (0, f.pipe)(v, (0, t.reduce)(y, w));
  }, j = function(v) {
    var y = (0, t.foldMap)(v);
    return function(w, it) {
      return (0, f.pipe)(w, y(it));
    };
  }, s = function(v, y, w) {
    return (0, f.pipe)(v, (0, t.reduceRight)(y, w));
  }, m = function(v) {
    var y = (0, t.traverse)(v);
    return function(w, it) {
      return (0, f.pipe)(w, y(it));
    };
  }, T = function(v, y) {
    return (0, f.pipe)(v, (0, t.alt)(y));
  }, O = function(v, y) {
    return (0, f.pipe)(v, (0, t.filter)(y));
  }, L = function(v, y) {
    return (0, f.pipe)(v, (0, t.filterMap)(y));
  }, D = function(v, y) {
    return (0, f.pipe)(v, (0, t.extend)(y));
  }, ct = function(v, y) {
    return (0, f.pipe)(v, (0, t.partition)(y));
  }, $ = function(v, y) {
    return (0, f.pipe)(v, (0, t.partitionMap)(y));
  };
  t.URI = "Option";
  var K = function(v) {
    return {
      show: function(y) {
        return (0, t.isNone)(y) ? "none" : "some(".concat(v.show(y.value), ")");
      }
    };
  };
  t.getShow = K;
  var G = function(v) {
    return {
      equals: function(y, w) {
        return y === w || ((0, t.isNone)(y) ? (0, t.isNone)(w) : (0, t.isNone)(w) ? !1 : v.equals(y.value, w.value));
      }
    };
  };
  t.getEq = G;
  var lt = function(v) {
    return {
      equals: (0, t.getEq)(v).equals,
      compare: function(y, w) {
        return y === w ? 0 : (0, t.isSome)(y) ? (0, t.isSome)(w) ? v.compare(y.value, w.value) : 1 : -1;
      }
    };
  };
  t.getOrd = lt;
  var Et = function(v) {
    return {
      concat: function(y, w) {
        return (0, t.isNone)(y) ? w : (0, t.isNone)(w) ? y : (0, t.some)(v.concat(y.value, w.value));
      },
      empty: t.none
    };
  };
  t.getMonoid = Et;
  var Jt = function(v) {
    return function(y) {
      return (0, t.isNone)(y) ? t.none : (0, t.some)(v(y.value));
    };
  };
  t.map = Jt, t.Functor = {
    URI: t.URI,
    map: b
  }, t.as = (0, f.dual)(2, (0, l.as)(t.Functor)), t.asUnit = (0, l.asUnit)(t.Functor), t.of = t.some, t.Pointed = {
    URI: t.URI,
    of: t.of
  };
  var kt = function(v) {
    return function(y) {
      return (0, t.isNone)(y) || (0, t.isNone)(v) ? t.none : (0, t.some)(y.value(v.value));
    };
  };
  t.ap = kt, t.Apply = {
    URI: t.URI,
    map: b,
    ap: B
  }, t.Applicative = {
    URI: t.URI,
    map: b,
    ap: B,
    of: t.of
  }, t.flatMap = (0, f.dual)(2, function(v, y) {
    return (0, t.isNone)(v) ? t.none : y(v.value);
  }), t.Chain = {
    URI: t.URI,
    map: b,
    ap: B,
    chain: t.flatMap
  }, t.Monad = {
    URI: t.URI,
    map: b,
    ap: B,
    of: t.of,
    chain: t.flatMap
  };
  var Kt = function(v, y) {
    return function(w) {
      return (0, t.isNone)(w) ? v : y(v, w.value);
    };
  };
  t.reduce = Kt;
  var Qe = function(v) {
    return function(y) {
      return function(w) {
        return (0, t.isNone)(w) ? v.empty : y(w.value);
      };
    };
  };
  t.foldMap = Qe;
  var Xe = function(v, y) {
    return function(w) {
      return (0, t.isNone)(w) ? v : y(w.value, v);
    };
  };
  t.reduceRight = Xe, t.Foldable = {
    URI: t.URI,
    reduce: x,
    foldMap: j,
    reduceRight: s
  }, t.orElse = (0, f.dual)(2, function(v, y) {
    return (0, t.isNone)(v) ? y() : v;
  }), t.altW = t.orElse, t.alt = t.orElse, t.Alt = {
    URI: t.URI,
    map: b,
    alt: T
  };
  var xe = function() {
    return t.none;
  };
  t.zero = xe, t.Zero = {
    URI: t.URI,
    zero: t.zero
  }, t.guard = (0, q.guard)(t.Zero, t.Pointed), t.Alternative = {
    URI: t.URI,
    map: b,
    ap: B,
    of: t.of,
    alt: T,
    zero: t.zero
  };
  var tn = function(v) {
    return function(y) {
      return (0, t.isNone)(y) ? t.none : (0, t.some)(v(y));
    };
  };
  t.extend = tn, t.Extend = {
    URI: t.URI,
    map: b,
    extend: D
  }, t.compact = (0, t.flatMap)(f.identity);
  var en = /* @__PURE__ */ (0, R.separated)(t.none, t.none), nn = function(v) {
    return (0, t.isNone)(v) ? en : (0, R.separated)((0, t.getLeft)(v.value), (0, t.getRight)(v.value));
  };
  t.separate = nn, t.Compactable = {
    URI: t.URI,
    compact: t.compact,
    separate: t.separate
  };
  var rn = function(v) {
    return function(y) {
      return (0, t.isNone)(y) ? t.none : v(y.value) ? y : t.none;
    };
  };
  t.filter = rn;
  var an = function(v) {
    return function(y) {
      return (0, t.isNone)(y) ? t.none : v(y.value);
    };
  };
  t.filterMap = an;
  var Gt = function(v) {
    return function(y) {
      return (0, R.separated)(O(y, (0, p.not)(v)), O(y, v));
    };
  };
  t.partition = Gt;
  var Ie = function(v) {
    return (0, f.flow)((0, t.map)(v), t.separate);
  };
  t.partitionMap = Ie, t.Filterable = {
    URI: t.URI,
    map: b,
    compact: t.compact,
    separate: t.separate,
    filter: O,
    filterMap: L,
    partition: ct,
    partitionMap: $
  };
  var un = function(v) {
    return function(y) {
      return function(w) {
        return (0, t.isNone)(w) ? v.of(t.none) : v.map(y(w.value), t.some);
      };
    };
  };
  t.traverse = un;
  var on = function(v) {
    return function(y) {
      return (0, t.isNone)(y) ? v.of(t.none) : v.map(y.value, t.some);
    };
  };
  t.sequence = on, t.Traversable = {
    URI: t.URI,
    map: b,
    reduce: x,
    foldMap: j,
    reduceRight: s,
    traverse: m,
    sequence: t.sequence
  };
  var ie = /* @__PURE__ */ (0, U.witherDefault)(t.Traversable, t.Compactable), ue = /* @__PURE__ */ (0, U.wiltDefault)(t.Traversable, t.Compactable), M = function(v) {
    var y = ie(v);
    return function(w) {
      return function(it) {
        return y(it, w);
      };
    };
  };
  t.wither = M;
  var k = function(v) {
    var y = ue(v);
    return function(w) {
      return function(it) {
        return y(it, w);
      };
    };
  };
  t.wilt = k, t.Witherable = {
    URI: t.URI,
    map: b,
    reduce: x,
    foldMap: j,
    reduceRight: s,
    traverse: m,
    sequence: t.sequence,
    compact: t.compact,
    separate: t.separate,
    filter: O,
    filterMap: L,
    partition: ct,
    partitionMap: $,
    wither: ie,
    wilt: ue
  };
  var S = function() {
    return t.none;
  };
  t.throwError = S, t.MonadThrow = {
    URI: t.URI,
    map: b,
    ap: B,
    of: t.of,
    chain: t.flatMap,
    throwError: t.throwError
  }, t.fromEither = t.getRight, t.FromEither = {
    URI: t.URI,
    fromEither: t.fromEither
  }, t.isSome = d.isSome;
  var z = function(v) {
    return v._tag === "None";
  };
  t.isNone = z;
  var et = function(v, y) {
    return function(w) {
      return (0, t.isNone)(w) ? v() : y(w.value);
    };
  };
  t.matchW = et, t.foldW = t.matchW, t.match = t.matchW, t.fold = t.match;
  var H = function(v) {
    return function(y) {
      return (0, t.isNone)(y) ? v() : y.value;
    };
  };
  t.getOrElseW = H, t.getOrElse = t.getOrElseW, t.flap = (0, l.flap)(t.Functor), t.apFirst = (0, u.apFirst)(t.Apply), t.apSecond = (0, u.apSecond)(t.Apply), t.flatten = t.compact, t.tap = (0, f.dual)(2, o.tap(t.Chain)), t.tapEither = (0, f.dual)(2, (0, c.tapEither)(t.FromEither, t.Chain)), t.duplicate = (0, t.extend)(f.identity), t.fromEitherK = (0, c.fromEitherK)(t.FromEither), t.chainEitherK = /* @__PURE__ */ (0, c.chainEitherK)(t.FromEither, t.Chain), t.chainFirstEitherK = t.tapEither;
  var mt = function(v) {
    return v == null ? t.none : (0, t.some)(v);
  };
  t.fromNullable = mt;
  var _t = function(v) {
    try {
      return (0, t.some)(v());
    } catch {
      return t.none;
    }
  };
  t.tryCatch = _t;
  var At = function(v) {
    return function() {
      for (var y = [], w = 0; w < arguments.length; w++)
        y[w] = arguments[w];
      return (0, t.tryCatch)(function() {
        return v.apply(void 0, y);
      });
    };
  };
  t.tryCatchK = At;
  var tt = function(v) {
    return (0, f.flow)(v, t.fromNullable);
  };
  t.fromNullableK = tt;
  var wt = function(v) {
    return function(y) {
      return (0, t.isNone)(y) ? t.none : (0, t.fromNullable)(v(y.value));
    };
  };
  t.chainNullableK = wt, t.toNullable = (0, t.match)(f.constNull, f.identity), t.toUndefined = (0, t.match)(f.constUndefined, f.identity);
  function Yt(v) {
    return function(y, w) {
      if (w === void 0) {
        var it = Yt(v);
        return function(vt) {
          return it(y, vt);
        };
      }
      return (0, t.isNone)(w) ? !1 : v.equals(y, w.value);
    };
  }
  var Er = function(v) {
    return function(y) {
      return (0, t.isNone)(y) ? !1 : v(y.value);
    };
  };
  t.exists = Er, t.Do = (0, t.of)(d.emptyRecord), t.bindTo = (0, l.bindTo)(t.Functor);
  var Ir = /* @__PURE__ */ (0, l.let)(t.Functor);
  t.let = Ir, t.bind = o.bind(t.Chain), t.apS = (0, u.apS)(t.Apply), t.ApT = (0, t.of)(d.emptyReadonlyArray);
  var Ar = function(v) {
    return function(y) {
      var w = v(0, d.head(y));
      if ((0, t.isNone)(w))
        return t.none;
      for (var it = [w.value], vt = 1; vt < y.length; vt++) {
        var qa = v(vt, y[vt]);
        if ((0, t.isNone)(qa))
          return t.none;
        it.push(qa.value);
      }
      return (0, t.some)(it);
    };
  };
  t.traverseReadonlyNonEmptyArrayWithIndex = Ar;
  var g = function(v) {
    var y = (0, t.traverseReadonlyNonEmptyArrayWithIndex)(v);
    return function(w) {
      return d.isNonEmpty(w) ? y(w) : t.ApT;
    };
  };
  t.traverseReadonlyArrayWithIndex = g, t.traverseArrayWithIndex = t.traverseReadonlyArrayWithIndex;
  var h = function(v) {
    return (0, t.traverseReadonlyArrayWithIndex)(function(y, w) {
      return v(w);
    });
  };
  t.traverseArray = h, t.sequenceArray = /* @__PURE__ */ (0, t.traverseArray)(f.identity), t.chain = t.flatMap, t.chainFirst = t.tap;
  function _(v) {
    return function(y) {
      return (0, t.isSome)(v(y));
    };
  }
  t.mapNullable = t.chainNullableK, t.option = {
    URI: t.URI,
    map: b,
    of: t.of,
    ap: B,
    chain: t.flatMap,
    reduce: x,
    foldMap: j,
    reduceRight: s,
    traverse: m,
    sequence: t.sequence,
    zero: t.zero,
    alt: T,
    extend: D,
    compact: t.compact,
    separate: t.separate,
    filter: O,
    filterMap: L,
    partition: ct,
    partitionMap: $,
    wither: ie,
    wilt: ue,
    throwError: t.throwError
  }, t.getApplySemigroup = (0, u.getApplySemigroup)(t.Apply), t.getApplyMonoid = (0, a.getApplicativeMonoid)(t.Applicative);
  var nt = function() {
    return (0, t.getMonoid)((0, E.first)());
  };
  t.getFirstMonoid = nt;
  var bt = function() {
    return (0, t.getMonoid)((0, E.last)());
  };
  t.getLastMonoid = bt;
})(Qr);
var Rl = C && C.__createBinding || (Object.create ? function(t, e, n, r) {
  r === void 0 && (r = n);
  var a = Object.getOwnPropertyDescriptor(e, n);
  (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, a);
} : function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
}), jl = C && C.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), Pl = C && C.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null) for (var n in t) n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && Rl(e, t, n);
  return jl(e, t), e;
};
Object.defineProperty($e, "__esModule", { value: !0 });
$e.compact = ea;
$e.separate = ou;
$e.getCompactableComposition = Nl;
var Ka = ft, uu = Ot, Za = Qr, kl = Pl(Pn);
function ea(t, e) {
  return function(n) {
    return t.map(n, e.compact);
  };
}
function ou(t, e, n) {
  var r = ea(t, e), a = (0, uu.map)(t, n);
  return function(u) {
    return kl.separated(r((0, Ka.pipe)(u, a(Za.getLeft))), r((0, Ka.pipe)(u, a(Za.getRight))));
  };
}
function Nl(t, e) {
  var n = (0, uu.getFunctorComposition)(t, e).map;
  return {
    map: n,
    compact: ea(t, e),
    separate: ou(t, e, e)
  };
}
var na = {}, ur = {};
Object.defineProperty(ur, "__esModule", { value: !0 });
ur.tailRec = void 0;
var Ul = function(t, e) {
  for (var n = e(t); n._tag === "Left"; )
    n = e(n.left);
  return n.right;
};
ur.tailRec = Ul;
(function(t) {
  var e = C && C.__createBinding || (Object.create ? function(g, h, _, nt) {
    nt === void 0 && (nt = _);
    var bt = Object.getOwnPropertyDescriptor(h, _);
    (!bt || ("get" in bt ? !h.__esModule : bt.writable || bt.configurable)) && (bt = { enumerable: !0, get: function() {
      return h[_];
    } }), Object.defineProperty(g, nt, bt);
  } : function(g, h, _, nt) {
    nt === void 0 && (nt = _), g[nt] = h[_];
  }), n = C && C.__setModuleDefault || (Object.create ? function(g, h) {
    Object.defineProperty(g, "default", { enumerable: !0, value: h });
  } : function(g, h) {
    g.default = h;
  }), r = C && C.__importStar || function(g) {
    if (g && g.__esModule) return g;
    var h = {};
    if (g != null) for (var _ in g) _ !== "default" && Object.prototype.hasOwnProperty.call(g, _) && e(h, g, _);
    return n(h, g), h;
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.match = t.foldW = t.matchW = t.isRight = t.isLeft = t.fromOption = t.fromPredicate = t.FromEither = t.MonadThrow = t.throwError = t.ChainRec = t.Extend = t.extend = t.Alt = t.alt = t.altW = t.Bifunctor = t.mapLeft = t.bimap = t.Traversable = t.sequence = t.traverse = t.Foldable = t.reduceRight = t.foldMap = t.reduce = t.Monad = t.Chain = t.Applicative = t.Apply = t.ap = t.apW = t.Pointed = t.of = t.asUnit = t.as = t.Functor = t.map = t.getAltValidation = t.getApplicativeValidation = t.getWitherable = t.getFilterable = t.getCompactable = t.getSemigroup = t.getEq = t.getShow = t.URI = t.flatMap = t.right = t.left = void 0, t.either = t.stringifyJSON = t.chainFirstW = t.chainFirst = t.chain = t.chainW = t.sequenceArray = t.traverseArray = t.traverseArrayWithIndex = t.traverseReadonlyArrayWithIndex = t.traverseReadonlyNonEmptyArrayWithIndex = t.ApT = t.apSW = t.apS = t.bindW = t.bind = t.let = t.bindTo = t.Do = t.exists = t.toUnion = t.chainNullableK = t.fromNullableK = t.tryCatchK = t.tryCatch = t.fromNullable = t.orElse = t.orElseW = t.swap = t.filterOrElseW = t.filterOrElse = t.flatMapOption = t.flatMapNullable = t.liftOption = t.liftNullable = t.chainOptionKW = t.chainOptionK = t.fromOptionK = t.duplicate = t.flatten = t.flattenW = t.tap = t.apSecondW = t.apSecond = t.apFirstW = t.apFirst = t.flap = t.getOrElse = t.getOrElseW = t.fold = void 0, t.getValidationMonoid = t.getValidationSemigroup = t.getApplyMonoid = t.getApplySemigroup = void 0, t.toError = z, t.elem = et, t.parseJSON = wt, t.getValidation = Ar;
  var a = me, u = St, o = r(Ft), c = ur, f = jt, l = ft, d = Ot, p = r(zt), E = Pn, R = Le;
  t.left = p.left, t.right = p.right, t.flatMap = (0, l.dual)(2, function(g, h) {
    return (0, t.isLeft)(g) ? g : h(g.right);
  });
  var U = function(g, h) {
    return (0, l.pipe)(g, (0, t.map)(h));
  }, q = function(g, h) {
    return (0, l.pipe)(g, (0, t.ap)(h));
  }, F = function(g, h, _) {
    return (0, l.pipe)(g, (0, t.reduce)(h, _));
  }, J = function(g) {
    return function(h, _) {
      var nt = (0, t.foldMap)(g);
      return (0, l.pipe)(h, nt(_));
    };
  }, A = function(g, h, _) {
    return (0, l.pipe)(g, (0, t.reduceRight)(h, _));
  }, b = function(g) {
    var h = (0, t.traverse)(g);
    return function(_, nt) {
      return (0, l.pipe)(_, h(nt));
    };
  }, B = function(g, h, _) {
    return (0, l.pipe)(g, (0, t.bimap)(h, _));
  }, x = function(g, h) {
    return (0, l.pipe)(g, (0, t.mapLeft)(h));
  }, j = function(g, h) {
    return (0, l.pipe)(g, (0, t.alt)(h));
  }, s = function(g, h) {
    return (0, l.pipe)(g, (0, t.extend)(h));
  }, m = function(g, h) {
    return (0, c.tailRec)(h(g), function(_) {
      return (0, t.isLeft)(_) ? (0, t.right)((0, t.left)(_.left)) : (0, t.isLeft)(_.right) ? (0, t.left)(h(_.right.left)) : (0, t.right)((0, t.right)(_.right.right));
    });
  };
  t.URI = "Either";
  var T = function(g, h) {
    return {
      show: function(_) {
        return (0, t.isLeft)(_) ? "left(".concat(g.show(_.left), ")") : "right(".concat(h.show(_.right), ")");
      }
    };
  };
  t.getShow = T;
  var O = function(g, h) {
    return {
      equals: function(_, nt) {
        return _ === nt || ((0, t.isLeft)(_) ? (0, t.isLeft)(nt) && g.equals(_.left, nt.left) : (0, t.isRight)(nt) && h.equals(_.right, nt.right));
      }
    };
  };
  t.getEq = O;
  var L = function(g) {
    return {
      concat: function(h, _) {
        return (0, t.isLeft)(_) ? h : (0, t.isLeft)(h) ? _ : (0, t.right)(g.concat(h.right, _.right));
      }
    };
  };
  t.getSemigroup = L;
  var D = function(g) {
    var h = (0, t.left)(g.empty);
    return {
      URI: t.URI,
      _E: void 0,
      compact: function(_) {
        return (0, t.isLeft)(_) ? _ : _.right._tag === "None" ? h : (0, t.right)(_.right.value);
      },
      separate: function(_) {
        return (0, t.isLeft)(_) ? (0, E.separated)(_, _) : (0, t.isLeft)(_.right) ? (0, E.separated)((0, t.right)(_.right.left), h) : (0, E.separated)(h, (0, t.right)(_.right.right));
      }
    };
  };
  t.getCompactable = D;
  var ct = function(g) {
    var h = (0, t.left)(g.empty), _ = (0, t.getCompactable)(g), nt = _.compact, bt = _.separate, v = function(w, it) {
      return (0, t.isLeft)(w) || it(w.right) ? w : h;
    }, y = function(w, it) {
      return (0, t.isLeft)(w) ? (0, E.separated)(w, w) : it(w.right) ? (0, E.separated)(h, (0, t.right)(w.right)) : (0, E.separated)((0, t.right)(w.right), h);
    };
    return {
      URI: t.URI,
      _E: void 0,
      map: U,
      compact: nt,
      separate: bt,
      filter: v,
      filterMap: function(w, it) {
        if ((0, t.isLeft)(w))
          return w;
        var vt = it(w.right);
        return vt._tag === "None" ? h : (0, t.right)(vt.value);
      },
      partition: y,
      partitionMap: function(w, it) {
        if ((0, t.isLeft)(w))
          return (0, E.separated)(w, w);
        var vt = it(w.right);
        return (0, t.isLeft)(vt) ? (0, E.separated)((0, t.right)(vt.left), h) : (0, E.separated)(h, (0, t.right)(vt.right));
      }
    };
  };
  t.getFilterable = ct;
  var $ = function(g) {
    var h = (0, t.getFilterable)(g), _ = (0, t.getCompactable)(g);
    return {
      URI: t.URI,
      _E: void 0,
      map: U,
      compact: h.compact,
      separate: h.separate,
      filter: h.filter,
      filterMap: h.filterMap,
      partition: h.partition,
      partitionMap: h.partitionMap,
      traverse: b,
      sequence: t.sequence,
      reduce: F,
      foldMap: J,
      reduceRight: A,
      wither: (0, R.witherDefault)(t.Traversable, _),
      wilt: (0, R.wiltDefault)(t.Traversable, _)
    };
  };
  t.getWitherable = $;
  var K = function(g) {
    return {
      URI: t.URI,
      _E: void 0,
      map: U,
      ap: function(h, _) {
        return (0, t.isLeft)(h) ? (0, t.isLeft)(_) ? (0, t.left)(g.concat(h.left, _.left)) : h : (0, t.isLeft)(_) ? _ : (0, t.right)(h.right(_.right));
      },
      of: t.of
    };
  };
  t.getApplicativeValidation = K;
  var G = function(g) {
    return {
      URI: t.URI,
      _E: void 0,
      map: U,
      alt: function(h, _) {
        if ((0, t.isRight)(h))
          return h;
        var nt = _();
        return (0, t.isLeft)(nt) ? (0, t.left)(g.concat(h.left, nt.left)) : nt;
      }
    };
  };
  t.getAltValidation = G;
  var lt = function(g) {
    return function(h) {
      return (0, t.isLeft)(h) ? h : (0, t.right)(g(h.right));
    };
  };
  t.map = lt, t.Functor = {
    URI: t.URI,
    map: U
  }, t.as = (0, l.dual)(2, (0, d.as)(t.Functor)), t.asUnit = (0, d.asUnit)(t.Functor), t.of = t.right, t.Pointed = {
    URI: t.URI,
    of: t.of
  };
  var Et = function(g) {
    return function(h) {
      return (0, t.isLeft)(h) ? h : (0, t.isLeft)(g) ? g : (0, t.right)(h.right(g.right));
    };
  };
  t.apW = Et, t.ap = t.apW, t.Apply = {
    URI: t.URI,
    map: U,
    ap: q
  }, t.Applicative = {
    URI: t.URI,
    map: U,
    ap: q,
    of: t.of
  }, t.Chain = {
    URI: t.URI,
    map: U,
    ap: q,
    chain: t.flatMap
  }, t.Monad = {
    URI: t.URI,
    map: U,
    ap: q,
    of: t.of,
    chain: t.flatMap
  };
  var Jt = function(g, h) {
    return function(_) {
      return (0, t.isLeft)(_) ? g : h(g, _.right);
    };
  };
  t.reduce = Jt;
  var kt = function(g) {
    return function(h) {
      return function(_) {
        return (0, t.isLeft)(_) ? g.empty : h(_.right);
      };
    };
  };
  t.foldMap = kt;
  var Kt = function(g, h) {
    return function(_) {
      return (0, t.isLeft)(_) ? g : h(_.right, g);
    };
  };
  t.reduceRight = Kt, t.Foldable = {
    URI: t.URI,
    reduce: F,
    foldMap: J,
    reduceRight: A
  };
  var Qe = function(g) {
    return function(h) {
      return function(_) {
        return (0, t.isLeft)(_) ? g.of((0, t.left)(_.left)) : g.map(h(_.right), t.right);
      };
    };
  };
  t.traverse = Qe;
  var Xe = function(g) {
    return function(h) {
      return (0, t.isLeft)(h) ? g.of((0, t.left)(h.left)) : g.map(h.right, t.right);
    };
  };
  t.sequence = Xe, t.Traversable = {
    URI: t.URI,
    map: U,
    reduce: F,
    foldMap: J,
    reduceRight: A,
    traverse: b,
    sequence: t.sequence
  };
  var xe = function(g, h) {
    return function(_) {
      return (0, t.isLeft)(_) ? (0, t.left)(g(_.left)) : (0, t.right)(h(_.right));
    };
  };
  t.bimap = xe;
  var tn = function(g) {
    return function(h) {
      return (0, t.isLeft)(h) ? (0, t.left)(g(h.left)) : h;
    };
  };
  t.mapLeft = tn, t.Bifunctor = {
    URI: t.URI,
    bimap: B,
    mapLeft: x
  };
  var en = function(g) {
    return function(h) {
      return (0, t.isLeft)(h) ? g() : h;
    };
  };
  t.altW = en, t.alt = t.altW, t.Alt = {
    URI: t.URI,
    map: U,
    alt: j
  };
  var nn = function(g) {
    return function(h) {
      return (0, t.isLeft)(h) ? h : (0, t.right)(g(h));
    };
  };
  t.extend = nn, t.Extend = {
    URI: t.URI,
    map: U,
    extend: s
  }, t.ChainRec = {
    URI: t.URI,
    map: U,
    ap: q,
    chain: t.flatMap,
    chainRec: m
  }, t.throwError = t.left, t.MonadThrow = {
    URI: t.URI,
    map: U,
    ap: q,
    of: t.of,
    chain: t.flatMap,
    throwError: t.throwError
  }, t.FromEither = {
    URI: t.URI,
    fromEither: l.identity
  }, t.fromPredicate = (0, f.fromPredicate)(t.FromEither), t.fromOption = /* @__PURE__ */ (0, f.fromOption)(t.FromEither), t.isLeft = p.isLeft, t.isRight = p.isRight;
  var rn = function(g, h) {
    return function(_) {
      return (0, t.isLeft)(_) ? g(_.left) : h(_.right);
    };
  };
  t.matchW = rn, t.foldW = t.matchW, t.match = t.matchW, t.fold = t.match;
  var an = function(g) {
    return function(h) {
      return (0, t.isLeft)(h) ? g(h.left) : h.right;
    };
  };
  t.getOrElseW = an, t.getOrElse = t.getOrElseW, t.flap = (0, d.flap)(t.Functor), t.apFirst = (0, u.apFirst)(t.Apply), t.apFirstW = t.apFirst, t.apSecond = (0, u.apSecond)(t.Apply), t.apSecondW = t.apSecond, t.tap = (0, l.dual)(2, o.tap(t.Chain)), t.flattenW = /* @__PURE__ */ (0, t.flatMap)(l.identity), t.flatten = t.flattenW, t.duplicate = (0, t.extend)(l.identity), t.fromOptionK = /* @__PURE__ */ (0, f.fromOptionK)(t.FromEither), t.chainOptionK = (0, f.chainOptionK)(t.FromEither, t.Chain), t.chainOptionKW = t.chainOptionK;
  var Gt = {
    fromEither: t.FromEither.fromEither
  };
  t.liftNullable = p.liftNullable(Gt), t.liftOption = p.liftOption(Gt);
  var Ie = {
    flatMap: t.flatMap
  };
  t.flatMapNullable = p.flatMapNullable(Gt, Ie), t.flatMapOption = p.flatMapOption(Gt, Ie), t.filterOrElse = (0, f.filterOrElse)(t.FromEither, t.Chain), t.filterOrElseW = t.filterOrElse;
  var un = function(g) {
    return (0, t.isLeft)(g) ? (0, t.right)(g.left) : (0, t.left)(g.right);
  };
  t.swap = un;
  var on = function(g) {
    return function(h) {
      return (0, t.isLeft)(h) ? g(h.left) : h;
    };
  };
  t.orElseW = on, t.orElse = t.orElseW;
  var ie = function(g) {
    return function(h) {
      return h == null ? (0, t.left)(g) : (0, t.right)(h);
    };
  };
  t.fromNullable = ie;
  var ue = function(g, h) {
    try {
      return (0, t.right)(g());
    } catch (_) {
      return (0, t.left)(h(_));
    }
  };
  t.tryCatch = ue;
  var M = function(g, h) {
    return function() {
      for (var _ = [], nt = 0; nt < arguments.length; nt++)
        _[nt] = arguments[nt];
      return (0, t.tryCatch)(function() {
        return g.apply(void 0, _);
      }, h);
    };
  };
  t.tryCatchK = M;
  var k = function(g) {
    var h = (0, t.fromNullable)(g);
    return function(_) {
      return (0, l.flow)(_, h);
    };
  };
  t.fromNullableK = k;
  var S = function(g) {
    var h = (0, t.fromNullableK)(g);
    return function(_) {
      return (0, t.flatMap)(h(_));
    };
  };
  t.chainNullableK = S, t.toUnion = (0, t.foldW)(l.identity, l.identity);
  function z(g) {
    try {
      return g instanceof Error ? g : new Error(String(g));
    } catch {
      return new Error();
    }
  }
  function et(g) {
    return function(h, _) {
      if (_ === void 0) {
        var nt = et(g);
        return function(bt) {
          return nt(h, bt);
        };
      }
      return (0, t.isLeft)(_) ? !1 : g.equals(h, _.right);
    };
  }
  var H = function(g) {
    return function(h) {
      return (0, t.isLeft)(h) ? !1 : g(h.right);
    };
  };
  t.exists = H, t.Do = (0, t.of)(p.emptyRecord), t.bindTo = (0, d.bindTo)(t.Functor);
  var mt = /* @__PURE__ */ (0, d.let)(t.Functor);
  t.let = mt, t.bind = o.bind(t.Chain), t.bindW = t.bind, t.apS = (0, u.apS)(t.Apply), t.apSW = t.apS, t.ApT = (0, t.of)(p.emptyReadonlyArray);
  var _t = function(g) {
    return function(h) {
      var _ = g(0, p.head(h));
      if ((0, t.isLeft)(_))
        return _;
      for (var nt = [_.right], bt = 1; bt < h.length; bt++) {
        var v = g(bt, h[bt]);
        if ((0, t.isLeft)(v))
          return v;
        nt.push(v.right);
      }
      return (0, t.right)(nt);
    };
  };
  t.traverseReadonlyNonEmptyArrayWithIndex = _t;
  var At = function(g) {
    var h = (0, t.traverseReadonlyNonEmptyArrayWithIndex)(g);
    return function(_) {
      return p.isNonEmpty(_) ? h(_) : t.ApT;
    };
  };
  t.traverseReadonlyArrayWithIndex = At, t.traverseArrayWithIndex = t.traverseReadonlyArrayWithIndex;
  var tt = function(g) {
    return (0, t.traverseReadonlyArrayWithIndex)(function(h, _) {
      return g(_);
    });
  };
  t.traverseArray = tt, t.sequenceArray = /* @__PURE__ */ (0, t.traverseArray)(l.identity), t.chainW = t.flatMap, t.chain = t.flatMap, t.chainFirst = t.tap, t.chainFirstW = t.tap;
  function wt(g, h) {
    return (0, t.tryCatch)(function() {
      return JSON.parse(g);
    }, h);
  }
  var Yt = function(g, h) {
    return (0, t.tryCatch)(function() {
      var _ = JSON.stringify(g);
      if (typeof _ != "string")
        throw new Error("Converting unsupported structure to JSON");
      return _;
    }, h);
  };
  t.stringifyJSON = Yt, t.either = {
    URI: t.URI,
    map: U,
    of: t.of,
    ap: q,
    chain: t.flatMap,
    reduce: F,
    foldMap: J,
    reduceRight: A,
    traverse: b,
    sequence: t.sequence,
    bimap: B,
    mapLeft: x,
    alt: j,
    extend: s,
    chainRec: m,
    throwError: t.throwError
  }, t.getApplySemigroup = /* @__PURE__ */ (0, u.getApplySemigroup)(t.Apply), t.getApplyMonoid = /* @__PURE__ */ (0, a.getApplicativeMonoid)(t.Applicative);
  var Er = function(g, h) {
    return (0, u.getApplySemigroup)((0, t.getApplicativeValidation)(g))(h);
  };
  t.getValidationSemigroup = Er;
  var Ir = function(g, h) {
    return (0, a.getApplicativeMonoid)((0, t.getApplicativeValidation)(g))(h);
  };
  t.getValidationMonoid = Ir;
  function Ar(g) {
    var h = (0, t.getApplicativeValidation)(g).ap, _ = (0, t.getAltValidation)(g).alt;
    return {
      URI: t.URI,
      _E: void 0,
      map: U,
      of: t.of,
      chain: t.flatMap,
      bimap: B,
      mapLeft: x,
      reduce: F,
      foldMap: J,
      reduceRight: A,
      extend: s,
      traverse: b,
      sequence: t.sequence,
      chainRec: m,
      throwError: t.throwError,
      ap: h,
      alt: _
    };
  }
})(na);
var at = {}, Cl = C && C.__createBinding || (Object.create ? function(t, e, n, r) {
  r === void 0 && (r = n);
  var a = Object.getOwnPropertyDescriptor(e, n);
  (!a || ("get" in a ? !e.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return e[n];
  } }), Object.defineProperty(t, r, a);
} : function(t, e, n, r) {
  r === void 0 && (r = n), t[r] = e[n];
}), Fl = C && C.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), $l = C && C.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (t != null) for (var n in t) n !== "default" && Object.prototype.hasOwnProperty.call(t, n) && Cl(e, t, n);
  return Fl(e, t), e;
};
Object.defineProperty(at, "__esModule", { value: !0 });
at.right = ra;
at.left = cu;
at.rightF = lu;
at.leftF = fu;
at.fromNullable = su;
at.fromNullableK = du;
at.chainNullableK = ql;
at.map = hu;
at.ap = mu;
at.chain = aa;
at.flatMap = vu;
at.alt = gu;
at.bimap = pu;
at.mapBoth = yu;
at.mapLeft = _u;
at.mapError = bu;
at.altValidation = Dl;
at.match = Kl;
at.matchE = Ou;
at.getOrElse = Eu;
at.orElse = ia;
at.orElseFirst = Zl;
at.tapError = Iu;
at.orLeft = Vl;
at.swap = Au;
at.toUnion = Bl;
at.getEitherM = zl;
var Ll = St, st = $l(na), Mt = ft, Wl = Ot;
function ra(t) {
  return (0, Mt.flow)(st.right, t.of);
}
function cu(t) {
  return (0, Mt.flow)(st.left, t.of);
}
function lu(t) {
  return function(e) {
    return t.map(e, st.right);
  };
}
function fu(t) {
  return function(e) {
    return t.map(e, st.left);
  };
}
function su(t) {
  return function(e) {
    return (0, Mt.flow)(st.fromNullable(e), t.of);
  };
}
function du(t) {
  var e = su(t);
  return function(n) {
    var r = e(n);
    return function(a) {
      return (0, Mt.flow)(a, r);
    };
  };
}
function ql(t) {
  var e = aa(t), n = du(t);
  return function(r) {
    var a = n(r);
    return function(u) {
      return e(a(u));
    };
  };
}
function hu(t) {
  return (0, Wl.map)(t, st.Functor);
}
function mu(t) {
  return (0, Ll.ap)(t, st.Apply);
}
function aa(t) {
  var e = vu(t);
  return function(n) {
    return function(r) {
      return e(r, n);
    };
  };
}
function vu(t) {
  return function(e, n) {
    return t.chain(e, function(r) {
      return st.isLeft(r) ? t.of(r) : n(r.right);
    });
  };
}
function gu(t) {
  return function(e) {
    return function(n) {
      return t.chain(n, function(r) {
        return st.isLeft(r) ? e() : t.of(r);
      });
    };
  };
}
function pu(t) {
  var e = yu(t);
  return function(n, r) {
    return function(a) {
      return e(a, n, r);
    };
  };
}
function yu(t) {
  return function(e, n, r) {
    return t.map(e, st.bimap(n, r));
  };
}
function _u(t) {
  var e = bu(t);
  return function(n) {
    return function(r) {
      return e(r, n);
    };
  };
}
function bu(t) {
  return function(e, n) {
    return t.map(e, st.mapLeft(n));
  };
}
function Dl(t, e) {
  return function(n) {
    return function(r) {
      return t.chain(r, st.match(function(a) {
        return t.map(n(), st.mapLeft(function(u) {
          return e.concat(a, u);
        }));
      }, ra(t)));
    };
  };
}
function Kl(t) {
  return function(e, n) {
    return function(r) {
      return t.map(r, st.match(e, n));
    };
  };
}
function Ou(t) {
  return function(e, n) {
    return function(r) {
      return t.chain(r, st.match(e, n));
    };
  };
}
function Eu(t) {
  return function(e) {
    return function(n) {
      return t.chain(n, st.match(e, t.of));
    };
  };
}
function ia(t) {
  return function(e) {
    return function(n) {
      return t.chain(n, function(r) {
        return st.isLeft(r) ? e(r.left) : t.of(r);
      });
    };
  };
}
function Zl(t) {
  var e = Iu(t);
  return function(n) {
    return function(r) {
      return e(r, n);
    };
  };
}
function Iu(t) {
  var e = ia(t);
  return function(n, r) {
    return (0, Mt.pipe)(n, e(function(a) {
      return t.map(r(a), function(u) {
        return st.isLeft(u) ? u : st.left(a);
      });
    }));
  };
}
function Vl(t) {
  return function(e) {
    return function(n) {
      return t.chain(n, st.match(function(r) {
        return t.map(e(r), st.left);
      }, function(r) {
        return t.of(st.right(r));
      }));
    };
  };
}
function Au(t) {
  return function(e) {
    return t.map(e, st.swap);
  };
}
function Bl(t) {
  return function(e) {
    return t.map(e, st.toUnion);
  };
}
function zl(t) {
  var e = mu(t), n = hu(t), r = aa(t), a = gu(t), u = pu(t), o = _u(t), c = Ou(t), f = Eu(t), l = ia(t);
  return {
    map: function(d, p) {
      return (0, Mt.pipe)(d, n(p));
    },
    ap: function(d, p) {
      return (0, Mt.pipe)(d, e(p));
    },
    of: ra(t),
    chain: function(d, p) {
      return (0, Mt.pipe)(d, r(p));
    },
    alt: function(d, p) {
      return (0, Mt.pipe)(d, a(p));
    },
    bimap: function(d, p, E) {
      return (0, Mt.pipe)(d, u(p, E));
    },
    mapLeft: function(d, p) {
      return (0, Mt.pipe)(d, o(p));
    },
    fold: function(d, p, E) {
      return (0, Mt.pipe)(d, c(p, E));
    },
    getOrElse: function(d, p) {
      return (0, Mt.pipe)(d, f(p));
    },
    orElse: function(d, p) {
      return (0, Mt.pipe)(d, l(p));
    },
    swap: Au(t),
    rightM: lu(t),
    leftM: fu(t),
    left: cu(t)
  };
}
var ve = {};
Object.defineProperty(ve, "__esModule", { value: !0 });
ve.filter = ua;
ve.filterMap = oa;
ve.partition = Tu;
ve.partitionMap = Mu;
ve.getFilterableComposition = Gl;
var Va = $e, Te = ft, Hl = Ot, Ba = Qr, Jl = xr, wu = Pn;
function ua(t, e) {
  return function(n) {
    return function(r) {
      return t.map(r, function(a) {
        return e.filter(a, n);
      });
    };
  };
}
function oa(t, e) {
  return function(n) {
    return function(r) {
      return t.map(r, function(a) {
        return e.filterMap(a, n);
      });
    };
  };
}
function Tu(t, e) {
  var n = ua(t, e);
  return function(r) {
    var a = n((0, Jl.not)(r)), u = n(r);
    return function(o) {
      return (0, wu.separated)(a(o), u(o));
    };
  };
}
function Mu(t, e) {
  var n = oa(t, e);
  return function(r) {
    return function(a) {
      return (0, wu.separated)((0, Te.pipe)(a, n(function(u) {
        return (0, Ba.getLeft)(r(u));
      })), (0, Te.pipe)(a, n(function(u) {
        return (0, Ba.getRight)(r(u));
      })));
    };
  };
}
function Gl(t, e) {
  var n = (0, Hl.getFunctorComposition)(t, e).map, r = (0, Va.compact)(t, e), a = (0, Va.separate)(t, e, e), u = ua(t, e), o = oa(t, e), c = Tu(t, e), f = Mu(t, e);
  return {
    map: n,
    compact: r,
    separate: a,
    filter: function(l, d) {
      return (0, Te.pipe)(l, u(d));
    },
    filterMap: function(l, d) {
      return (0, Te.pipe)(l, o(d));
    },
    partition: function(l, d) {
      return (0, Te.pipe)(l, c(d));
    },
    partitionMap: function(l, d) {
      return (0, Te.pipe)(l, f(d));
    }
  };
}
var ge = {};
Object.defineProperty(ge, "__esModule", { value: !0 });
ge.fromIOK = Ql;
ge.chainIOK = Xl;
ge.chainFirstIOK = xl;
ge.tapIO = Su;
var Yl = Ft, ca = ft;
function Ql(t) {
  return function(e) {
    return (0, ca.flow)(e, t.fromIO);
  };
}
function Xl(t, e) {
  return function(n) {
    var r = (0, ca.flow)(n, t.fromIO);
    return function(a) {
      return e.chain(a, r);
    };
  };
}
function xl(t, e) {
  var n = Su(t, e);
  return function(r) {
    return function(a) {
      return n(a, r);
    };
  };
}
function Su(t, e) {
  var n = (0, Yl.tap)(e);
  return function(r, a) {
    return n(r, (0, ca.flow)(a, t.fromIO));
  };
}
var We = {};
Object.defineProperty(We, "__esModule", { value: !0 });
We.fromTaskK = ef;
We.chainTaskK = nf;
We.chainFirstTaskK = rf;
We.tapTask = Ru;
var tf = Ft, la = ft;
function ef(t) {
  return function(e) {
    return (0, la.flow)(e, t.fromTask);
  };
}
function nf(t, e) {
  return function(n) {
    var r = (0, la.flow)(n, t.fromTask);
    return function(a) {
      return e.chain(a, r);
    };
  };
}
function rf(t, e) {
  var n = Ru(t, e);
  return function(r) {
    return function(a) {
      return n(a, r);
    };
  };
}
function Ru(t, e) {
  var n = (0, tf.tap)(e);
  return function(r, a) {
    return n(r, (0, la.flow)(a, t.fromTask));
  };
}
var ju = {};
(function(t) {
  var e = C && C.__createBinding || (Object.create ? function($, K, G, lt) {
    lt === void 0 && (lt = G);
    var Et = Object.getOwnPropertyDescriptor(K, G);
    (!Et || ("get" in Et ? !K.__esModule : Et.writable || Et.configurable)) && (Et = { enumerable: !0, get: function() {
      return K[G];
    } }), Object.defineProperty($, lt, Et);
  } : function($, K, G, lt) {
    lt === void 0 && (lt = G), $[lt] = K[G];
  }), n = C && C.__setModuleDefault || (Object.create ? function($, K) {
    Object.defineProperty($, "default", { enumerable: !0, value: K });
  } : function($, K) {
    $.default = K;
  }), r = C && C.__importStar || function($) {
    if ($ && $.__esModule) return $;
    var K = {};
    if ($ != null) for (var G in $) G !== "default" && Object.prototype.hasOwnProperty.call($, G) && e(K, $, G);
    return n(K, $), K;
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.chainFirst = t.chain = t.sequenceSeqArray = t.traverseSeqArray = t.traverseSeqArrayWithIndex = t.sequenceArray = t.traverseArray = t.traverseArrayWithIndex = t.traverseReadonlyArrayWithIndexSeq = t.traverseReadonlyNonEmptyArrayWithIndexSeq = t.traverseReadonlyArrayWithIndex = t.traverseReadonlyNonEmptyArrayWithIndex = t.ApT = t.apS = t.bind = t.let = t.bindTo = t.Do = t.never = t.FromTask = t.chainFirstIOK = t.chainIOK = t.fromIOK = t.tapIO = t.tap = t.flatMapIO = t.FromIO = t.MonadTask = t.fromTask = t.MonadIO = t.Monad = t.Chain = t.ApplicativeSeq = t.ApplySeq = t.ApplicativePar = t.apSecond = t.apFirst = t.ApplyPar = t.Pointed = t.flap = t.asUnit = t.as = t.Functor = t.URI = t.flatten = t.flatMap = t.of = t.ap = t.map = t.fromIO = void 0, t.getMonoid = t.getSemigroup = t.taskSeq = t.task = void 0, t.delay = E, t.getRaceMonoid = b;
  var a = me, u = St, o = r(Ft), c = ge, f = ft, l = Ot, d = r(zt), p = function($) {
    return function() {
      return Promise.resolve().then($);
    };
  };
  t.fromIO = p;
  function E($) {
    return function(K) {
      return function() {
        return new Promise(function(G) {
          setTimeout(function() {
            Promise.resolve().then(K).then(G);
          }, $);
        });
      };
    };
  }
  var R = function($, K) {
    return (0, f.pipe)($, (0, t.map)(K));
  }, U = function($, K) {
    return (0, f.pipe)($, (0, t.ap)(K));
  }, q = function($, K) {
    return (0, t.flatMap)($, function(G) {
      return (0, f.pipe)(K, (0, t.map)(G));
    });
  }, F = function($) {
    return function(K) {
      return function() {
        return Promise.resolve().then(K).then($);
      };
    };
  };
  t.map = F;
  var J = function($) {
    return function(K) {
      return function() {
        return Promise.all([Promise.resolve().then(K), Promise.resolve().then($)]).then(function(G) {
          var lt = G[0], Et = G[1];
          return lt(Et);
        });
      };
    };
  };
  t.ap = J;
  var A = function($) {
    return function() {
      return Promise.resolve($);
    };
  };
  t.of = A, t.flatMap = (0, f.dual)(2, function($, K) {
    return function() {
      return Promise.resolve().then($).then(function(G) {
        return K(G)();
      });
    };
  }), t.flatten = (0, t.flatMap)(f.identity), t.URI = "Task";
  function b() {
    return {
      concat: function($, K) {
        return function() {
          return Promise.race([Promise.resolve().then($), Promise.resolve().then(K)]);
        };
      },
      empty: t.never
    };
  }
  t.Functor = {
    URI: t.URI,
    map: R
  }, t.as = (0, f.dual)(2, (0, l.as)(t.Functor)), t.asUnit = (0, l.asUnit)(t.Functor), t.flap = (0, l.flap)(t.Functor), t.Pointed = {
    URI: t.URI,
    of: t.of
  }, t.ApplyPar = {
    URI: t.URI,
    map: R,
    ap: U
  }, t.apFirst = (0, u.apFirst)(t.ApplyPar), t.apSecond = (0, u.apSecond)(t.ApplyPar), t.ApplicativePar = {
    URI: t.URI,
    map: R,
    ap: U,
    of: t.of
  }, t.ApplySeq = {
    URI: t.URI,
    map: R,
    ap: q
  }, t.ApplicativeSeq = {
    URI: t.URI,
    map: R,
    ap: q,
    of: t.of
  }, t.Chain = {
    URI: t.URI,
    map: R,
    ap: U,
    chain: t.flatMap
  }, t.Monad = {
    URI: t.URI,
    map: R,
    of: t.of,
    ap: U,
    chain: t.flatMap
  }, t.MonadIO = {
    URI: t.URI,
    map: R,
    of: t.of,
    ap: U,
    chain: t.flatMap,
    fromIO: t.fromIO
  }, t.fromTask = f.identity, t.MonadTask = {
    URI: t.URI,
    map: R,
    of: t.of,
    ap: U,
    chain: t.flatMap,
    fromIO: t.fromIO,
    fromTask: t.fromTask
  }, t.FromIO = {
    URI: t.URI,
    fromIO: t.fromIO
  };
  var B = {
    flatMap: t.flatMap
  }, x = {
    fromIO: t.FromIO.fromIO
  };
  t.flatMapIO = d.flatMapIO(x, B), t.tap = (0, f.dual)(2, o.tap(t.Chain)), t.tapIO = (0, f.dual)(2, (0, c.tapIO)(t.FromIO, t.Chain)), t.fromIOK = /* @__PURE__ */ (0, c.fromIOK)(t.FromIO), t.chainIOK = t.flatMapIO, t.chainFirstIOK = t.tapIO, t.FromTask = {
    URI: t.URI,
    fromIO: t.fromIO,
    fromTask: t.fromTask
  };
  var j = function() {
    return new Promise(function($) {
    });
  };
  t.never = j, t.Do = (0, t.of)(d.emptyRecord), t.bindTo = (0, l.bindTo)(t.Functor);
  var s = /* @__PURE__ */ (0, l.let)(t.Functor);
  t.let = s, t.bind = o.bind(t.Chain), t.apS = (0, u.apS)(t.ApplyPar), t.ApT = (0, t.of)(d.emptyReadonlyArray);
  var m = function($) {
    return function(K) {
      return function() {
        return Promise.all(K.map(function(G, lt) {
          return Promise.resolve().then(function() {
            return $(lt, G)();
          });
        }));
      };
    };
  };
  t.traverseReadonlyNonEmptyArrayWithIndex = m;
  var T = function($) {
    var K = (0, t.traverseReadonlyNonEmptyArrayWithIndex)($);
    return function(G) {
      return d.isNonEmpty(G) ? K(G) : t.ApT;
    };
  };
  t.traverseReadonlyArrayWithIndex = T;
  var O = function($) {
    return function(K) {
      return function() {
        return d.tail(K).reduce(function(G, lt, Et) {
          return G.then(function(Jt) {
            return Promise.resolve().then($(Et + 1, lt)).then(function(kt) {
              return Jt.push(kt), Jt;
            });
          });
        }, Promise.resolve().then($(0, d.head(K))).then(d.singleton));
      };
    };
  };
  t.traverseReadonlyNonEmptyArrayWithIndexSeq = O;
  var L = function($) {
    var K = (0, t.traverseReadonlyNonEmptyArrayWithIndexSeq)($);
    return function(G) {
      return d.isNonEmpty(G) ? K(G) : t.ApT;
    };
  };
  t.traverseReadonlyArrayWithIndexSeq = L, t.traverseArrayWithIndex = t.traverseReadonlyArrayWithIndex;
  var D = function($) {
    return (0, t.traverseReadonlyArrayWithIndex)(function(K, G) {
      return $(G);
    });
  };
  t.traverseArray = D, t.sequenceArray = /* @__PURE__ */ (0, t.traverseArray)(f.identity), t.traverseSeqArrayWithIndex = t.traverseReadonlyArrayWithIndexSeq;
  var ct = function($) {
    return (0, t.traverseReadonlyArrayWithIndexSeq)(function(K, G) {
      return $(G);
    });
  };
  t.traverseSeqArray = ct, t.sequenceSeqArray = /* @__PURE__ */ (0, t.traverseSeqArray)(f.identity), t.chain = t.flatMap, t.chainFirst = t.tap, t.task = {
    URI: t.URI,
    map: R,
    of: t.of,
    ap: U,
    chain: t.flatMap,
    fromIO: t.fromIO,
    fromTask: t.fromTask
  }, t.taskSeq = {
    URI: t.URI,
    map: R,
    of: t.of,
    ap: q,
    chain: t.flatMap,
    fromIO: t.fromIO,
    fromTask: t.fromTask
  }, t.getSemigroup = (0, u.getApplySemigroup)(t.ApplySeq), t.getMonoid = (0, a.getApplicativeMonoid)(t.ApplicativeSeq);
})(ju);
(function(t) {
  var e = C && C.__createBinding || (Object.create ? function(M, k, S, z) {
    z === void 0 && (z = S);
    var et = Object.getOwnPropertyDescriptor(k, S);
    (!et || ("get" in et ? !k.__esModule : et.writable || et.configurable)) && (et = { enumerable: !0, get: function() {
      return k[S];
    } }), Object.defineProperty(M, z, et);
  } : function(M, k, S, z) {
    z === void 0 && (z = S), M[z] = k[S];
  }), n = C && C.__setModuleDefault || (Object.create ? function(M, k) {
    Object.defineProperty(M, "default", { enumerable: !0, value: k });
  } : function(M, k) {
    M.default = k;
  }), r = C && C.__importStar || function(M) {
    if (M && M.__esModule) return M;
    var k = {};
    if (M != null) for (var S in M) S !== "default" && Object.prototype.hasOwnProperty.call(M, S) && e(k, M, S);
    return n(k, M), k;
  }, a = C && C.__awaiter || function(M, k, S, z) {
    function et(H) {
      return H instanceof S ? H : new S(function(mt) {
        mt(H);
      });
    }
    return new (S || (S = Promise))(function(H, mt) {
      function _t(wt) {
        try {
          tt(z.next(wt));
        } catch (Yt) {
          mt(Yt);
        }
      }
      function At(wt) {
        try {
          tt(z.throw(wt));
        } catch (Yt) {
          mt(Yt);
        }
      }
      function tt(wt) {
        wt.done ? H(wt.value) : et(wt.value).then(_t, At);
      }
      tt((z = z.apply(M, k || [])).next());
    });
  }, u = C && C.__generator || function(M, k) {
    var S = { label: 0, sent: function() {
      if (H[0] & 1) throw H[1];
      return H[1];
    }, trys: [], ops: [] }, z, et, H, mt;
    return mt = { next: _t(0), throw: _t(1), return: _t(2) }, typeof Symbol == "function" && (mt[Symbol.iterator] = function() {
      return this;
    }), mt;
    function _t(tt) {
      return function(wt) {
        return At([tt, wt]);
      };
    }
    function At(tt) {
      if (z) throw new TypeError("Generator is already executing.");
      for (; mt && (mt = 0, tt[0] && (S = 0)), S; ) try {
        if (z = 1, et && (H = tt[0] & 2 ? et.return : tt[0] ? et.throw || ((H = et.return) && H.call(et), 0) : et.next) && !(H = H.call(et, tt[1])).done) return H;
        switch (et = 0, H && (tt = [tt[0] & 2, H.value]), tt[0]) {
          case 0:
          case 1:
            H = tt;
            break;
          case 4:
            return S.label++, { value: tt[1], done: !1 };
          case 5:
            S.label++, et = tt[1], tt = [0];
            continue;
          case 7:
            tt = S.ops.pop(), S.trys.pop();
            continue;
          default:
            if (H = S.trys, !(H = H.length > 0 && H[H.length - 1]) && (tt[0] === 6 || tt[0] === 2)) {
              S = 0;
              continue;
            }
            if (tt[0] === 3 && (!H || tt[1] > H[0] && tt[1] < H[3])) {
              S.label = tt[1];
              break;
            }
            if (tt[0] === 6 && S.label < H[1]) {
              S.label = H[1], H = tt;
              break;
            }
            if (H && S.label < H[2]) {
              S.label = H[2], S.ops.push(tt);
              break;
            }
            H[2] && S.ops.pop(), S.trys.pop();
            continue;
        }
        tt = k.call(M, S);
      } catch (wt) {
        tt = [6, wt], et = 0;
      } finally {
        z = H = 0;
      }
      if (tt[0] & 5) throw tt[1];
      return { value: tt[0] ? tt[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.throwError = t.of = t.altW = t.alt = t.flatten = t.flattenW = t.flatMap = t.apW = t.ap = t.mapLeft = t.mapError = t.bimap = t.mapBoth = t.map = t.fromIOEitherK = t.chainTaskOptionK = t.chainTaskOptionKW = t.fromTaskOptionK = t.swap = t.orLeft = t.orElseFirstTaskK = t.orElseFirstIOK = t.tapError = t.orElseW = t.orElse = t.chainNullableK = t.fromNullableK = t.fromNullable = t.toUnion = t.tryCatchK = t.tryCatch = t.getOrElseW = t.getOrElse = t.foldW = t.matchEW = t.fold = t.matchE = t.matchW = t.match = t.fromTaskOption = t.fromIOEither = t.fromEither = t.fromTask = t.fromIO = t.leftIO = t.rightIO = t.leftTask = t.rightTask = t.right = t.left = void 0, t.fromEitherK = t.filterOrElseW = t.filterOrElse = t.fromPredicate = t.chainFirstEitherKW = t.chainFirstEitherK = t.chainEitherKW = t.chainEitherK = t.flatMapTaskOption = t.flatMapIOEither = t.flatMapTask = t.flatMapIO = t.flatMapEither = t.flatMapOption = t.flatMapNullable = t.liftOption = t.liftNullable = t.chainOptionKW = t.chainOptionK = t.fromOptionK = t.fromOption = t.Alt = t.Bifunctor = t.tapTask = t.tapIO = t.tapEither = t.tap = t.FromTask = t.FromIO = t.FromEither = t.MonadThrow = t.MonadTask = t.MonadIO = t.Monad = t.Chain = t.ApplicativeSeq = t.ApplySeq = t.ApplicativePar = t.apSecondW = t.apSecond = t.apFirstW = t.apFirst = t.ApplyPar = t.Pointed = t.flap = t.asUnit = t.as = t.Functor = t.getCompactable = t.URI = void 0, t.getSemigroup = t.getApplyMonoid = t.getApplySemigroup = t.taskEitherSeq = t.taskEither = t.orElseFirstW = t.orElseFirst = t.chainFirstW = t.chainFirst = t.chainW = t.chain = t.sequenceSeqArray = t.traverseSeqArray = t.traverseSeqArrayWithIndex = t.sequenceArray = t.traverseArray = t.traverseArrayWithIndex = t.traverseReadonlyArrayWithIndexSeq = t.traverseReadonlyNonEmptyArrayWithIndexSeq = t.traverseReadonlyArrayWithIndex = t.traverseReadonlyNonEmptyArrayWithIndex = t.ApT = t.apSW = t.apS = t.bindW = t.bind = t.let = t.bindTo = t.Do = t.bracketW = t.bracket = t.chainIOEitherK = t.chainIOEitherKW = t.chainFirstTaskK = t.chainTaskK = t.fromTaskK = t.chainFirstIOK = t.chainIOK = t.fromIOK = void 0, t.getApplicativeTaskValidation = G, t.getAltTaskValidation = lt, t.getFilterable = Jt, t.taskify = xe, t.getTaskValidation = ue;
  var o = me, c = St, f = r(Ft), l = $e, d = r(na), p = r(at), E = ve, R = jt, U = ge, q = We, F = ft, J = Ot, A = r(zt), b = r(ju);
  t.left = p.left(b.Pointed), t.right = p.right(b.Pointed), t.rightTask = p.rightF(b.Functor), t.leftTask = p.leftF(b.Functor), t.rightIO = (0, F.flow)(b.fromIO, t.rightTask), t.leftIO = (0, F.flow)(b.fromIO, t.leftTask), t.fromIO = t.rightIO, t.fromTask = t.rightTask, t.fromEither = b.of, t.fromIOEither = b.fromIO;
  var B = function(M) {
    return b.map(d.fromOption(M));
  };
  t.fromTaskOption = B, t.match = /* @__PURE__ */ p.match(b.Functor), t.matchW = t.match, t.matchE = p.matchE(b.Monad), t.fold = t.matchE, t.matchEW = t.matchE, t.foldW = t.matchEW, t.getOrElse = /* @__PURE__ */ p.getOrElse(b.Monad), t.getOrElseW = t.getOrElse;
  var x = function(M, k) {
    return function() {
      return a(void 0, void 0, void 0, function() {
        var S;
        return u(this, function(z) {
          switch (z.label) {
            case 0:
              return z.trys.push([0, 2, , 3]), [4, M().then(A.right)];
            case 1:
              return [2, z.sent()];
            case 2:
              return S = z.sent(), [2, A.left(k(S))];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
  };
  t.tryCatch = x;
  var j = function(M, k) {
    return function() {
      for (var S = [], z = 0; z < arguments.length; z++)
        S[z] = arguments[z];
      return (0, t.tryCatch)(function() {
        return M.apply(void 0, S);
      }, k);
    };
  };
  t.tryCatchK = j, t.toUnion = p.toUnion(b.Functor), t.fromNullable = p.fromNullable(b.Pointed), t.fromNullableK = p.fromNullableK(b.Pointed), t.chainNullableK = /* @__PURE__ */ p.chainNullableK(b.Monad), t.orElse = /* @__PURE__ */ p.orElse(b.Monad), t.orElseW = t.orElse, t.tapError = (0, F.dual)(2, p.tapError(b.Monad));
  var s = function(M) {
    return (0, t.tapError)((0, t.fromIOK)(M));
  };
  t.orElseFirstIOK = s;
  var m = function(M) {
    return (0, t.tapError)((0, t.fromTaskK)(M));
  };
  t.orElseFirstTaskK = m, t.orLeft = /* @__PURE__ */ p.orLeft(b.Monad), t.swap = p.swap(b.Functor);
  var T = function(M) {
    var k = (0, t.fromTaskOption)(M);
    return function(S) {
      return (0, F.flow)(S, k);
    };
  };
  t.fromTaskOptionK = T;
  var O = function(M) {
    return function(k) {
      return function(S) {
        return (0, t.flatMap)(S, (0, t.fromTaskOptionK)(M)(k));
      };
    };
  };
  t.chainTaskOptionKW = O, t.chainTaskOptionK = t.chainTaskOptionKW;
  var L = function(M) {
    return (0, F.flow)(M, t.fromIOEither);
  };
  t.fromIOEitherK = L;
  var D = function(M, k) {
    return (0, F.pipe)(M, (0, t.map)(k));
  }, ct = function(M, k) {
    return (0, F.pipe)(M, (0, t.ap)(k));
  }, $ = function(M, k) {
    return (0, t.flatMap)(M, function(S) {
      return (0, F.pipe)(k, (0, t.map)(S));
    });
  }, K = function(M, k) {
    return (0, F.pipe)(M, (0, t.alt)(k));
  };
  t.map = p.map(b.Functor), t.mapBoth = (0, F.dual)(3, p.mapBoth(b.Functor)), t.bimap = t.mapBoth, t.mapError = (0, F.dual)(2, p.mapError(b.Functor)), t.mapLeft = t.mapError, t.ap = /* @__PURE__ */ p.ap(b.ApplyPar), t.apW = t.ap, t.flatMap = (0, F.dual)(2, p.flatMap(b.Monad)), t.flattenW = /* @__PURE__ */ (0, t.flatMap)(F.identity), t.flatten = t.flattenW, t.alt = /* @__PURE__ */ p.alt(b.Monad), t.altW = t.alt, t.of = t.right, t.throwError = t.left, t.URI = "TaskEither";
  function G(M, k) {
    var S = (0, c.ap)(M, d.getApplicativeValidation(k));
    return {
      URI: t.URI,
      _E: void 0,
      map: D,
      ap: function(z, et) {
        return (0, F.pipe)(z, S(et));
      },
      of: t.of
    };
  }
  function lt(M) {
    var k = p.altValidation(b.Monad, M);
    return {
      URI: t.URI,
      _E: void 0,
      map: D,
      alt: function(S, z) {
        return (0, F.pipe)(S, k(z));
      }
    };
  }
  var Et = function(M) {
    var k = d.getCompactable(M);
    return {
      URI: t.URI,
      _E: void 0,
      compact: (0, l.compact)(b.Functor, k),
      separate: (0, l.separate)(b.Functor, k, d.Functor)
    };
  };
  t.getCompactable = Et;
  function Jt(M) {
    var k = d.getFilterable(M), S = (0, t.getCompactable)(M), z = (0, E.filter)(b.Functor, k), et = (0, E.filterMap)(b.Functor, k), H = (0, E.partition)(b.Functor, k), mt = (0, E.partitionMap)(b.Functor, k);
    return {
      URI: t.URI,
      _E: void 0,
      map: D,
      compact: S.compact,
      separate: S.separate,
      filter: function(_t, At) {
        return (0, F.pipe)(_t, z(At));
      },
      filterMap: function(_t, At) {
        return (0, F.pipe)(_t, et(At));
      },
      partition: function(_t, At) {
        return (0, F.pipe)(_t, H(At));
      },
      partitionMap: function(_t, At) {
        return (0, F.pipe)(_t, mt(At));
      }
    };
  }
  t.Functor = {
    URI: t.URI,
    map: D
  }, t.as = (0, F.dual)(2, (0, J.as)(t.Functor)), t.asUnit = (0, J.asUnit)(t.Functor), t.flap = (0, J.flap)(t.Functor), t.Pointed = {
    URI: t.URI,
    of: t.of
  }, t.ApplyPar = {
    URI: t.URI,
    map: D,
    ap: ct
  }, t.apFirst = (0, c.apFirst)(t.ApplyPar), t.apFirstW = t.apFirst, t.apSecond = (0, c.apSecond)(t.ApplyPar), t.apSecondW = t.apSecond, t.ApplicativePar = {
    URI: t.URI,
    map: D,
    ap: ct,
    of: t.of
  }, t.ApplySeq = {
    URI: t.URI,
    map: D,
    ap: $
  }, t.ApplicativeSeq = {
    URI: t.URI,
    map: D,
    ap: $,
    of: t.of
  }, t.Chain = {
    URI: t.URI,
    map: D,
    ap: ct,
    chain: t.flatMap
  }, t.Monad = {
    URI: t.URI,
    map: D,
    ap: ct,
    chain: t.flatMap,
    of: t.of
  }, t.MonadIO = {
    URI: t.URI,
    map: D,
    ap: ct,
    chain: t.flatMap,
    of: t.of,
    fromIO: t.fromIO
  }, t.MonadTask = {
    URI: t.URI,
    map: D,
    ap: ct,
    chain: t.flatMap,
    of: t.of,
    fromIO: t.fromIO,
    fromTask: t.fromTask
  }, t.MonadThrow = {
    URI: t.URI,
    map: D,
    ap: ct,
    chain: t.flatMap,
    of: t.of,
    throwError: t.throwError
  }, t.FromEither = {
    URI: t.URI,
    fromEither: t.fromEither
  }, t.FromIO = {
    URI: t.URI,
    fromIO: t.fromIO
  }, t.FromTask = {
    URI: t.URI,
    fromIO: t.fromIO,
    fromTask: t.fromTask
  }, t.tap = (0, F.dual)(2, f.tap(t.Chain)), t.tapEither = (0, F.dual)(2, (0, R.tapEither)(t.FromEither, t.Chain)), t.tapIO = (0, F.dual)(2, (0, U.tapIO)(t.FromIO, t.Chain)), t.tapTask = (0, F.dual)(2, (0, q.tapTask)(t.FromTask, t.Chain)), t.Bifunctor = {
    URI: t.URI,
    bimap: t.mapBoth,
    mapLeft: t.mapError
  }, t.Alt = {
    URI: t.URI,
    map: D,
    alt: K
  }, t.fromOption = /* @__PURE__ */ (0, R.fromOption)(t.FromEither), t.fromOptionK = /* @__PURE__ */ (0, R.fromOptionK)(t.FromEither), t.chainOptionK = (0, R.chainOptionK)(t.FromEither, t.Chain), t.chainOptionKW = t.chainOptionK;
  var kt = {
    fromEither: t.FromEither.fromEither
  };
  t.liftNullable = A.liftNullable(kt), t.liftOption = A.liftOption(kt);
  var Kt = {
    flatMap: t.flatMap
  }, Qe = {
    fromIO: t.FromIO.fromIO
  }, Xe = {
    fromTask: t.fromTask
  };
  t.flatMapNullable = A.flatMapNullable(kt, Kt), t.flatMapOption = A.flatMapOption(kt, Kt), t.flatMapEither = A.flatMapEither(kt, Kt), t.flatMapIO = A.flatMapIO(Qe, Kt), t.flatMapTask = A.flatMapTask(Xe, Kt), t.flatMapIOEither = (0, F.dual)(2, function(M, k) {
    return (0, t.flatMap)(M, (0, t.fromIOEitherK)(k));
  }), t.flatMapTaskOption = (0, F.dual)(3, function(M, k, S) {
    return (0, t.flatMap)(M, function(z) {
      return (0, t.fromTaskOption)(function() {
        return S(z);
      })(k(z));
    });
  }), t.chainEitherK = t.flatMapEither, t.chainEitherKW = t.flatMapEither, t.chainFirstEitherK = t.tapEither, t.chainFirstEitherKW = t.tapEither, t.fromPredicate = (0, R.fromPredicate)(t.FromEither), t.filterOrElse = (0, R.filterOrElse)(t.FromEither, t.Chain), t.filterOrElseW = t.filterOrElse, t.fromEitherK = (0, R.fromEitherK)(t.FromEither), t.fromIOK = (0, U.fromIOK)(t.FromIO), t.chainIOK = t.flatMapIO, t.chainFirstIOK = t.tapIO, t.fromTaskK = (0, q.fromTaskK)(t.FromTask), t.chainTaskK = t.flatMapTask, t.chainFirstTaskK = t.tapTask, t.chainIOEitherKW = t.flatMapIOEither, t.chainIOEitherK = t.flatMapIOEither;
  function xe(M) {
    return function() {
      var k = Array.prototype.slice.call(arguments);
      return function() {
        return new Promise(function(S) {
          var z = function(et, H) {
            return et != null ? S(A.left(et)) : S(A.right(H));
          };
          M.apply(null, k.concat(z));
        });
      };
    };
  }
  var tn = function(M, k, S) {
    return (0, t.bracketW)(M, k, S);
  };
  t.bracket = tn;
  var en = function(M, k, S) {
    return (0, t.flatMap)(M, function(z) {
      return b.flatMap(k(z), function(et) {
        return (0, t.flatMap)(S(z, et), function() {
          return b.of(et);
        });
      });
    });
  };
  t.bracketW = en, t.Do = (0, t.of)(A.emptyRecord), t.bindTo = (0, J.bindTo)(t.Functor);
  var nn = /* @__PURE__ */ (0, J.let)(t.Functor);
  t.let = nn, t.bind = f.bind(t.Chain), t.bindW = t.bind, t.apS = (0, c.apS)(t.ApplyPar), t.apSW = t.apS, t.ApT = (0, t.of)(A.emptyReadonlyArray);
  var rn = function(M) {
    return (0, F.flow)(b.traverseReadonlyNonEmptyArrayWithIndex(M), b.map(d.traverseReadonlyNonEmptyArrayWithIndex(F.SK)));
  };
  t.traverseReadonlyNonEmptyArrayWithIndex = rn;
  var an = function(M) {
    var k = (0, t.traverseReadonlyNonEmptyArrayWithIndex)(M);
    return function(S) {
      return A.isNonEmpty(S) ? k(S) : t.ApT;
    };
  };
  t.traverseReadonlyArrayWithIndex = an;
  var Gt = function(M) {
    return function(k) {
      return function() {
        return A.tail(k).reduce(function(S, z, et) {
          return S.then(function(H) {
            return A.isLeft(H) ? S : M(et + 1, z)().then(function(mt) {
              return A.isLeft(mt) ? mt : (H.right.push(mt.right), H);
            });
          });
        }, M(0, A.head(k))().then(d.map(A.singleton)));
      };
    };
  };
  t.traverseReadonlyNonEmptyArrayWithIndexSeq = Gt;
  var Ie = function(M) {
    var k = (0, t.traverseReadonlyNonEmptyArrayWithIndexSeq)(M);
    return function(S) {
      return A.isNonEmpty(S) ? k(S) : t.ApT;
    };
  };
  t.traverseReadonlyArrayWithIndexSeq = Ie, t.traverseArrayWithIndex = t.traverseReadonlyArrayWithIndex;
  var un = function(M) {
    return (0, t.traverseReadonlyArrayWithIndex)(function(k, S) {
      return M(S);
    });
  };
  t.traverseArray = un, t.sequenceArray = /* @__PURE__ */ (0, t.traverseArray)(F.identity), t.traverseSeqArrayWithIndex = t.traverseReadonlyArrayWithIndexSeq;
  var on = function(M) {
    return (0, t.traverseReadonlyArrayWithIndexSeq)(function(k, S) {
      return M(S);
    });
  };
  t.traverseSeqArray = on, t.sequenceSeqArray = /* @__PURE__ */ (0, t.traverseSeqArray)(F.identity), t.chain = t.flatMap, t.chainW = t.flatMap, t.chainFirst = t.tap, t.chainFirstW = t.tap, t.orElseFirst = t.tapError, t.orElseFirstW = t.tapError, t.taskEither = {
    URI: t.URI,
    bimap: t.mapBoth,
    mapLeft: t.mapError,
    map: D,
    of: t.of,
    ap: ct,
    chain: t.flatMap,
    alt: K,
    fromIO: t.fromIO,
    fromTask: t.fromTask,
    throwError: t.throwError
  }, t.taskEitherSeq = {
    URI: t.URI,
    bimap: t.mapBoth,
    mapLeft: t.mapError,
    map: D,
    of: t.of,
    ap: $,
    chain: t.flatMap,
    alt: K,
    fromIO: t.fromIO,
    fromTask: t.fromTask,
    throwError: t.throwError
  }, t.getApplySemigroup = /* @__PURE__ */ (0, c.getApplySemigroup)(t.ApplySeq), t.getApplyMonoid = /* @__PURE__ */ (0, o.getApplicativeMonoid)(t.ApplicativeSeq);
  var ie = function(M) {
    return (0, c.getApplySemigroup)(b.ApplySeq)(d.getSemigroup(M));
  };
  t.getSemigroup = ie;
  function ue(M) {
    var k = G(b.ApplicativePar, M), S = lt(M);
    return {
      URI: t.URI,
      _E: void 0,
      map: D,
      ap: k.ap,
      of: t.of,
      chain: t.flatMap,
      bimap: t.mapBoth,
      mapLeft: t.mapError,
      alt: S.alt,
      fromIO: t.fromIO,
      fromTask: t.fromTask,
      throwError: t.throwError
    };
  }
})(oe);
var af = function(t, e, n) {
  if (arguments.length === 2) for (var r = 0, a = e.length, u; r < a; r++)
    (u || !(r in e)) && (u || (u = Array.prototype.slice.call(e, 0, r)), u[r] = e[r]);
  return t.concat(u || Array.prototype.slice.call(e));
};
function uf(t) {
  return t;
}
function Me(t, e, n, r, a, u, o, c, f) {
  switch (arguments.length) {
    case 1:
      return t;
    case 2:
      return function() {
        return e(t.apply(this, arguments));
      };
    case 3:
      return function() {
        return n(e(t.apply(this, arguments)));
      };
    case 4:
      return function() {
        return r(n(e(t.apply(this, arguments))));
      };
    case 5:
      return function() {
        return a(r(n(e(t.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return u(a(r(n(e(t.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return o(u(a(r(n(e(t.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return c(o(u(a(r(n(e(t.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return f(c(o(u(a(r(n(e(t.apply(this, arguments)))))))));
      };
  }
}
function Q(t, e, n, r, a, u, o, c, f) {
  switch (arguments.length) {
    case 1:
      return t;
    case 2:
      return e(t);
    case 3:
      return n(e(t));
    case 4:
      return r(n(e(t)));
    case 5:
      return a(r(n(e(t))));
    case 6:
      return u(a(r(n(e(t)))));
    case 7:
      return o(u(a(r(n(e(t))))));
    case 8:
      return c(o(u(a(r(n(e(t)))))));
    case 9:
      return f(c(o(u(a(r(n(e(t))))))));
    default: {
      for (var l = arguments[0], d = 1; d < arguments.length; d++)
        l = arguments[d](l);
      return l;
    }
  }
}
var of = function(t, e) {
  var n = function(r) {
    return r.length >= t;
  };
  return function() {
    var r = Array.from(arguments);
    return n(arguments) ? e.apply(this, r) : function(a) {
      return e.apply(void 0, af([a], r, !1));
    };
  };
}, Pu = function(t) {
  return t._tag === "Some";
}, ku = { _tag: "None" }, Nu = function(t) {
  return { _tag: "Some", value: t };
}, cf = function(t) {
  return t._tag === "Left";
}, lf = function(t) {
  return t._tag === "Right";
}, ff = function(t) {
  return { _tag: "Left", left: t };
}, sf = function(t) {
  return { _tag: "Right", right: t };
}, df = function(t) {
  return [t];
}, hf = [], mf = Object.prototype.hasOwnProperty, vf = function(t) {
  return function(e) {
    return function(n) {
      return n.reduce(function(r, a) {
        return t.concat(r, a);
      }, e);
    };
  };
}, gf = function(t) {
  return {
    concat: function(e, n) {
      var r = {};
      for (var a in t)
        mf.call(t, a) && (r[a] = t[a].concat(e[a], n[a]));
      return r;
    }
  };
}, Tr = function() {
  return { concat: uf };
}, pf = function() {
  return { concat: function(t, e) {
    return e;
  } };
}, yf = vf, za = function(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, a = e.length, u; r < a; r++)
    (u || !(r in e)) && (u || (u = Array.prototype.slice.call(e, 0, r)), u[r] = e[r]);
  return t.concat(u || Array.prototype.slice.call(e));
}, _f = hf, bf = function(t, e) {
  return t < 0 || t >= e.length;
}, Of = function(t) {
  return function(e) {
    return za(za([], e, !0), [t], !1);
  };
}, Ef = Of, If = df, Af = {
  concat: function(t, e) {
    return t + e;
  }
}, wf = "", fa = {
  concat: Af.concat,
  empty: wf
}, Uu = function(t) {
  return t.trim();
}, Cu = function(t) {
  return t.length === 0;
}, Vn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Tf = typeof Vn == "object" && Vn && Vn.Object === Object && Vn, Fu = Tf, Mf = Fu, Sf = typeof self == "object" && self && self.Object === Object && self, Rf = Mf || Sf || Function("return this")(), qt = Rf, jf = qt, Pf = jf.Symbol, or = Pf, Ha = or, $u = Object.prototype, kf = $u.hasOwnProperty, Nf = $u.toString, cn = Ha ? Ha.toStringTag : void 0;
function Uf(t) {
  var e = kf.call(t, cn), n = t[cn];
  try {
    t[cn] = void 0;
    var r = !0;
  } catch {
  }
  var a = Nf.call(t);
  return r && (e ? t[cn] = n : delete t[cn]), a;
}
var Cf = Uf, Ff = Object.prototype, $f = Ff.toString;
function Lf(t) {
  return $f.call(t);
}
var Wf = Lf, Ja = or, qf = Cf, Df = Wf, Kf = "[object Null]", Zf = "[object Undefined]", Ga = Ja ? Ja.toStringTag : void 0;
function Vf(t) {
  return t == null ? t === void 0 ? Zf : Kf : Ga && Ga in Object(t) ? qf(t) : Df(t);
}
var sa = Vf;
function Bf(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Lu = Bf, zf = sa, Hf = Lu, Jf = "[object AsyncFunction]", Gf = "[object Function]", Yf = "[object GeneratorFunction]", Qf = "[object Proxy]";
function Xf(t) {
  if (!Hf(t))
    return !1;
  var e = zf(t);
  return e == Gf || e == Yf || e == Jf || e == Qf;
}
var xf = Xf, ts = qt, es = ts["__core-js_shared__"], ns = es, Mr = ns, Ya = function() {
  var t = /[^.]+$/.exec(Mr && Mr.keys && Mr.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function rs(t) {
  return !!Ya && Ya in t;
}
var as = rs, is = Function.prototype, us = is.toString;
function os(t) {
  if (t != null) {
    try {
      return us.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var Wu = os, cs = xf, ls = as, fs = Lu, ss = Wu, ds = /[\\^$.*+?()[\]{}|]/g, hs = /^\[object .+?Constructor\]$/, ms = Function.prototype, vs = Object.prototype, gs = ms.toString, ps = vs.hasOwnProperty, ys = RegExp(
  "^" + gs.call(ps).replace(ds, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function _s(t) {
  if (!fs(t) || ls(t))
    return !1;
  var e = cs(t) ? ys : hs;
  return e.test(ss(t));
}
var bs = _s;
function Os(t, e) {
  return t == null ? void 0 : t[e];
}
var Es = Os, Is = bs, As = Es;
function ws(t, e) {
  var n = As(t, e);
  return Is(n) ? n : void 0;
}
var pe = ws, Ts = pe, Ms = qt, Ss = Ts(Ms, "Map"), Rs = Ss, js = pe;
js(Object, "create");
var Ps = pe;
(function() {
  try {
    var t = Ps(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
})();
function ks(t) {
  return t != null && typeof t == "object";
}
var qu = ks, Ns = sa, Us = qu, Cs = "[object Arguments]";
function Fs(t) {
  return Us(t) && Ns(t) == Cs;
}
var $s = Fs, Qa = $s, Ls = qu, Du = Object.prototype, Ws = Du.hasOwnProperty, qs = Du.propertyIsEnumerable;
Qa(/* @__PURE__ */ function() {
  return arguments;
}());
var zn = { exports: {} };
function Ds() {
  return !1;
}
var Ks = Ds;
zn.exports;
(function(t, e) {
  var n = qt, r = Ks, a = e && !e.nodeType && e, u = a && !0 && t && !t.nodeType && t, o = u && u.exports === a, c = o ? n.Buffer : void 0, f = c ? c.isBuffer : void 0, l = f || r;
  t.exports = l;
})(zn, zn.exports);
zn.exports;
var Hn = { exports: {} };
Hn.exports;
(function(t, e) {
  var n = Fu, r = e && !e.nodeType && e, a = r && !0 && t && !t.nodeType && t, u = a && a.exports === r, o = u && n.process, c = function() {
    try {
      var f = a && a.require && a.require("util").types;
      return f || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  t.exports = c;
})(Hn, Hn.exports);
var da = Hn.exports, Xa = da;
Xa && Xa.isTypedArray;
var Jn = { exports: {} };
Jn.exports;
(function(t, e) {
  var n = qt, r = e && !e.nodeType && e, a = r && !0 && t && !t.nodeType && t, u = a && a.exports === r, o = u ? n.Buffer : void 0, c = o ? o.allocUnsafe : void 0;
  function f(l, d) {
    if (d)
      return l.slice();
    var p = l.length, E = c ? c(p) : new l.constructor(p);
    return l.copy(E), E;
  }
  t.exports = f;
})(Jn, Jn.exports);
Jn.exports;
var Zs = pe, Vs = qt, Bs = Zs(Vs, "DataView"), zs = Bs, Hs = pe, Js = qt, Gs = Hs(Js, "Promise"), Ys = Gs, Qs = pe, Xs = qt, xs = Qs(Xs, "Set"), td = xs, ed = pe, nd = qt, rd = ed(nd, "WeakMap"), ad = rd, kr = zs, Nr = Rs, Ur = Ys, Cr = td, Fr = ad, Ku = sa, qe = Wu, xa = "[object Map]", id = "[object Object]", ti = "[object Promise]", ei = "[object Set]", ni = "[object WeakMap]", ri = "[object DataView]", ud = qe(kr), od = qe(Nr), cd = qe(Ur), ld = qe(Cr), fd = qe(Fr), Ae = Ku;
(kr && Ae(new kr(new ArrayBuffer(1))) != ri || Nr && Ae(new Nr()) != xa || Ur && Ae(Ur.resolve()) != ti || Cr && Ae(new Cr()) != ei || Fr && Ae(new Fr()) != ni) && (Ae = function(t) {
  var e = Ku(t), n = e == id ? t.constructor : void 0, r = n ? qe(n) : "";
  if (r)
    switch (r) {
      case ud:
        return ri;
      case od:
        return xa;
      case cd:
        return ti;
      case ld:
        return ei;
      case fd:
        return ni;
    }
  return e;
});
var sd = qt;
sd.Uint8Array;
var ai = or, ii = ai ? ai.prototype : void 0;
ii && ii.valueOf;
var ui = da;
ui && ui.isMap;
var oi = da;
oi && oi.isSet;
var rt;
(function(t) {
  t.assertEqual = (a) => a;
  function e(a) {
  }
  t.assertIs = e;
  function n(a) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (a) => {
    const u = {};
    for (const o of a)
      u[o] = o;
    return u;
  }, t.getValidEnumValues = (a) => {
    const u = t.objectKeys(a).filter((c) => typeof a[a[c]] != "number"), o = {};
    for (const c of u)
      o[c] = a[c];
    return t.objectValues(o);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(u) {
    return a[u];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const u = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && u.push(o);
    return u;
  }, t.find = (a, u) => {
    for (const o of a)
      if (u(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function r(a, u = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(u);
  }
  t.joinValues = r, t.jsonStringifyReplacer = (a, u) => typeof u == "bigint" ? u.toString() : u;
})(rt || (rt = {}));
var $r;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})($r || ($r = {}));
const N = rt.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Xt = (t) => {
  switch (typeof t) {
    case "undefined":
      return N.undefined;
    case "string":
      return N.string;
    case "number":
      return isNaN(t) ? N.nan : N.number;
    case "boolean":
      return N.boolean;
    case "function":
      return N.function;
    case "bigint":
      return N.bigint;
    case "symbol":
      return N.symbol;
    case "object":
      return Array.isArray(t) ? N.array : t === null ? N.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? N.promise : typeof Map < "u" && t instanceof Map ? N.map : typeof Set < "u" && t instanceof Set ? N.set : typeof Date < "u" && t instanceof Date ? N.date : N.object;
    default:
      return N.unknown;
  }
}, I = rt.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), dd = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class Rt extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const n = e || function(u) {
      return u.message;
    }, r = { _errors: [] }, a = (u) => {
      for (const o of u.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          r._errors.push(n(o));
        else {
          let c = r, f = 0;
          for (; f < o.path.length; ) {
            const l = o.path[f];
            f === o.path.length - 1 ? (c[l] = c[l] || { _errors: [] }, c[l]._errors.push(n(o))) : c[l] = c[l] || { _errors: [] }, c = c[l], f++;
          }
        }
    };
    return a(this), r;
  }
  static assert(e) {
    if (!(e instanceof Rt))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, rt.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, r = [];
    for (const a of this.issues)
      a.path.length > 0 ? (n[a.path[0]] = n[a.path[0]] || [], n[a.path[0]].push(e(a))) : r.push(e(a));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Rt.create = (t) => new Rt(t);
const Re = (t, e) => {
  let n;
  switch (t.code) {
    case I.invalid_type:
      t.received === N.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case I.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, rt.jsonStringifyReplacer)}`;
      break;
    case I.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${rt.joinValues(t.keys, ", ")}`;
      break;
    case I.invalid_union:
      n = "Invalid input";
      break;
    case I.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${rt.joinValues(t.options)}`;
      break;
    case I.invalid_enum_value:
      n = `Invalid enum value. Expected ${rt.joinValues(t.options)}, received '${t.received}'`;
      break;
    case I.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case I.invalid_return_type:
      n = "Invalid function return type";
      break;
    case I.invalid_date:
      n = "Invalid date";
      break;
    case I.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : rt.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case I.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case I.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case I.custom:
      n = "Invalid input";
      break;
    case I.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case I.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case I.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, rt.assertNever(t);
  }
  return { message: n };
};
let Zu = Re;
function hd(t) {
  Zu = t;
}
function Gn() {
  return Zu;
}
const Yn = (t) => {
  const { data: e, path: n, errorMaps: r, issueData: a } = t, u = [...n, ...a.path || []], o = {
    ...a,
    path: u
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: u,
      message: a.message
    };
  let c = "";
  const f = r.filter((l) => !!l).slice().reverse();
  for (const l of f)
    c = l(o, { data: e, defaultError: c }).message;
  return {
    ...a,
    path: u,
    message: c
  };
}, md = [];
function P(t, e) {
  const n = Gn(), r = Yn({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      n,
      n === Re ? void 0 : Re
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(r);
}
class It {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const r = [];
    for (const a of n) {
      if (a.status === "aborted")
        return V;
      a.status === "dirty" && e.dirty(), r.push(a.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, n) {
    const r = [];
    for (const a of n) {
      const u = await a.key, o = await a.value;
      r.push({
        key: u,
        value: o
      });
    }
    return It.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, n) {
    const r = {};
    for (const a of n) {
      const { key: u, value: o } = a;
      if (u.status === "aborted" || o.status === "aborted")
        return V;
      u.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), u.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (r[u.value] = o.value);
    }
    return { status: e.value, value: r };
  }
}
const V = Object.freeze({
  status: "aborted"
}), Qn = (t) => ({ status: "dirty", value: t }), Tt = (t) => ({ status: "valid", value: t }), Lr = (t) => t.status === "aborted", Wr = (t) => t.status === "dirty", hn = (t) => t.status === "valid", mn = (t) => typeof Promise < "u" && t instanceof Promise;
function Xn(t, e, n, r) {
  if (typeof e == "function" ? t !== e || !r : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function Vu(t, e, n, r, a) {
  if (typeof e == "function" ? t !== e || !a : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, n), n;
}
var W;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(W || (W = {}));
var fn, sn;
class Lt {
  constructor(e, n, r, a) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = r, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const ci = (t, e) => {
  if (hn(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new Rt(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function Y(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: r, description: a } = t;
  if (e && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (u, o) => {
    var c, f;
    const { message: l } = t;
    return u.code === "invalid_enum_value" ? { message: l ?? o.defaultError } : typeof o.data > "u" ? { message: (c = l ?? r) !== null && c !== void 0 ? c : o.defaultError } : u.code !== "invalid_type" ? { message: o.defaultError } : { message: (f = l ?? n) !== null && f !== void 0 ? f : o.defaultError };
  }, description: a };
}
class X {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Xt(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: Xt(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new It(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Xt(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (mn(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const r = this.safeParse(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, n) {
    var r;
    const a = {
      common: {
        issues: [],
        async: (r = n == null ? void 0 : n.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Xt(e)
    }, u = this._parseSync({ data: e, path: a.path, parent: a });
    return ci(a, u);
  }
  async parseAsync(e, n) {
    const r = await this.safeParseAsync(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Xt(e)
    }, a = this._parse({ data: e, path: r.path, parent: r }), u = await (mn(a) ? a : Promise.resolve(a));
    return ci(r, u);
  }
  refine(e, n) {
    const r = (a) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(a) : n;
    return this._refinement((a, u) => {
      const o = e(a), c = () => u.addIssue({
        code: I.custom,
        ...r(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((f) => f ? !0 : (c(), !1)) : o ? !0 : (c(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((r, a) => e(r) ? !0 : (a.addIssue(typeof n == "function" ? n(r, a) : n), !1));
  }
  _refinement(e) {
    return new Ct({
      schema: this,
      typeName: Z.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return $t.create(this, this._def);
  }
  nullable() {
    return ne.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Ut.create(this, this._def);
  }
  promise() {
    return Pe.create(this, this._def);
  }
  or(e) {
    return yn.create([this, e], this._def);
  }
  and(e) {
    return _n.create(this, e, this._def);
  }
  transform(e) {
    return new Ct({
      ...Y(this._def),
      schema: this,
      typeName: Z.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new An({
      ...Y(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Z.ZodDefault
    });
  }
  brand() {
    return new ha({
      typeName: Z.ZodBranded,
      type: this,
      ...Y(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new wn({
      ...Y(this._def),
      innerType: this,
      catchValue: n,
      typeName: Z.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return kn.create(this, e);
  }
  readonly() {
    return Tn.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const vd = /^c[^\s-]{8,}$/i, gd = /^[0-9a-z]+$/, pd = /^[0-9A-HJKMNP-TV-Z]{26}$/, yd = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, _d = /^[a-z0-9_-]{21}$/i, bd = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Od = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Ed = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Sr;
const Id = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Ad = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, wd = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Bu = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Td = new RegExp(`^${Bu}$`);
function zu(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function Md(t) {
  return new RegExp(`^${zu(t)}$`);
}
function Hu(t) {
  let e = `${Bu}T${zu(t)}`;
  const n = [];
  return n.push(t.local ? "Z?" : "Z"), t.offset && n.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${n.join("|")})`, new RegExp(`^${e}$`);
}
function Sd(t, e) {
  return !!((e === "v4" || !e) && Id.test(t) || (e === "v6" || !e) && Ad.test(t));
}
class Nt extends X {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== N.string) {
      const a = this._getOrReturnCtx(e);
      return P(a, {
        code: I.invalid_type,
        expected: N.string,
        received: a.parsedType
      }), V;
    }
    const n = new It();
    let r;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (r = this._getOrReturnCtx(e, r), P(r, {
          code: I.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (r = this._getOrReturnCtx(e, r), P(r, {
          code: I.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "length") {
        const u = e.data.length > a.value, o = e.data.length < a.value;
        (u || o) && (r = this._getOrReturnCtx(e, r), u ? P(r, {
          code: I.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : o && P(r, {
          code: I.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), n.dirty());
      } else if (a.kind === "email")
        Od.test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
          validation: "email",
          code: I.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "emoji")
        Sr || (Sr = new RegExp(Ed, "u")), Sr.test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
          validation: "emoji",
          code: I.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "uuid")
        yd.test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
          validation: "uuid",
          code: I.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "nanoid")
        _d.test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
          validation: "nanoid",
          code: I.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid")
        vd.test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
          validation: "cuid",
          code: I.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid2")
        gd.test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
          validation: "cuid2",
          code: I.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "ulid")
        pd.test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
          validation: "ulid",
          code: I.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          r = this._getOrReturnCtx(e, r), P(r, {
            validation: "url",
            code: I.invalid_string,
            message: a.message
          }), n.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
        validation: "regex",
        code: I.invalid_string,
        message: a.message
      }), n.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (r = this._getOrReturnCtx(e, r), P(r, {
        code: I.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), n.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (r = this._getOrReturnCtx(e, r), P(r, {
        code: I.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (r = this._getOrReturnCtx(e, r), P(r, {
        code: I.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "datetime" ? Hu(a).test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
        code: I.invalid_string,
        validation: "datetime",
        message: a.message
      }), n.dirty()) : a.kind === "date" ? Td.test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
        code: I.invalid_string,
        validation: "date",
        message: a.message
      }), n.dirty()) : a.kind === "time" ? Md(a).test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
        code: I.invalid_string,
        validation: "time",
        message: a.message
      }), n.dirty()) : a.kind === "duration" ? bd.test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
        validation: "duration",
        code: I.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "ip" ? Sd(e.data, a.version) || (r = this._getOrReturnCtx(e, r), P(r, {
        validation: "ip",
        code: I.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "base64" ? wd.test(e.data) || (r = this._getOrReturnCtx(e, r), P(r, {
        validation: "base64",
        code: I.invalid_string,
        message: a.message
      }), n.dirty()) : rt.assertNever(a);
    return { status: n.value, value: e.data };
  }
  _regex(e, n, r) {
    return this.refinement((a) => e.test(a), {
      validation: n,
      code: I.invalid_string,
      ...W.errToObj(r)
    });
  }
  _addCheck(e) {
    return new Nt({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...W.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...W.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...W.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...W.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...W.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...W.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...W.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...W.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...W.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...W.errToObj(e) });
  }
  datetime(e) {
    var n, r;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (n = e == null ? void 0 : e.offset) !== null && n !== void 0 ? n : !1,
      local: (r = e == null ? void 0 : e.local) !== null && r !== void 0 ? r : !1,
      ...W.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...W.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...W.errToObj(e) });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...W.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n == null ? void 0 : n.position,
      ...W.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...W.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...W.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...W.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...W.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...W.errToObj(n)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, W.errToObj(e));
  }
  trim() {
    return new Nt({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Nt({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Nt({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
Nt.create = (t) => {
  var e;
  return new Nt({
    checks: [],
    typeName: Z.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...Y(t)
  });
};
function Rd(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, a = n > r ? n : r, u = parseInt(t.toFixed(a).replace(".", "")), o = parseInt(e.toFixed(a).replace(".", ""));
  return u % o / Math.pow(10, a);
}
class xt extends X {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== N.number) {
      const a = this._getOrReturnCtx(e);
      return P(a, {
        code: I.invalid_type,
        expected: N.number,
        received: a.parsedType
      }), V;
    }
    let n;
    const r = new It();
    for (const a of this._def.checks)
      a.kind === "int" ? rt.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), P(n, {
        code: I.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), r.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), P(n, {
        code: I.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), r.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), P(n, {
        code: I.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), r.dirty()) : a.kind === "multipleOf" ? Rd(e.data, a.value) !== 0 && (n = this._getOrReturnCtx(e, n), P(n, {
        code: I.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), r.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), P(n, {
        code: I.not_finite,
        message: a.message
      }), r.dirty()) : rt.assertNever(a);
    return { status: r.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, W.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, W.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, W.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, W.toString(n));
  }
  setLimit(e, n, r, a) {
    return new xt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: W.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new xt({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: W.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: W.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: W.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: W.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: W.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: W.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: W.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: W.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: W.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && rt.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
xt.create = (t) => new xt({
  checks: [],
  typeName: Z.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...Y(t)
});
class te extends X {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== N.bigint) {
      const a = this._getOrReturnCtx(e);
      return P(a, {
        code: I.invalid_type,
        expected: N.bigint,
        received: a.parsedType
      }), V;
    }
    let n;
    const r = new It();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), P(n, {
        code: I.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), r.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), P(n, {
        code: I.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), r.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), P(n, {
        code: I.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), r.dirty()) : rt.assertNever(a);
    return { status: r.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, W.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, W.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, W.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, W.toString(n));
  }
  setLimit(e, n, r, a) {
    return new te({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: W.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new te({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: W.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: W.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: W.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: W.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: W.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
te.create = (t) => {
  var e;
  return new te({
    checks: [],
    typeName: Z.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...Y(t)
  });
};
class vn extends X {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== N.boolean) {
      const n = this._getOrReturnCtx(e);
      return P(n, {
        code: I.invalid_type,
        expected: N.boolean,
        received: n.parsedType
      }), V;
    }
    return Tt(e.data);
  }
}
vn.create = (t) => new vn({
  typeName: Z.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...Y(t)
});
class se extends X {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== N.date) {
      const a = this._getOrReturnCtx(e);
      return P(a, {
        code: I.invalid_type,
        expected: N.date,
        received: a.parsedType
      }), V;
    }
    if (isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return P(a, {
        code: I.invalid_date
      }), V;
    }
    const n = new It();
    let r;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (r = this._getOrReturnCtx(e, r), P(r, {
        code: I.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), n.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (r = this._getOrReturnCtx(e, r), P(r, {
        code: I.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), n.dirty()) : rt.assertNever(a);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new se({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: W.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: W.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
se.create = (t) => new se({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: Z.ZodDate,
  ...Y(t)
});
class xn extends X {
  _parse(e) {
    if (this._getType(e) !== N.symbol) {
      const n = this._getOrReturnCtx(e);
      return P(n, {
        code: I.invalid_type,
        expected: N.symbol,
        received: n.parsedType
      }), V;
    }
    return Tt(e.data);
  }
}
xn.create = (t) => new xn({
  typeName: Z.ZodSymbol,
  ...Y(t)
});
class gn extends X {
  _parse(e) {
    if (this._getType(e) !== N.undefined) {
      const n = this._getOrReturnCtx(e);
      return P(n, {
        code: I.invalid_type,
        expected: N.undefined,
        received: n.parsedType
      }), V;
    }
    return Tt(e.data);
  }
}
gn.create = (t) => new gn({
  typeName: Z.ZodUndefined,
  ...Y(t)
});
class pn extends X {
  _parse(e) {
    if (this._getType(e) !== N.null) {
      const n = this._getOrReturnCtx(e);
      return P(n, {
        code: I.invalid_type,
        expected: N.null,
        received: n.parsedType
      }), V;
    }
    return Tt(e.data);
  }
}
pn.create = (t) => new pn({
  typeName: Z.ZodNull,
  ...Y(t)
});
class je extends X {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Tt(e.data);
  }
}
je.create = (t) => new je({
  typeName: Z.ZodAny,
  ...Y(t)
});
class fe extends X {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Tt(e.data);
  }
}
fe.create = (t) => new fe({
  typeName: Z.ZodUnknown,
  ...Y(t)
});
class Vt extends X {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return P(n, {
      code: I.invalid_type,
      expected: N.never,
      received: n.parsedType
    }), V;
  }
}
Vt.create = (t) => new Vt({
  typeName: Z.ZodNever,
  ...Y(t)
});
class tr extends X {
  _parse(e) {
    if (this._getType(e) !== N.undefined) {
      const n = this._getOrReturnCtx(e);
      return P(n, {
        code: I.invalid_type,
        expected: N.void,
        received: n.parsedType
      }), V;
    }
    return Tt(e.data);
  }
}
tr.create = (t) => new tr({
  typeName: Z.ZodVoid,
  ...Y(t)
});
class Ut extends X {
  _parse(e) {
    const { ctx: n, status: r } = this._processInputParams(e), a = this._def;
    if (n.parsedType !== N.array)
      return P(n, {
        code: I.invalid_type,
        expected: N.array,
        received: n.parsedType
      }), V;
    if (a.exactLength !== null) {
      const o = n.data.length > a.exactLength.value, c = n.data.length < a.exactLength.value;
      (o || c) && (P(n, {
        code: o ? I.too_big : I.too_small,
        minimum: c ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), r.dirty());
    }
    if (a.minLength !== null && n.data.length < a.minLength.value && (P(n, {
      code: I.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), r.dirty()), a.maxLength !== null && n.data.length > a.maxLength.value && (P(n, {
      code: I.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((o, c) => a.type._parseAsync(new Lt(n, o, n.path, c)))).then((o) => It.mergeArray(r, o));
    const u = [...n.data].map((o, c) => a.type._parseSync(new Lt(n, o, n.path, c)));
    return It.mergeArray(r, u);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new Ut({
      ...this._def,
      minLength: { value: e, message: W.toString(n) }
    });
  }
  max(e, n) {
    return new Ut({
      ...this._def,
      maxLength: { value: e, message: W.toString(n) }
    });
  }
  length(e, n) {
    return new Ut({
      ...this._def,
      exactLength: { value: e, message: W.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Ut.create = (t, e) => new Ut({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Z.ZodArray,
  ...Y(e)
});
function we(t) {
  if (t instanceof ht) {
    const e = {};
    for (const n in t.shape) {
      const r = t.shape[n];
      e[n] = $t.create(we(r));
    }
    return new ht({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof Ut ? new Ut({
    ...t._def,
    type: we(t.element)
  }) : t instanceof $t ? $t.create(we(t.unwrap())) : t instanceof ne ? ne.create(we(t.unwrap())) : t instanceof Wt ? Wt.create(t.items.map((e) => we(e))) : t;
}
class ht extends X {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = rt.objectKeys(e);
    return this._cached = { shape: e, keys: n };
  }
  _parse(e) {
    if (this._getType(e) !== N.object) {
      const f = this._getOrReturnCtx(e);
      return P(f, {
        code: I.invalid_type,
        expected: N.object,
        received: f.parsedType
      }), V;
    }
    const { status: n, ctx: r } = this._processInputParams(e), { shape: a, keys: u } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Vt && this._def.unknownKeys === "strip"))
      for (const f in r.data)
        u.includes(f) || o.push(f);
    const c = [];
    for (const f of u) {
      const l = a[f], d = r.data[f];
      c.push({
        key: { status: "valid", value: f },
        value: l._parse(new Lt(r, d, r.path, f)),
        alwaysSet: f in r.data
      });
    }
    if (this._def.catchall instanceof Vt) {
      const f = this._def.unknownKeys;
      if (f === "passthrough")
        for (const l of o)
          c.push({
            key: { status: "valid", value: l },
            value: { status: "valid", value: r.data[l] }
          });
      else if (f === "strict")
        o.length > 0 && (P(r, {
          code: I.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (f !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const f = this._def.catchall;
      for (const l of o) {
        const d = r.data[l];
        c.push({
          key: { status: "valid", value: l },
          value: f._parse(
            new Lt(r, d, r.path, l)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: l in r.data
        });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const f = [];
      for (const l of c) {
        const d = await l.key, p = await l.value;
        f.push({
          key: d,
          value: p,
          alwaysSet: l.alwaysSet
        });
      }
      return f;
    }).then((f) => It.mergeObjectSync(n, f)) : It.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return W.errToObj, new ht({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, r) => {
          var a, u, o, c;
          const f = (o = (u = (a = this._def).errorMap) === null || u === void 0 ? void 0 : u.call(a, n, r).message) !== null && o !== void 0 ? o : r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (c = W.errToObj(e).message) !== null && c !== void 0 ? c : f
          } : {
            message: f
          };
        }
      } : {}
    });
  }
  strip() {
    return new ht({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ht({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new ht({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new ht({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: Z.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new ht({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    return rt.objectKeys(e).forEach((r) => {
      e[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new ht({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    return rt.objectKeys(this.shape).forEach((r) => {
      e[r] || (n[r] = this.shape[r]);
    }), new ht({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return we(this);
  }
  partial(e) {
    const n = {};
    return rt.objectKeys(this.shape).forEach((r) => {
      const a = this.shape[r];
      e && !e[r] ? n[r] = a : n[r] = a.optional();
    }), new ht({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    return rt.objectKeys(this.shape).forEach((r) => {
      if (e && !e[r])
        n[r] = this.shape[r];
      else {
        let a = this.shape[r];
        for (; a instanceof $t; )
          a = a._def.innerType;
        n[r] = a;
      }
    }), new ht({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return Ju(rt.objectKeys(this.shape));
  }
}
ht.create = (t, e) => new ht({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Vt.create(),
  typeName: Z.ZodObject,
  ...Y(e)
});
ht.strictCreate = (t, e) => new ht({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Vt.create(),
  typeName: Z.ZodObject,
  ...Y(e)
});
ht.lazycreate = (t, e) => new ht({
  shape: t,
  unknownKeys: "strip",
  catchall: Vt.create(),
  typeName: Z.ZodObject,
  ...Y(e)
});
class yn extends X {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = this._def.options;
    function a(u) {
      for (const c of u)
        if (c.result.status === "valid")
          return c.result;
      for (const c of u)
        if (c.result.status === "dirty")
          return n.common.issues.push(...c.ctx.common.issues), c.result;
      const o = u.map((c) => new Rt(c.ctx.common.issues));
      return P(n, {
        code: I.invalid_union,
        unionErrors: o
      }), V;
    }
    if (n.common.async)
      return Promise.all(r.map(async (u) => {
        const o = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await u._parseAsync({
            data: n.data,
            path: n.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let u;
      const o = [];
      for (const f of r) {
        const l = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, d = f._parseSync({
          data: n.data,
          path: n.path,
          parent: l
        });
        if (d.status === "valid")
          return d;
        d.status === "dirty" && !u && (u = { result: d, ctx: l }), l.common.issues.length && o.push(l.common.issues);
      }
      if (u)
        return n.common.issues.push(...u.ctx.common.issues), u.result;
      const c = o.map((f) => new Rt(f));
      return P(n, {
        code: I.invalid_union,
        unionErrors: c
      }), V;
    }
  }
  get options() {
    return this._def.options;
  }
}
yn.create = (t, e) => new yn({
  options: t,
  typeName: Z.ZodUnion,
  ...Y(e)
});
const Qt = (t) => t instanceof On ? Qt(t.schema) : t instanceof Ct ? Qt(t.innerType()) : t instanceof En ? [t.value] : t instanceof ee ? t.options : t instanceof In ? rt.objectValues(t.enum) : t instanceof An ? Qt(t._def.innerType) : t instanceof gn ? [void 0] : t instanceof pn ? [null] : t instanceof $t ? [void 0, ...Qt(t.unwrap())] : t instanceof ne ? [null, ...Qt(t.unwrap())] : t instanceof ha || t instanceof Tn ? Qt(t.unwrap()) : t instanceof wn ? Qt(t._def.innerType) : [];
class cr extends X {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== N.object)
      return P(n, {
        code: I.invalid_type,
        expected: N.object,
        received: n.parsedType
      }), V;
    const r = this.discriminator, a = n.data[r], u = this.optionsMap.get(a);
    return u ? n.common.async ? u._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : u._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (P(n, {
      code: I.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), V);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, n, r) {
    const a = /* @__PURE__ */ new Map();
    for (const u of n) {
      const o = Qt(u.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const c of o) {
        if (a.has(c))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(c)}`);
        a.set(c, u);
      }
    }
    return new cr({
      typeName: Z.ZodDiscriminatedUnion,
      discriminator: e,
      options: n,
      optionsMap: a,
      ...Y(r)
    });
  }
}
function qr(t, e) {
  const n = Xt(t), r = Xt(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === N.object && r === N.object) {
    const a = rt.objectKeys(e), u = rt.objectKeys(t).filter((c) => a.indexOf(c) !== -1), o = { ...t, ...e };
    for (const c of u) {
      const f = qr(t[c], e[c]);
      if (!f.valid)
        return { valid: !1 };
      o[c] = f.data;
    }
    return { valid: !0, data: o };
  } else if (n === N.array && r === N.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let u = 0; u < t.length; u++) {
      const o = t[u], c = e[u], f = qr(o, c);
      if (!f.valid)
        return { valid: !1 };
      a.push(f.data);
    }
    return { valid: !0, data: a };
  } else return n === N.date && r === N.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class _n extends X {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), a = (u, o) => {
      if (Lr(u) || Lr(o))
        return V;
      const c = qr(u.value, o.value);
      return c.valid ? ((Wr(u) || Wr(o)) && n.dirty(), { status: n.value, value: c.data }) : (P(r, {
        code: I.invalid_intersection_types
      }), V);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([u, o]) => a(u, o)) : a(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
_n.create = (t, e, n) => new _n({
  left: t,
  right: e,
  typeName: Z.ZodIntersection,
  ...Y(n)
});
class Wt extends X {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== N.array)
      return P(r, {
        code: I.invalid_type,
        expected: N.array,
        received: r.parsedType
      }), V;
    if (r.data.length < this._def.items.length)
      return P(r, {
        code: I.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), V;
    !this._def.rest && r.data.length > this._def.items.length && (P(r, {
      code: I.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const a = [...r.data].map((u, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new Lt(r, u, r.path, o)) : null;
    }).filter((u) => !!u);
    return r.common.async ? Promise.all(a).then((u) => It.mergeArray(n, u)) : It.mergeArray(n, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Wt({
      ...this._def,
      rest: e
    });
  }
}
Wt.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Wt({
    items: t,
    typeName: Z.ZodTuple,
    rest: null,
    ...Y(e)
  });
};
class bn extends X {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== N.object)
      return P(r, {
        code: I.invalid_type,
        expected: N.object,
        received: r.parsedType
      }), V;
    const a = [], u = this._def.keyType, o = this._def.valueType;
    for (const c in r.data)
      a.push({
        key: u._parse(new Lt(r, c, r.path, c)),
        value: o._parse(new Lt(r, r.data[c], r.path, c)),
        alwaysSet: c in r.data
      });
    return r.common.async ? It.mergeObjectAsync(n, a) : It.mergeObjectSync(n, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, r) {
    return n instanceof X ? new bn({
      keyType: e,
      valueType: n,
      typeName: Z.ZodRecord,
      ...Y(r)
    }) : new bn({
      keyType: Nt.create(),
      valueType: e,
      typeName: Z.ZodRecord,
      ...Y(n)
    });
  }
}
class er extends X {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== N.map)
      return P(r, {
        code: I.invalid_type,
        expected: N.map,
        received: r.parsedType
      }), V;
    const a = this._def.keyType, u = this._def.valueType, o = [...r.data.entries()].map(([c, f], l) => ({
      key: a._parse(new Lt(r, c, r.path, [l, "key"])),
      value: u._parse(new Lt(r, f, r.path, [l, "value"]))
    }));
    if (r.common.async) {
      const c = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const f of o) {
          const l = await f.key, d = await f.value;
          if (l.status === "aborted" || d.status === "aborted")
            return V;
          (l.status === "dirty" || d.status === "dirty") && n.dirty(), c.set(l.value, d.value);
        }
        return { status: n.value, value: c };
      });
    } else {
      const c = /* @__PURE__ */ new Map();
      for (const f of o) {
        const l = f.key, d = f.value;
        if (l.status === "aborted" || d.status === "aborted")
          return V;
        (l.status === "dirty" || d.status === "dirty") && n.dirty(), c.set(l.value, d.value);
      }
      return { status: n.value, value: c };
    }
  }
}
er.create = (t, e, n) => new er({
  valueType: e,
  keyType: t,
  typeName: Z.ZodMap,
  ...Y(n)
});
class de extends X {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== N.set)
      return P(r, {
        code: I.invalid_type,
        expected: N.set,
        received: r.parsedType
      }), V;
    const a = this._def;
    a.minSize !== null && r.data.size < a.minSize.value && (P(r, {
      code: I.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), n.dirty()), a.maxSize !== null && r.data.size > a.maxSize.value && (P(r, {
      code: I.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), n.dirty());
    const u = this._def.valueType;
    function o(f) {
      const l = /* @__PURE__ */ new Set();
      for (const d of f) {
        if (d.status === "aborted")
          return V;
        d.status === "dirty" && n.dirty(), l.add(d.value);
      }
      return { status: n.value, value: l };
    }
    const c = [...r.data.values()].map((f, l) => u._parse(new Lt(r, f, r.path, l)));
    return r.common.async ? Promise.all(c).then((f) => o(f)) : o(c);
  }
  min(e, n) {
    return new de({
      ...this._def,
      minSize: { value: e, message: W.toString(n) }
    });
  }
  max(e, n) {
    return new de({
      ...this._def,
      maxSize: { value: e, message: W.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
de.create = (t, e) => new de({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: Z.ZodSet,
  ...Y(e)
});
class Se extends X {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== N.function)
      return P(n, {
        code: I.invalid_type,
        expected: N.function,
        received: n.parsedType
      }), V;
    function r(c, f) {
      return Yn({
        data: c,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Gn(),
          Re
        ].filter((l) => !!l),
        issueData: {
          code: I.invalid_arguments,
          argumentsError: f
        }
      });
    }
    function a(c, f) {
      return Yn({
        data: c,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Gn(),
          Re
        ].filter((l) => !!l),
        issueData: {
          code: I.invalid_return_type,
          returnTypeError: f
        }
      });
    }
    const u = { errorMap: n.common.contextualErrorMap }, o = n.data;
    if (this._def.returns instanceof Pe) {
      const c = this;
      return Tt(async function(...f) {
        const l = new Rt([]), d = await c._def.args.parseAsync(f, u).catch((E) => {
          throw l.addIssue(r(f, E)), l;
        }), p = await Reflect.apply(o, this, d);
        return await c._def.returns._def.type.parseAsync(p, u).catch((E) => {
          throw l.addIssue(a(p, E)), l;
        });
      });
    } else {
      const c = this;
      return Tt(function(...f) {
        const l = c._def.args.safeParse(f, u);
        if (!l.success)
          throw new Rt([r(f, l.error)]);
        const d = Reflect.apply(o, this, l.data), p = c._def.returns.safeParse(d, u);
        if (!p.success)
          throw new Rt([a(d, p.error)]);
        return p.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new Se({
      ...this._def,
      args: Wt.create(e).rest(fe.create())
    });
  }
  returns(e) {
    return new Se({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, n, r) {
    return new Se({
      args: e || Wt.create([]).rest(fe.create()),
      returns: n || fe.create(),
      typeName: Z.ZodFunction,
      ...Y(r)
    });
  }
}
class On extends X {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
On.create = (t, e) => new On({
  getter: t,
  typeName: Z.ZodLazy,
  ...Y(e)
});
class En extends X {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return P(n, {
        received: n.data,
        code: I.invalid_literal,
        expected: this._def.value
      }), V;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
En.create = (t, e) => new En({
  value: t,
  typeName: Z.ZodLiteral,
  ...Y(e)
});
function Ju(t, e) {
  return new ee({
    values: t,
    typeName: Z.ZodEnum,
    ...Y(e)
  });
}
class ee extends X {
  constructor() {
    super(...arguments), fn.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return P(n, {
        expected: rt.joinValues(r),
        received: n.parsedType,
        code: I.invalid_type
      }), V;
    }
    if (Xn(this, fn) || Vu(this, fn, new Set(this._def.values)), !Xn(this, fn).has(e.data)) {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return P(n, {
        received: n.data,
        code: I.invalid_enum_value,
        options: r
      }), V;
    }
    return Tt(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e, n = this._def) {
    return ee.create(e, {
      ...this._def,
      ...n
    });
  }
  exclude(e, n = this._def) {
    return ee.create(this.options.filter((r) => !e.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
fn = /* @__PURE__ */ new WeakMap();
ee.create = Ju;
class In extends X {
  constructor() {
    super(...arguments), sn.set(this, void 0);
  }
  _parse(e) {
    const n = rt.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== N.string && r.parsedType !== N.number) {
      const a = rt.objectValues(n);
      return P(r, {
        expected: rt.joinValues(a),
        received: r.parsedType,
        code: I.invalid_type
      }), V;
    }
    if (Xn(this, sn) || Vu(this, sn, new Set(rt.getValidEnumValues(this._def.values))), !Xn(this, sn).has(e.data)) {
      const a = rt.objectValues(n);
      return P(r, {
        received: r.data,
        code: I.invalid_enum_value,
        options: a
      }), V;
    }
    return Tt(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
sn = /* @__PURE__ */ new WeakMap();
In.create = (t, e) => new In({
  values: t,
  typeName: Z.ZodNativeEnum,
  ...Y(e)
});
class Pe extends X {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== N.promise && n.common.async === !1)
      return P(n, {
        code: I.invalid_type,
        expected: N.promise,
        received: n.parsedType
      }), V;
    const r = n.parsedType === N.promise ? n.data : Promise.resolve(n.data);
    return Tt(r.then((a) => this._def.type.parseAsync(a, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
Pe.create = (t, e) => new Pe({
  type: t,
  typeName: Z.ZodPromise,
  ...Y(e)
});
class Ct extends X {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Z.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), a = this._def.effect || null, u = {
      addIssue: (o) => {
        P(r, o), o.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (u.addIssue = u.addIssue.bind(u), a.type === "preprocess") {
      const o = a.transform(r.data, u);
      if (r.common.async)
        return Promise.resolve(o).then(async (c) => {
          if (n.value === "aborted")
            return V;
          const f = await this._def.schema._parseAsync({
            data: c,
            path: r.path,
            parent: r
          });
          return f.status === "aborted" ? V : f.status === "dirty" || n.value === "dirty" ? Qn(f.value) : f;
        });
      {
        if (n.value === "aborted")
          return V;
        const c = this._def.schema._parseSync({
          data: o,
          path: r.path,
          parent: r
        });
        return c.status === "aborted" ? V : c.status === "dirty" || n.value === "dirty" ? Qn(c.value) : c;
      }
    }
    if (a.type === "refinement") {
      const o = (c) => {
        const f = a.refinement(c, u);
        if (r.common.async)
          return Promise.resolve(f);
        if (f instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return c;
      };
      if (r.common.async === !1) {
        const c = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return c.status === "aborted" ? V : (c.status === "dirty" && n.dirty(), o(c.value), { status: n.value, value: c.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((c) => c.status === "aborted" ? V : (c.status === "dirty" && n.dirty(), o(c.value).then(() => ({ status: n.value, value: c.value }))));
    }
    if (a.type === "transform")
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!hn(o))
          return o;
        const c = a.transform(o.value, u);
        if (c instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: c };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => hn(o) ? Promise.resolve(a.transform(o.value, u)).then((c) => ({ status: n.value, value: c })) : o);
    rt.assertNever(a);
  }
}
Ct.create = (t, e, n) => new Ct({
  schema: t,
  typeName: Z.ZodEffects,
  effect: e,
  ...Y(n)
});
Ct.createWithPreprocess = (t, e, n) => new Ct({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: Z.ZodEffects,
  ...Y(n)
});
class $t extends X {
  _parse(e) {
    return this._getType(e) === N.undefined ? Tt(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
$t.create = (t, e) => new $t({
  innerType: t,
  typeName: Z.ZodOptional,
  ...Y(e)
});
class ne extends X {
  _parse(e) {
    return this._getType(e) === N.null ? Tt(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ne.create = (t, e) => new ne({
  innerType: t,
  typeName: Z.ZodNullable,
  ...Y(e)
});
class An extends X {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let r = n.data;
    return n.parsedType === N.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
An.create = (t, e) => new An({
  innerType: t,
  typeName: Z.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...Y(e)
});
class wn extends X {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return mn(a) ? a.then((u) => ({
      status: "valid",
      value: u.status === "valid" ? u.value : this._def.catchValue({
        get error() {
          return new Rt(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Rt(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
wn.create = (t, e) => new wn({
  innerType: t,
  typeName: Z.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...Y(e)
});
class nr extends X {
  _parse(e) {
    if (this._getType(e) !== N.nan) {
      const n = this._getOrReturnCtx(e);
      return P(n, {
        code: I.invalid_type,
        expected: N.nan,
        received: n.parsedType
      }), V;
    }
    return { status: "valid", value: e.data };
  }
}
nr.create = (t) => new nr({
  typeName: Z.ZodNaN,
  ...Y(t)
});
const jd = Symbol("zod_brand");
class ha extends X {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class kn extends X {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? V : a.status === "dirty" ? (n.dirty(), Qn(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return a.status === "aborted" ? V : a.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, n) {
    return new kn({
      in: e,
      out: n,
      typeName: Z.ZodPipeline
    });
  }
}
class Tn extends X {
  _parse(e) {
    const n = this._def.innerType._parse(e), r = (a) => (hn(a) && (a.value = Object.freeze(a.value)), a);
    return mn(n) ? n.then((a) => r(a)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Tn.create = (t, e) => new Tn({
  innerType: t,
  typeName: Z.ZodReadonly,
  ...Y(e)
});
function Gu(t, e = {}, n) {
  return t ? je.create().superRefine((r, a) => {
    var u, o;
    if (!t(r)) {
      const c = typeof e == "function" ? e(r) : typeof e == "string" ? { message: e } : e, f = (o = (u = c.fatal) !== null && u !== void 0 ? u : n) !== null && o !== void 0 ? o : !0, l = typeof c == "string" ? { message: c } : c;
      a.addIssue({ code: "custom", ...l, fatal: f });
    }
  }) : je.create();
}
const Pd = {
  object: ht.lazycreate
};
var Z;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(Z || (Z = {}));
const kd = (t, e = {
  message: `Input not instance of ${t.name}`
}) => Gu((n) => n instanceof t, e), Yu = Nt.create, Qu = xt.create, Nd = nr.create, Ud = te.create, Xu = vn.create, Cd = se.create, Fd = xn.create, $d = gn.create, Ld = pn.create, Wd = je.create, qd = fe.create, Dd = Vt.create, Kd = tr.create, Zd = Ut.create, Vd = ht.create, Bd = ht.strictCreate, zd = yn.create, Hd = cr.create, Jd = _n.create, Gd = Wt.create, Yd = bn.create, Qd = er.create, Xd = de.create, xd = Se.create, th = On.create, eh = En.create, nh = ee.create, rh = In.create, ah = Pe.create, li = Ct.create, ih = $t.create, uh = ne.create, oh = Ct.createWithPreprocess, ch = kn.create, lh = () => Yu().optional(), fh = () => Qu().optional(), sh = () => Xu().optional(), dh = {
  string: (t) => Nt.create({ ...t, coerce: !0 }),
  number: (t) => xt.create({ ...t, coerce: !0 }),
  boolean: (t) => vn.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => te.create({ ...t, coerce: !0 }),
  date: (t) => se.create({ ...t, coerce: !0 })
}, hh = V;
var i = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Re,
  setErrorMap: hd,
  getErrorMap: Gn,
  makeIssue: Yn,
  EMPTY_PATH: md,
  addIssueToContext: P,
  ParseStatus: It,
  INVALID: V,
  DIRTY: Qn,
  OK: Tt,
  isAborted: Lr,
  isDirty: Wr,
  isValid: hn,
  isAsync: mn,
  get util() {
    return rt;
  },
  get objectUtil() {
    return $r;
  },
  ZodParsedType: N,
  getParsedType: Xt,
  ZodType: X,
  datetimeRegex: Hu,
  ZodString: Nt,
  ZodNumber: xt,
  ZodBigInt: te,
  ZodBoolean: vn,
  ZodDate: se,
  ZodSymbol: xn,
  ZodUndefined: gn,
  ZodNull: pn,
  ZodAny: je,
  ZodUnknown: fe,
  ZodNever: Vt,
  ZodVoid: tr,
  ZodArray: Ut,
  ZodObject: ht,
  ZodUnion: yn,
  ZodDiscriminatedUnion: cr,
  ZodIntersection: _n,
  ZodTuple: Wt,
  ZodRecord: bn,
  ZodMap: er,
  ZodSet: de,
  ZodFunction: Se,
  ZodLazy: On,
  ZodLiteral: En,
  ZodEnum: ee,
  ZodNativeEnum: In,
  ZodPromise: Pe,
  ZodEffects: Ct,
  ZodTransformer: Ct,
  ZodOptional: $t,
  ZodNullable: ne,
  ZodDefault: An,
  ZodCatch: wn,
  ZodNaN: nr,
  BRAND: jd,
  ZodBranded: ha,
  ZodPipeline: kn,
  ZodReadonly: Tn,
  custom: Gu,
  Schema: X,
  ZodSchema: X,
  late: Pd,
  get ZodFirstPartyTypeKind() {
    return Z;
  },
  coerce: dh,
  any: Wd,
  array: Zd,
  bigint: Ud,
  boolean: Xu,
  date: Cd,
  discriminatedUnion: Hd,
  effect: li,
  enum: nh,
  function: xd,
  instanceof: kd,
  intersection: Jd,
  lazy: th,
  literal: eh,
  map: Qd,
  nan: Nd,
  nativeEnum: rh,
  never: Dd,
  null: Ld,
  nullable: uh,
  number: Qu,
  object: Vd,
  oboolean: sh,
  onumber: fh,
  optional: ih,
  ostring: lh,
  pipeline: ch,
  preprocess: oh,
  promise: ah,
  record: Yd,
  set: Xd,
  strictObject: Bd,
  string: Yu,
  symbol: Fd,
  transformer: li,
  tuple: Gd,
  undefined: $d,
  union: zd,
  unknown: qd,
  void: Kd,
  NEVER: hh,
  ZodIssueCode: I,
  quotelessJson: dd,
  ZodError: Rt
}), dt = (t) => t, mh = class {
  /**
   * @package
   */
  constructor(t, e, n) {
    this.versionMap = t, this.latestVersion = e, this.getVersion = n;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(t) {
    let e = this.getVersion(t);
    if (e === null)
      return !1;
    const n = this.versionMap[e];
    return n ? n.schema.safeParse(t).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(t) {
    return this.versionMap[this.latestVersion].schema.safeParse(t).success;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(t) {
    const e = this.getVersion(t);
    if (e === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const n = this.versionMap[e];
    if (!n)
      return { type: "err", error: { type: "INVALID_VER" } };
    const r = n.schema.safeParse(t);
    if (!r.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: e,
          versionDef: n,
          error: r.error
        }
      };
    let a = t;
    for (let u = e + 1; u <= this.latestVersion; u++) {
      const o = this.versionMap[u];
      if (!o)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: u }
        };
      if (o.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: u }
        };
      a = o.up(a);
    }
    return { type: "ok", value: a };
  }
};
function Nn(t) {
  return new mh(t.versionMap, t.latestVersion, t.getVersion);
}
function rr(t) {
  return i.custom((e) => t.is(e)).transform((e) => {
    const n = t.safeParse(e);
    if (n.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return n.value;
  });
}
var fi = or, si = fi ? fi.prototype : void 0;
si && si.valueOf;
const vh = i.object({
  id: i.optional(i.string()),
  // Firebase Firestore ID
  url: i.string(),
  path: i.string(),
  headers: i.array(
    i.object({
      key: i.string(),
      value: i.string(),
      active: i.boolean()
    })
  ),
  params: i.array(
    i.object({
      key: i.string(),
      value: i.string(),
      active: i.boolean()
    })
  ),
  name: i.string(),
  method: i.string(),
  preRequestScript: i.string(),
  testScript: i.string(),
  contentType: i.string(),
  body: i.string(),
  rawParams: i.optional(i.string()),
  auth: i.optional(i.string()),
  httpUser: i.optional(i.string()),
  httpPassword: i.optional(i.string()),
  bearerToken: i.optional(i.string())
}), di = dt({
  initial: !0,
  schema: vh
}), ma = i.object({
  key: i.string(),
  active: i.boolean()
}).and(
  i.union([
    i.object({
      isFile: i.literal(!0),
      value: i.array(i.instanceof(Blob).nullable())
    }),
    i.object({
      isFile: i.literal(!1),
      value: i.string()
    })
  ])
);
i.object({
  contentType: i.literal("multipart/form-data"),
  body: i.array(ma)
});
const gh = i.union([
  i.object({
    contentType: i.literal(null),
    body: i.literal(null).catch(null)
  }),
  i.object({
    contentType: i.literal("multipart/form-data"),
    body: i.array(ma).catch([])
  }),
  i.object({
    contentType: i.union([
      i.literal("application/json"),
      i.literal("application/ld+json"),
      i.literal("application/hal+json"),
      i.literal("application/vnd.api+json"),
      i.literal("application/xml"),
      i.literal("application/x-www-form-urlencoded"),
      i.literal("text/html"),
      i.literal("text/plain")
    ]),
    body: i.string().catch("")
  })
]), De = i.object({
  authType: i.literal("none")
}), Ke = i.object({
  authType: i.literal("basic"),
  username: i.string().catch(""),
  password: i.string().catch("")
}), Ze = i.object({
  authType: i.literal("bearer"),
  token: i.string().catch("")
}), ph = i.object({
  authType: i.literal("oauth-2"),
  token: i.string().catch(""),
  oidcDiscoveryURL: i.string().catch(""),
  authURL: i.string().catch(""),
  accessTokenURL: i.string().catch(""),
  clientID: i.string().catch(""),
  scope: i.string().catch("")
}), Un = i.object({
  authType: i.literal("api-key"),
  key: i.string().catch(""),
  value: i.string().catch(""),
  addTo: i.string().catch("Headers")
}), Ve = i.object({
  authType: i.literal("inherit")
}), yh = i.discriminatedUnion("authType", [
  De,
  Ve,
  Ke,
  Ze,
  ph,
  Un
]).and(
  i.object({
    authActive: i.boolean()
  })
), _h = i.array(
  i.object({
    key: i.string().catch(""),
    value: i.string().catch(""),
    active: i.boolean().catch(!0)
  })
), xu = i.array(
  i.object({
    key: i.string().catch(""),
    value: i.string().catch(""),
    active: i.boolean().catch(!0)
  })
), to = i.object({
  v: i.literal("1"),
  id: i.optional(i.string()),
  // Firebase Firestore ID
  name: i.string(),
  method: i.string(),
  endpoint: i.string(),
  params: _h,
  headers: xu,
  preRequestScript: i.string().catch(""),
  testScript: i.string().catch(""),
  auth: yh,
  body: gh
});
function bh(t) {
  return {
    contentType: "application/json",
    body: t.contentType === "application/json" ? t.rawParams ?? "" : ""
  };
}
function Oh(t) {
  return !t.auth || t.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : t.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: t.httpUser ?? "",
    password: t.httpPassword ?? ""
  } : t.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: t.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const Eh = dt({
  initial: !1,
  schema: to,
  up(t) {
    const {
      url: e,
      path: n,
      headers: r,
      params: a,
      name: u,
      method: o,
      preRequestScript: c,
      testScript: f
    } = t, l = `${e}${n}`, d = bh(t), p = Oh(t), E = {
      v: "1",
      endpoint: l,
      headers: r,
      params: a,
      name: u,
      method: o,
      preRequestScript: c,
      testScript: f,
      body: d,
      auth: p
    };
    return t.id && (E.id = t.id), E;
  }
}), eo = i.array(
  i.object({
    key: i.string().catch(""),
    value: i.string().catch(""),
    active: i.boolean().catch(!0)
  })
), no = to.extend({
  v: i.literal("2"),
  requestVariables: eo
}), Ih = dt({
  initial: !1,
  schema: no,
  up(t) {
    return {
      ...t,
      v: "2",
      requestVariables: []
    };
  }
}), ro = i.object({
  grantType: i.literal("AUTHORIZATION_CODE"),
  authEndpoint: i.string().trim(),
  tokenEndpoint: i.string().trim(),
  clientID: i.string().trim(),
  clientSecret: i.string().trim(),
  scopes: i.string().trim().optional(),
  token: i.string().catch(""),
  isPKCE: i.boolean(),
  codeVerifierMethod: i.union([i.literal("plain"), i.literal("S256")]).optional()
}), lr = i.object({
  grantType: i.literal("CLIENT_CREDENTIALS"),
  authEndpoint: i.string().trim(),
  clientID: i.string().trim(),
  clientSecret: i.string().trim(),
  scopes: i.string().trim().optional(),
  token: i.string().catch("")
}), fr = i.object({
  grantType: i.literal("PASSWORD"),
  authEndpoint: i.string().trim(),
  clientID: i.string().trim(),
  clientSecret: i.string().trim(),
  scopes: i.string().trim().optional(),
  username: i.string().trim(),
  password: i.string().trim(),
  token: i.string().catch("")
}), sr = i.object({
  grantType: i.literal("IMPLICIT"),
  authEndpoint: i.string().trim(),
  clientID: i.string().trim(),
  scopes: i.string().trim().optional(),
  token: i.string().catch("")
}), dr = i.object({
  authType: i.literal("oauth-2"),
  grantTypeInfo: i.discriminatedUnion("grantType", [
    ro,
    lr,
    fr,
    sr
  ]),
  addTo: i.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ah = i.discriminatedUnion("authType", [
  De,
  Ve,
  Ke,
  Ze,
  dr,
  Un
]).and(
  i.object({
    authActive: i.boolean()
  })
), ao = no.extend({
  v: i.literal("3"),
  auth: Ah
}), wh = dt({
  initial: !1,
  schema: ao,
  up(t) {
    if (t.auth.authType === "oauth-2") {
      const { token: e, accessTokenURL: n, scope: r, clientID: a, authURL: u } = t.auth;
      return {
        ...t,
        v: "3",
        auth: {
          ...t.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: u,
            tokenEndpoint: n,
            clientID: a,
            clientSecret: "",
            scopes: r,
            isPKCE: !1,
            token: e
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...t,
      v: "3",
      auth: {
        ...t.auth
      }
    };
  }
}), io = Un.extend({
  addTo: i.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Th = i.discriminatedUnion("authType", [
  De,
  Ve,
  Ke,
  Ze,
  dr,
  io
]).and(
  i.object({
    authActive: i.boolean()
  })
), uo = ao.extend({
  v: i.literal("4"),
  auth: Th
}), Mh = dt({
  schema: uo,
  initial: !1,
  up(t) {
    return t.auth.authType === "api-key" ? {
      ...t,
      v: "4",
      auth: {
        ...t.auth,
        addTo: t.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...t,
      auth: {
        ...t.auth
      },
      v: "4"
    };
  }
}), oo = ro.extend({
  clientSecret: i.string().optional()
}), hr = dr.extend({
  grantTypeInfo: i.discriminatedUnion("grantType", [
    oo,
    lr,
    fr,
    sr
  ])
}), co = i.discriminatedUnion("authType", [
  De,
  Ve,
  Ke,
  Ze,
  hr,
  io
]).and(
  i.object({
    authActive: i.boolean()
  })
), lo = uo.extend({
  v: i.literal("5"),
  auth: co
}), Sh = dt({
  schema: lo,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "5"
    };
  }
}), fo = i.union([
  i.object({
    contentType: i.literal(null),
    body: i.literal(null).catch(null)
  }),
  i.object({
    contentType: i.literal("multipart/form-data"),
    body: i.array(ma).catch([])
  }),
  i.object({
    contentType: i.union([
      i.literal("application/json"),
      i.literal("application/ld+json"),
      i.literal("application/hal+json"),
      i.literal("application/vnd.api+json"),
      i.literal("application/xml"),
      i.literal("text/xml"),
      i.literal("application/x-www-form-urlencoded"),
      i.literal("text/html"),
      i.literal("text/plain")
    ]),
    body: i.string().catch("")
  })
]), so = lo.extend({
  v: i.literal("6"),
  body: fo
}), Rh = dt({
  schema: so,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "6"
    };
  }
}), ho = oo.extend({
  refreshToken: i.string().optional()
}), mo = i.object({
  authType: i.literal("oauth-2"),
  grantTypeInfo: i.discriminatedUnion("grantType", [
    ho,
    lr,
    fr,
    sr
  ]),
  addTo: i.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), vo = i.array(
  i.object({
    key: i.string().catch(""),
    value: i.string().catch(""),
    active: i.boolean().catch(!0),
    description: i.string().catch("")
  })
), va = i.array(
  i.object({
    key: i.string().catch(""),
    value: i.string().catch(""),
    active: i.boolean().catch(!0),
    description: i.string().catch("")
  })
), ga = i.object({
  authType: i.literal("aws-signature"),
  accessKey: i.string().catch(""),
  secretKey: i.string().catch(""),
  region: i.string().catch(""),
  serviceName: i.string().catch(""),
  serviceToken: i.string().optional(),
  signature: i.object({}).optional(),
  addTo: i.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), go = i.discriminatedUnion("authType", [
  De,
  Ve,
  Ke,
  Ze,
  mo,
  Un,
  ga
]).and(
  i.object({
    authActive: i.boolean()
  })
), po = so.extend({
  v: i.literal("7"),
  params: vo,
  headers: va,
  auth: go
}), jh = dt({
  schema: po,
  initial: !1,
  up(t) {
    const e = t.params.map((r) => ({
      ...r,
      description: ""
    })), n = t.headers.map((r) => ({
      ...r,
      description: ""
    }));
    return {
      ...t,
      v: "7",
      params: e,
      headers: n
      // no need to update anything for HoppRESTAuth, because the newly added refreshToken is optional
    };
  }
}), Ph = {
  // 1xx Informational
  // Request received, continuing process.[2]
  // This class of status code indicates a provisional response, consisting only of the Status-Line and optional headers, and is terminated by an empty line. Since HTTP/1.0 did not define any 1xx status codes, servers must not send a 1xx response to an HTTP/1.0 client except under experimental conditions.
  100: "Continue",
  // This means that the server has received the request headers, and that the client should proceed to send the request body (in the case of a request for which a body needs to be sent; for example, a POST request). If the request body is large, sending it to a server when a request has already been rejected based upon inappropriate headers is inefficient. To have a server check if the request could be accepted based on the request's headers alone, a client must send Expect: 100-continue as a header in its initial request[2] and check if a 100 Continue status code is received in response before continuing (or receive 417 Expectation Failed and not continue).[2]
  101: "Switching Protocols",
  // This means the requester has asked the server to switch protocols and the server is acknowledging that it will do so.[2]
  102: "Processing",
  // (WebDAV; RFC 2518) As a WebDAV request may contain many sub-requests involving file operations, it may take a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[3] This prevents the client from timing out and assuming the request was lost.
  // 2xx Success
  // This class of status codes indicates the action requested by the client was received, understood, accepted and processed successfully.
  200: "OK",
  // Standard response for successful HTTP requests. The actual response will depend on the request method used. In a GET request, the response will contain an entity corresponding to the requested resource. In a POST request the response will contain an entity describing or containing the result of the action.[2]
  201: "Created",
  // The request has been fulfilled and resulted in a new resource being created.[2]
  202: "Accepted",
  // The request has been accepted for processing, but the processing has not been completed. The request might or might not eventually be acted upon, as it might be disallowed when processing actually takes place.[2]
  203: "Non-Authoritative Information",
  // (since HTTP/1.1) The server successfully processed the request, but is returning information that may be from another source.[2]
  204: "No Content",
  // The server successfully processed the request, but is not returning any content.[2]
  205: "Reset Content",
  // The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.[2]
  206: "Partial Content",
  // The server is delivering only part of the resource due to a range header sent by the client. The range header is used by tools like wget to enable resuming of interrupted downloads, or split a download into multiple simultaneous streams.[2]
  207: "Multi-Status",
  // (WebDAV; RFC 4918) The message body that follows is an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.[4]
  208: "Already Reported",
  // (WebDAV; RFC 5842) The members of a DAV binding have already been enumerated in a previous reply to this request, and are not being included again.
  226: "IM Used",
  // (RFC 3229) The server has fulfilled a GET request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance. [5]
  // 3xx Redirection
  // The client must take additional action to complete the request.[2]
  // This class of status code indicates that further action needs to be taken by the user agent in order to fulfil the request. The action required may be carried out by the user agent without interaction with the user if and only if the method used in the second request is GET or HEAD. A user agent should not automatically redirect a request more than five times, since such redirections usually indicate an infinite loop.
  300: "Multiple Choices",
  // Indicates multiple options for the resource that the client may follow. It, for instance, could be used to present different format options for video, list files with different extensions, or word sense disambiguation.[2]
  301: "Moved Permanently",
  // This and all future requests should be directed to the given URI.[2]
  302: "Found",
  // This is an example of industry practice contradicting the standard.[2] The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"),[6] but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.[7] However, some Web applications and frameworks use the 302 status code as if it were the 303.[citation needed]
  303: "See Other",
  // (since HTTP/1.1) The response to the request can be found under another URI using a GET method. When received in response to a POST (or PUT/DELETE), it should be assumed that the server has received the data and the redirect should be issued with a separate GET message.[2]
  304: "Not Modified",
  // Indicates the resource has not been modified since last requested.[2] Typically, the HTTP client provides a header like the If-Modified-Since header to provide a time against which to compare. Using this saves bandwidth and reprocessing on both the server and client, as only the header data must be sent and received in comparison to the entirety of the page being re-processed by the server, then sent again using more bandwidth of the server and client.
  305: "Use Proxy",
  // (since HTTP/1.1) Many HTTP clients (such as Mozilla[8] and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.[2]
  306: "Switch Proxy",
  // No longer used.[2] Originally meant "Subsequent requests should use the specified proxy."[9]
  307: "Temporary Redirect",
  // (since HTTP/1.1) In this case, the request should be repeated with another URI; however, future requests can still use the original URI.[2] In contrast to 302, the request method should not be changed when reissuing the original request. For instance, a POST request must be repeated using another POST request.
  308: "Permanent Redirect",
  // (experimental Internet-Draft)[10] The request, and all future requests should be repeated using another URI. 307 and 308 (as proposed) parallel the behaviours of 302 and 301, but do not require the HTTP method to change. So, for example, submitting a form to a permanently redirected resource may continue smoothly.
  // 4xx Client Error
  // The 4xx class of status code is intended for cases in which the client seems to have erred. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and whether it is a temporary or permanent condition. These status codes are applicable to any request method. User agents should display any included entity to the user.
  400: "Bad Request",
  // The request cannot be fulfilled due to bad syntax.[2]
  401: "Unauthorized",
  // Similar to 403 Forbidden, but specifically for use when authentication is possible but has failed or not yet been provided.[2] The response must include a WWW-Authenticate header field containing a challenge applicable to the requested resource. See Basic access authentication and Digest access authentication.
  402: "Payment Required",
  // Reserved for future use.[2] The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, but that has not happened, and this code is not usually used. As an example of its use, however, Apple's MobileMe service generates a 402 error ("httpStatusCode:402" in the Mac OS X Console log) if the MobileMe account is delinquent.[citation needed]
  403: "Forbidden",
  // The request was a legal request, but the server is refusing to respond to it.[2] Unlike a 401 Unauthorized response, authenticating will make no difference.[2]
  404: "Not Found",
  // The requested resource could not be found but may be available again in the future.[2] Subsequent requests by the client are permissible.
  405: "Method Not Allowed",
  // A request was made of a resource using a request method not supported by that resource;[2] for example, using GET on a form which requires data to be presented via POST, or using PUT on a read-only resource.
  406: "Not Acceptable",
  // The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request.[2]
  407: "Proxy Authentication Required",
  // The client must first authenticate itself with the proxy.[2]
  408: "Request Timeout",
  // The server timed out waiting for the request.[2] According to W3 HTTP specifications: "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
  409: "Conflict",
  // Indicates that the request could not be processed because of conflict in the request, such as an edit conflict.[2]
  410: "Gone",
  // Indicates that the resource requested is no longer available and will not be available again.[2] This should be used when a resource has been intentionally removed and the resource should be purged. Upon receiving a 410 status code, the client should not request the resource again in the future. Clients such as search engines should remove the resource from their indices. Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
  411: "Length Required",
  // The request did not specify the length of its content, which is required by the requested resource.[2]
  412: "Precondition Failed",
  // The server does not meet one of the preconditions that the requester put on the request.[2]
  413: "Request Entity Too Large",
  // The request is larger than the server is willing or able to process.[2]
  414: "Request-URI Too Long",
  // The URI provided was too long for the server to process.[2]
  415: "Unsupported Media Type",
  // The request entity has a media type which the server or resource does not support.[2] For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
  416: "Requested Range Not Satisfiable",
  // The client has asked for a portion of the file, but the server cannot supply that portion.[2] For example, if the client asked for a part of the file that lies beyond the end of the file.[2]
  417: "Expectation Failed",
  // The server cannot meet the requirements of the Expect request-header field.[2]
  418: "I'm a teapot",
  // (RFC 2324) This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. However, known implementations do exist.[11]
  420: "Enhance Your Calm",
  // (Twitter) Returned by the Twitter Search and Trends API when the client is being rate limited.[12] Likely a reference to this number's association with marijuana. Other services may wish to implement the 429 Too Many Requests response code instead. The phrase "Enhance Your Calm" is a reference to Demolition Man (film). In the film, Sylvester Stallone's character John Spartan is a hot-head in a generally more subdued future, and is regularly told to "Enhance your calm" rather than a more common phrase like "calm down".
  422: "Unprocessable Entity",
  // (WebDAV; RFC 4918) The request was well-formed but was unable to be followed due to semantic errors.[4]
  423: "Locked",
  // (WebDAV; RFC 4918) The resource that is being accessed is locked.[4]
  424: "Failed Dependency",
  // (WebDAV; RFC 4918) The request failed due to failure of a previous request (e.g. a PROPPATCH).[4]
  425: "Unordered Collection",
  // (Internet draft) Defined in drafts of "WebDAV Advanced Collections Protocol",[14] but not present in "Web Distributed Authoring and Versioning (WebDAV) Ordered Collections Protocol".[15]
  426: "Upgrade Required",
  // (RFC 2817) The client should switch to a different protocol such as TLS/1.0.[16]
  428: "Precondition Required",
  // (RFC 6585) The origin server requires the request to be conditional. Intended to prevent "the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict."[17]
  429: "Too Many Requests",
  // (RFC 6585) The user has sent too many requests in a given amount of time. Intended for use with rate limiting schemes.[17]
  431: "Request Header Fields Too Large",
  // (RFC 6585) The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.[17]
  444: "No Response",
  // (Nginx) Used in Nginx logs to indicate that the server has returned no information to the client and closed the connection (useful as a deterrent for malware).
  449: "Retry With",
  // (Microsoft) A Microsoft extension. The request should be retried after performing the appropriate action.[18] Often search-engines or custom applications will ignore required parameters. Where no default action is appropriate, the Aviongoo website sends a "HTTP/1.1 449 Retry with valid parameters: param1, param2, . . ." response. The applications may choose to learn, or not.
  450: "Blocked by Windows Parental Controls",
  // (Microsoft) A Microsoft extension. This error is given when Windows Parental Controls are turned on and are blocking access to the given webpage.[19]
  451: "Unavailable For Legal Reasons",
  // (Internet draft) Defined in the internet draft "A New HTTP Status Code for Legally-restricted Resources",[20]. Intended to be used when resource access is denied for legal reasons, e.g. censorship or government-mandated blocked access. Likely a reference to the 1953 dystopian novel Fahrenheit 451, where books are outlawed.
  499: "Client Closed Request",
  // (Nginx) Used in Nginx logs to indicate when the connection has been closed by client while the server is still processing its request, making server unable to send a status code back.[21]
  // 5xx Server Error
  // The server failed to fulfill an apparently valid request.[2]
  // Response status codes beginning with the digit "5" indicate cases in which the server is aware that it has encountered an error or is otherwise incapable of performing the request. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and indicate whether it is a temporary or permanent condition. Likewise, user agents should display any included entity to the user. These response codes are applicable to any request method.
  500: "Internal Server Error",
  // A generic error message, given when no more specific message is suitable.[2]
  501: "Not Implemented",
  // The server either does not recognise the request method, or it lacks the ability to fulfill the request.[2]
  502: "Bad Gateway",
  // The server was acting as a gateway or proxy and received an invalid response from the upstream server.[2]
  503: "Service Unavailable",
  // The server is currently unavailable (because it is overloaded or down for maintenance).[2] Generally, this is a temporary state.
  504: "Gateway Timeout",
  // The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.[2]
  505: "HTTP Version Not Supported",
  // The server does not support the HTTP protocol version used in the request.[2]
  506: "Variant Also Negotiates",
  // (RFC 2295) Transparent content negotiation for the request results in a circular reference.[22]
  507: "Insufficient Storage",
  // (WebDAV; RFC 4918) The server is unable to store the representation needed to complete the request.[4]
  508: "Loop Detected",
  // (WebDAV; RFC 5842) The server detected an infinite loop while processing the request (sent in lieu of 208).
  509: "Bandwidth Limit Exceeded",
  // (Apache bw/limited extension) This status code, while used by many servers, is not specified in any RFCs.
  510: "Not Extended",
  // (RFC 2774) Further extensions to the request are required for the server to fulfill it.[23]
  511: "Network Authentication Required",
  // (RFC 6585) The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network (e.g. "captive portals" used to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).[17]
  598: "Network read timeout error",
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
  599: "Network connect timeout error"
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network connect timeout behind the proxy to a client in front of the proxy.
}, kh = lr.extend({
  clientSecret: i.string().optional()
}), Nh = fr.extend({
  clientSecret: i.string().optional()
}), Uh = i.object({
  authType: i.literal("oauth-2"),
  grantTypeInfo: i.discriminatedUnion("grantType", [
    ho,
    kh,
    Nh,
    sr
  ]),
  addTo: i.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ch = i.object({
  authType: i.literal("digest"),
  username: i.string().catch(""),
  password: i.string().catch(""),
  realm: i.string().catch(""),
  nonce: i.string().catch(""),
  algorithm: i.enum(["MD5", "MD5-sess"]).catch("MD5"),
  qop: i.enum(["auth", "auth-int"]).catch("auth"),
  nc: i.string().catch(""),
  cnonce: i.string().catch(""),
  opaque: i.string().catch(""),
  disableRetry: i.boolean().catch(!1)
}), pa = i.discriminatedUnion("authType", [
  De,
  Ve,
  Ke,
  Ze,
  Uh,
  Un,
  ga,
  Ch
]).and(
  i.object({
    authActive: i.boolean()
  })
), Fh = i.union(
  Object.keys(Ph).map((t) => i.literal(parseInt(t)))
), $h = i.array(
  i.object({
    key: i.string(),
    value: i.string()
  })
), Lh = i.object({
  v: i.literal("1"),
  name: i.string(),
  method: i.string(),
  endpoint: i.string(),
  headers: va,
  params: vo,
  body: fo,
  auth: pa,
  requestVariables: eo
}), Wh = i.object({
  name: i.string(),
  originalRequest: Lh,
  status: i.string(),
  code: i.optional(Fh),
  headers: $h,
  body: i.string()
}), qh = i.record(
  i.string(),
  Wh
), Dh = po.extend({
  v: i.literal("8"),
  auth: pa,
  responses: qh
}), Kh = dt({
  schema: Dh,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: "8",
      // no need to update anything for HoppRESTAuth, because we loosened the previous schema by making `clientSecret` optional
      responses: {}
    };
  }
}), Zh = i.object({
  // v is a stringified number
  v: i.string().regex(/^\d+$/).transform(Number)
}), yo = Nn({
  latestVersion: 8,
  versionMap: {
    0: di,
    1: Eh,
    2: Ih,
    3: wh,
    4: Mh,
    5: Sh,
    6: Rh,
    7: jh,
    8: Kh
  },
  getVersion(t) {
    const e = Zh.safeParse(t);
    return e.success ? e.data.v : di.schema.safeParse(t).success ? 0 : null;
  }
}), ya = i.object({
  key: i.string().catch(""),
  value: i.string().catch(""),
  active: i.boolean().catch(!0)
}), Vh = i.object({
  v: i.literal(1),
  name: i.string(),
  url: i.string(),
  headers: i.array(ya).catch([]),
  query: i.string(),
  variables: i.string()
}), Bh = dt({
  initial: !0,
  schema: Vh
}), Be = i.object({
  authType: i.literal("none")
}), ze = i.object({
  authType: i.literal("basic"),
  username: i.string().catch(""),
  password: i.string().catch("")
}), He = i.object({
  authType: i.literal("bearer"),
  token: i.string().catch("")
}), zh = i.object({
  authType: i.literal("oauth-2"),
  token: i.string().catch(""),
  oidcDiscoveryURL: i.string().catch(""),
  authURL: i.string().catch(""),
  accessTokenURL: i.string().catch(""),
  clientID: i.string().catch(""),
  scope: i.string().catch("")
}), _a = i.object({
  authType: i.literal("api-key"),
  key: i.string().catch(""),
  value: i.string().catch(""),
  addTo: i.string().catch("Headers")
}), Je = i.object({
  authType: i.literal("inherit")
}), Hh = i.discriminatedUnion("authType", [
  Be,
  ze,
  He,
  zh,
  _a,
  Je
]).and(
  i.object({
    authActive: i.boolean()
  })
), _o = i.object({
  id: i.optional(i.string()),
  v: i.literal(2),
  name: i.string(),
  url: i.string(),
  headers: i.array(ya).catch([]),
  query: i.string(),
  variables: i.string(),
  auth: Hh
}), Jh = dt({
  initial: !1,
  schema: _o,
  up(t) {
    return {
      ...t,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), Gh = i.discriminatedUnion("authType", [
  Be,
  Je,
  ze,
  He,
  _a,
  dr
  // both rest and gql have the same auth type for oauth2
]).and(
  i.object({
    authActive: i.boolean()
  })
), bo = _o.extend({
  v: i.literal(3),
  auth: Gh
}), Yh = dt({
  initial: !1,
  schema: bo,
  up(t) {
    if (t.auth.authType === "oauth-2") {
      const { token: e, accessTokenURL: n, scope: r, clientID: a, authURL: u } = t.auth;
      return {
        ...t,
        v: 3,
        auth: {
          ...t.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: u,
            tokenEndpoint: n,
            clientID: a,
            clientSecret: "",
            scopes: r,
            isPKCE: !1,
            token: e
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...t,
      v: 3,
      auth: {
        ...t.auth
      }
    };
  }
}), mr = _a.extend({
  addTo: i.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Qh = i.discriminatedUnion("authType", [
  Be,
  Je,
  ze,
  He,
  mr,
  hr
  // both rest and gql have the same auth type for oauth2
]).and(
  i.object({
    authActive: i.boolean()
  })
), Oo = bo.extend({
  v: i.literal(4),
  auth: Qh
}), Xh = dt({
  initial: !1,
  schema: Oo,
  up(t) {
    return t.auth.authType === "api-key" ? {
      ...t,
      v: 4,
      auth: {
        ...t.auth,
        addTo: t.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...t,
      v: 4,
      auth: {
        ...t.auth
      }
    };
  }
}), Eo = i.discriminatedUnion("authType", [
  Be,
  Je,
  ze,
  He,
  mr,
  hr
  // both rest and gql have the same auth type for oauth2
]).and(
  i.object({
    authActive: i.boolean()
  })
), Io = Oo.extend({
  v: i.literal(5),
  auth: Eo
}), xh = dt({
  initial: !1,
  schema: Io,
  up(t) {
    return {
      ...t,
      v: 5
    };
  }
}), Ao = ga, wo = i.object({
  key: i.string().catch(""),
  value: i.string().catch(""),
  active: i.boolean().catch(!0),
  description: i.string().catch("")
}), To = i.discriminatedUnion("authType", [
  Be,
  Je,
  ze,
  He,
  hr,
  mr,
  Ao
]).and(
  i.object({
    authActive: i.boolean()
  })
), Mo = Io.extend({
  v: i.literal(6),
  auth: To,
  headers: i.array(wo).catch([])
}), tm = dt({
  schema: Mo,
  initial: !1,
  up(t) {
    const e = t.headers.map((n) => ({
      ...n,
      description: ""
    }));
    return {
      ...t,
      v: 6,
      headers: e
    };
  }
}), So = i.discriminatedUnion("authType", [
  Be,
  Je,
  ze,
  He,
  mo,
  mr,
  Ao
]).and(
  i.object({
    authActive: i.boolean()
  })
), em = Mo.extend({
  v: i.literal(7),
  auth: So
}), nm = dt({
  schema: em,
  initial: !1,
  up(t) {
    return {
      ...t,
      v: 7
      // no need to update anything for HoppGQLAuth, because we loosened the previous schema by making `clientSecret` optional
    };
  }
}), rm = i.object({
  v: i.number()
}), Ro = Nn({
  latestVersion: 7,
  versionMap: {
    1: Bh,
    2: Jh,
    3: Yh,
    4: Xh,
    5: xh,
    6: tm,
    7: nm
  },
  getVersion(t) {
    const e = rm.safeParse(t);
    return e.success ? e.data.v : null;
  }
}), am = i.object({
  v: i.literal(1),
  id: i.optional(i.string()),
  // For Firestore ID data
  name: i.string(),
  requests: i.array(
    i.lazy(
      () => i.union([
        rr(yo),
        rr(Ro)
      ])
    )
  )
}), jo = am.extend({
  folders: i.lazy(() => i.array(jo))
}), hi = dt({
  initial: !0,
  schema: jo
}), Po = i.object({
  v: i.literal(2),
  id: i.optional(i.string()),
  // For Firestore ID data
  name: i.string(),
  requests: i.array(
    i.lazy(
      () => i.union([
        rr(yo),
        rr(Ro)
      ])
    )
  ),
  auth: i.union([co, Eo]),
  headers: i.union([xu, i.array(ya)])
}), ko = Po.extend({
  folders: i.lazy(() => i.array(ko))
}), im = dt({
  initial: !1,
  schema: ko,
  up(t) {
    const e = {
      ...t,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: []
    };
    return t.id && (e.id = t.id), e;
  }
}), No = Po.extend({
  v: i.literal(3),
  // AWS Signature Authorization type addition
  auth: i.union([go, To]),
  // `description` field addition under `headers`
  headers: i.union([va, i.array(wo)])
}), Uo = No.extend({
  folders: i.lazy(() => i.array(Uo))
}), um = dt({
  initial: !1,
  schema: Uo,
  up(t) {
    const e = t.headers.map(
      (n) => ({
        ...n,
        description: ""
      })
    );
    return {
      ...t,
      v: 3,
      headers: e
    };
  }
}), om = No.extend({
  v: i.literal(4),
  auth: i.union([pa, So])
}), Co = om.extend({
  folders: i.lazy(() => i.array(Co))
}), cm = dt({
  initial: !1,
  schema: Co,
  // @ts-expect-error
  up(t) {
    return {
      ...t,
      v: 4
    };
  }
}), lm = i.object({
  v: i.number()
});
Nn({
  latestVersion: 4,
  versionMap: {
    1: hi,
    2: im,
    3: um,
    4: cm
  },
  getVersion(t) {
    const e = lm.safeParse(t);
    return e.success ? e.data.v : hi.schema.safeParse(t).success ? 1 : null;
  }
});
var ae = function(t) {
  return function(e) {
    return !t(e);
  };
}, fm = Ef, sm = bf;
function Fo(t, e) {
  return e === void 0 ? function(n) {
    return Fo(t, n);
  } : sm(t, e) ? ku : Nu(e[t]);
}
var dm = function(t) {
  return function(e) {
    for (var n = [], r = 0; r < e.length; r++) {
      var a = t(r, e[r]);
      Pu(a) && n.push(a.value);
    }
    return n;
  };
}, hm = function(t) {
  return dm(function(e, n) {
    return t(n);
  });
}, mm = function(t) {
  return t.slice();
}, vm = _f, mi = function(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, a = e.length, u; r < a; r++)
    (u || !(r in e)) && (u || (u = Array.prototype.slice.call(e, 0, r)), u[r] = e[r]);
  return t.concat(u || Array.prototype.slice.call(e));
}, gm = function(t) {
  return function(e) {
    return mi(mi([], e, !0), [t], !1);
  };
}, pm = gm, ym = function(t) {
  return [t];
}, _m = pm, bm = Fo, Om = function() {
  return {
    concat: function(t, e) {
      return t.concat(e);
    }
  };
}, Em = function() {
  return {
    concat: Om().concat,
    empty: []
  };
}, vr = ku, Cn = Nu;
function $o(t) {
  return function(e) {
    return t(e) ? Cn(e) : vr;
  };
}
var Dr = function(t) {
  return function(e) {
    return Lo(e) ? vr : Cn(t(e.value));
  };
}, Im = Pu, Lo = function(t) {
  return t._tag === "None";
}, Am = function(t, e) {
  return function(n) {
    return Lo(n) ? t() : e(n.value);
  };
}, wm = Am, ba = wm, Tm = function(t, e) {
  for (var n = e(t); n._tag === "Left"; )
    n = e(n.left);
  return n.right;
}, ye = ff, Bt = sf, Mm = /* @__PURE__ */ of(2, function(t, e) {
  return Mn(t) ? t : e(t.right);
}), Wo = function(t) {
  return function(e) {
    return Mn(e) ? e : Bt(t(e.right));
  };
}, qo = function(t) {
  return function(e) {
    return Mn(e) ? ye(t(e.left)) : e;
  };
}, Mn = cf, Sm = lf, vi = Mm, ar = function() {
  return ar = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, ar.apply(this, arguments);
}, Fn = function(t, e, n) {
  return Bt({
    value: t,
    next: e,
    start: n
  });
}, $n = function(t, e, n) {
  return e === void 0 && (e = []), n === void 0 && (n = !1), ye({
    input: t,
    expected: e,
    fatal: n
  });
}, Rm = function(t, e) {
  return ar(ar({}, t), { expected: e });
}, jm = function(t, e) {
  return Pm().concat(t, e);
}, Pm = function() {
  return {
    concat: function(t, e) {
      return t.input.cursor < e.input.cursor ? pf().concat(t, e) : t.input.cursor > e.input.cursor ? Tr().concat(t, e) : gf({
        input: Tr(),
        fatal: Tr(),
        expected: Em()
      }).concat(t, e);
    }
  };
}, km = function(t) {
  return bm(t.cursor, t.buffer);
}, Nm = function(t) {
  return t.cursor >= t.buffer.length;
}, Um = function(t) {
  return Q(km(t), Dr(function(e) {
    return { value: e, next: { buffer: t.buffer, cursor: t.cursor + 1 } };
  }));
}, re = function() {
  return re = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, re.apply(this, arguments);
}, Oa = function(t) {
  return function(e) {
    return Fn(t, e, e);
  };
}, Cm = function() {
  return function(t) {
    return $n(t);
  };
}, Fm = function(t) {
  return function() {
    return $n(t);
  };
}, yt = function(t) {
  return Q(Wm($m()), _e(function(e) {
    var n = e[0], r = e[1];
    return t(n) ? ke(n) : Fm(r);
  }));
}, pt = function(t, e) {
  return function(n) {
    return Q(t(n), qo(function(r) {
      return Rm(r, [e]);
    }));
  };
}, $m = function() {
  return function(t) {
    return Q(Um(t), ba(function() {
      return $n(t);
    }, function(e) {
      var n = e.value, r = e.next;
      return Fn(n, r, t);
    }));
  };
}, Lm = function(t, e) {
  return function(n) {
    return Q(t(n), vi(function(r) {
      return Q(e(r.value)(r.next), vi(function(a) {
        return Fn(a.value, a.next, n);
      }));
    }));
  };
}, gr = function(t, e) {
  return function(n) {
    var r = t(n);
    return Sm(r) || r.left.fatal ? r : Q(e()(n), qo(function(a) {
      return jm(r.left, a);
    }));
  };
}, Wm = function(t) {
  return function(e) {
    return Q(t(e), Wo(function(n) {
      return re(re({}, n), { value: [n.value, e] });
    }));
  };
}, Do = function(t) {
  return be(function() {
    return ke(t.empty);
  });
}, Ea = function() {
  return pt(function(t) {
    return Nm(t) ? Fn(void 0, t, t) : $n(t);
  }, "end of file");
}, qm = function(t) {
  return Q(Ia(t), be(function() {
    return ke([]);
  }));
}, Ia = function(t) {
  return Q(t, _e(function(e) {
    return wa(ym(e), function(n) {
      return Q(t, gt(function(r) {
        return ye(_m(r)(n));
      }), be(function() {
        return ke(Bt(n));
      }));
    });
  }));
}, Dm = function(t, e) {
  return function(n) {
    return Q(t, _e(function() {
      return n;
    }), Ta(function() {
      return e;
    }));
  };
}, Ko = function(t) {
  return Dm(t, t);
}, Km = function(t) {
  return qm(yt(ae(t)));
}, Aa = function(t, e) {
  return Q(e, gt(function() {
    return vm;
  }), be(function() {
    return Zm(t, e);
  }));
}, Zm = function(t, e) {
  return Q(t, _e(function(n) {
    return wa(If(n), function(r) {
      return Q(e, gt(function() {
        return Bt(r);
      }), be(function() {
        return Q(t, gt(function(a) {
          return ye(fm(a)(r));
        }));
      }));
    });
  }));
}, Ln = function(t, e) {
  return function(n) {
    return Q(t(n), Wo(function(r) {
      return re(re({}, r), { value: e(r.value) });
    }));
  };
}, Zo = function(t, e) {
  return pr(t, function(n) {
    return Ln(e, n);
  });
}, pr = function(t, e) {
  return Lm(t, e);
}, wa = function(t, e) {
  var n = function(r) {
    return function(a) {
      return Mn(a.value) ? ye({ value: a.value.left, stream: a.next }) : Bt(Fn(a.value.right, a.next, r));
    };
  };
  return function(r) {
    return Tm({ value: t, stream: r }, function(a) {
      var u = e(a.value)(a.stream);
      return Mn(u) ? Bt($n(a.stream, u.left.expected, u.left.fatal)) : n(r)(u.right);
    });
  };
}, Vm = function(t, e) {
  return gr(t, e);
}, gt = function(t) {
  return function(e) {
    return Ln(e, t);
  };
}, ke = Oa, _e = function(t) {
  return function(e) {
    return pr(e, t);
  };
}, Ta = function(t) {
  return function(e) {
    return pr(e, function(n) {
      return Ln(t(n), function() {
        return n;
      });
    });
  };
}, be = function(t) {
  return function(e) {
    return Vm(e, t);
  };
}, Bm = "Parser", zm = function(t) {
  return {
    concat: function(e, n) {
      return Zo(Ln(e, function(r) {
        return function(a) {
          return t.concat(r, a);
        };
      }), n);
    }
  };
}, Hm = function(t) {
  return re(re({}, zm(t)), { empty: Oa(t.empty) });
}, Jm = {
  URI: Bm,
  map: Ln,
  ap: Zo,
  chain: pr,
  chainRec: wa
}, Vo = function(t, e, n) {
  var r;
  return Object.assign({}, t, (r = {}, r[e] = n, r));
}, Bo = function(t) {
  return function(e) {
    return Q(e, gt(function(n) {
      return Vo({}, t, n);
    }));
  };
}, Kr = function(t, e) {
  return function(n) {
    return Q(n, _e(function(r) {
      return Q(e(r), gt(function(a) {
        return Vo(r, t, a);
      }));
    }));
  };
}, Gm = function(t) {
  return yf(t)(t.empty);
}, Ym = Do(fa), Ne = function(t) {
  return pt(yt(function(e) {
    return e === t;
  }), '"'.concat(t, '"'));
}, Qm = function(t) {
  return pt(yt(function(e) {
    return e !== t;
  }), 'anything but "'.concat(t, '"'));
}, Ma = function(t) {
  return Ym(Wn(t));
}, Wn = function(t) {
  return Q(Ia(t), gt(function(e) {
    return e.join("");
  }));
}, Sa = function(t) {
  return "0123456789".indexOf(t) !== -1;
}, Zr = pt(yt(Sa), "a digit"), Xm = /^\s$/, zo = function(t) {
  return Xm.test(t);
}, Ho = pt(yt(zo), "a whitespace"), xm = function(t) {
  return t === "_";
}, qn = function(t) {
  return /[a-z]/.test(t.toLowerCase());
}, Jo = function(t) {
  return qn(t) || Sa(t) || xm(t);
};
pt(yt(Jo), "a word character");
pt(yt(qn), "a letter");
var tv = function(t) {
  return t.toLowerCase() !== t.toUpperCase();
};
pt(yt(tv), "an unicode letter");
var Go = function(t) {
  return qn(t) && t === t.toUpperCase();
};
pt(yt(Go), "an upper case letter");
var Yo = function(t) {
  return qn(t) && t === t.toLowerCase();
};
pt(yt(Yo), "a lower case letter");
pt(yt(ae(Sa)), "a non-digit");
var Qo = pt(yt(ae(zo)), "a non-whitespace character");
pt(yt(ae(Jo)), "a non-word character");
pt(yt(ae(qn)), "a non-letter character");
pt(yt(ae(Go)), "anything but an upper case letter");
pt(yt(ae(Yo)), "anything but a lower case letter");
var Xo = function(t) {
  return pt(Jm.chainRec(t, function(e) {
    return Q(rv(0, e), ba(function() {
      return ke(Bt(t));
    }, function(n) {
      return Q(Ne(n), _e(function() {
        return ke(ye(e.slice(1)));
      }));
    }));
  }), JSON.stringify(t));
}, Vr = Gm(Hm(fa)), Sn = Do(fa), ev = function(t) {
  return Sn(nv(t));
}, nv = function(t) {
  return Q(Ia(t), gt(function(e) {
    return e.join("");
  }));
}, rv = function(t, e) {
  return t < e.length ? Cn(e.charAt(t)) : vr;
}, av = Ma(Ho);
Wn(Ho);
Ma(Qo);
Wn(Qo);
var iv = function(t) {
  var e = +t;
  return isNaN(e) || t === "" ? vr : Cn(e);
};
pt(Q(Vr([Sn(Ne("-")), Wn(Zr)]), gt(function(t) {
  return +t;
})), "an integer");
pt(Q(Vr([Sn(Ne("-")), Ma(Zr), Sn(Vr([Ne("."), Wn(Zr)]))]), _e(function(t) {
  return Q(iv(t), ba(function() {
    return Cm();
  }, Oa));
})), "a float");
var uv = Ko(Ne('"'))(ev(gr(Xo('\\"'), function() {
  return Qm('"');
})));
const Ue = Ko(av), xo = (t) => (e) => e.join(t), Ra = (t) => Q(
  Km((e) => t.includes(e)),
  gt(xo(""))
), ov = Me(
  Ra,
  Ta(() => yt(() => !0))
), tc = Q(
  uv,
  gt((t) => JSON.parse(`"${t}"`))
), cv = Q(
  Ue(tc),
  be(
    () => Q(
      Ra([":", `
`]),
      gt(Uu)
    )
  )
), lv = Q(
  Ue(tc),
  be(
    () => Q(
      Ra([`
`]),
      gt(Uu)
    )
  )
), ec = Q(
  Sn(Xo("#")),
  gt(ae(Cu))
), nc = Q(
  Ue(ec),
  Bo("commented"),
  Kr("key", () => Ue(cv)),
  Ta(() => Ne(":")),
  Kr("value", () => lv)
), fv = Q(
  Ue(ec),
  Bo("commented"),
  Kr("key", () => gr(
    ov([`
`]),
    () => Q(
      Aa(yt((t) => !0), Ea()),
      gt(Me(
        mm,
        xo("")
      ))
    )
  )),
  gt(Me(
    $o(({ key: t }) => !Cu(t))
  ))
);
Q(
  Aa(Ue(nc), Ea())
);
Q(
  Aa(
    gr(
      Q(nc, gt(Cn)),
      () => Q(
        fv,
        gt(Me(
          Dr((t) => ({ ...t, value: "" }))
        ))
      )
    ),
    Ea()
  ),
  gt(Me(
    hm(Me(
      $o(Im),
      Dr((t) => t.value)
    ))
  ))
);
const sv = i.object({
  id: i.optional(i.string()),
  name: i.string(),
  variables: i.array(
    i.object({
      key: i.string(),
      value: i.string()
    })
  )
}), gi = dt({
  initial: !0,
  schema: sv
}), dv = () => Math.random().toString(36).substring(2, 16), hv = i.object({
  v: i.literal(1),
  id: i.string(),
  name: i.string(),
  variables: i.array(
    i.union([
      i.object({
        key: i.string(),
        secret: i.literal(!0)
      }),
      i.object({
        key: i.string(),
        value: i.string(),
        secret: i.literal(!1).catch(!1)
      })
    ])
  )
}), mv = dt({
  initial: !1,
  schema: hv,
  up(t) {
    return {
      ...t,
      v: 1,
      id: t.id || dv(),
      variables: t.variables.map((e) => ({
        ...e,
        secret: !1
      }))
    };
  }
}), vv = [
  // Common
  {
    key: "$guid",
    description: "A v4 style GUID.",
    getValue: () => {
      const t = "0123456789abcdef";
      let e = "";
      for (let n = 0; n < 36; n++)
        n === 8 || n === 13 || n === 18 || n === 23 ? e += "-" : n === 14 ? e += "4" : n === 19 ? e += t.charAt(8 + Math.floor(Math.random() * 4)) : e += t.charAt(
          Math.floor(Math.random() * t.length)
        );
      return e;
    }
  },
  {
    key: "$timestamp",
    description: "The current UNIX timestamp in seconds.",
    getValue: () => Math.floor(Date.now() / 1e3).toString()
  },
  {
    key: "$isoTimestamp",
    description: "The current ISO timestamp at zero UTC.",
    getValue: () => (/* @__PURE__ */ new Date()).toISOString()
  },
  {
    key: "$randomUUID",
    description: "A random 36-character UUID.",
    getValue: () => {
      const t = "0123456789abcdef";
      let e = "";
      for (let n = 0; n < 36; n++)
        n === 8 || n === 13 || n === 18 || n === 23 ? e += "-" : e += t.charAt(
          Math.floor(Math.random() * t.length)
        );
      return e;
    }
  },
  // Text, numbers, and colors
  {
    key: "$randomAlphaNumeric",
    description: "A random alpha-numeric character.",
    getValue: () => {
      const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return t.charAt(Math.floor(Math.random() * t.length));
    }
  },
  {
    key: "$randomBoolean",
    description: "A random boolean value.",
    getValue: () => Math.random() < 0.5 ? "true" : "false"
  },
  {
    key: "$randomInt",
    description: "A random integer between 0 and 1000.",
    getValue: () => Math.floor(Math.random() * 1e3).toString()
  },
  {
    key: "$randomColor",
    description: "A random color.",
    getValue: () => {
      const t = ["red", "green", "blue", "yellow", "purple", "orange"];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomHexColor",
    description: "A random hex value.",
    getValue: () => {
      const t = "0123456789abcdef";
      let e = "#";
      for (let n = 0; n < 6; n++)
        e += t.charAt(
          Math.floor(Math.random() * t.length)
        );
      return e;
    }
  },
  {
    key: "$randomAbbreviation",
    description: "A random abbreviation.",
    getValue: () => {
      const t = [
        "SQL",
        "PCI",
        "JSON",
        "HTML",
        "CSS",
        "JS",
        "TS",
        "API"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  // Internet and IP addresses
  {
    key: "$randomIP",
    description: "A random IPv4 address.",
    getValue: () => Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 256)
    ).join(".")
  },
  {
    key: "$randomIPV6",
    description: "A random IPv6 address.",
    getValue: () => Array.from(
      { length: 8 },
      () => Math.floor(Math.random() * 65536).toString(16)
    ).join(":")
  },
  {
    key: "$randomMACAddress",
    description: "A random MAC address.",
    getValue: () => Array.from(
      { length: 6 },
      () => Math.floor(Math.random() * 256).toString(16)
    ).join(":")
  },
  {
    key: "$randomPassword",
    description: "A random 15-character alpha-numeric password.",
    getValue: () => {
      const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let e = "";
      for (let n = 0; n < 15; n++)
        e += t.charAt(
          Math.floor(Math.random() * t.length)
        );
      return e;
    }
  },
  {
    key: "$randomLocale",
    description: "A random two-letter language code (ISO 639-1).",
    getValue: () => {
      const t = ["ny", "sr", "si"];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomUserAgent",
    description: "A random user agent.",
    getValue: () => {
      const t = [
        "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10.9.8; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomProtocol",
    description: "A random internet protocol.",
    getValue: () => {
      const t = ["http", "https"];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomSemver",
    description: "A random semantic version number.",
    getValue: () => Array.from(
      { length: 3 },
      () => Math.floor(Math.random() * 10)
    ).join(".")
  },
  // Names
  {
    key: "$randomFirstName",
    description: "A random first name.",
    getValue: () => {
      const t = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomLastName",
    description: "A random last name.",
    getValue: () => {
      const t = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomFullName",
    description: "A random first and last name.",
    getValue: () => {
      const t = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ], e = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return `${t[Math.floor(Math.random() * t.length)]} ${e[Math.floor(Math.random() * e.length)]}`;
    }
  },
  {
    key: "$randomNamePrefix",
    description: "A random name prefix.",
    getValue: () => {
      const t = ["Dr.", "Ms.", "Mr.", "Mrs.", "Miss", "Prof."];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomNameSuffix",
    description: "A random name suffix.",
    getValue: () => {
      const t = ["I", "MD", "DDS", "PhD", "Esq.", "Jr."];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  // Addresses
  {
    key: "$randomCity",
    description: "A random city name.",
    getValue: () => {
      const t = [
        "New York",
        "Los Angeles",
        "Chicago",
        "Houston",
        "Phoenix",
        "Philadelphia"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  // profession
  {
    key: "$randomJobArea",
    description: "A random job area.",
    getValue: () => {
      const t = [
        "Mobility",
        "Intranet",
        "Configuration",
        "Development",
        "Design",
        "Testing"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomJobDescriptor",
    description: "A random job descriptor.",
    getValue: () => {
      const t = [
        "Forward",
        "Corporate",
        "Senior",
        "Junior",
        "Lead",
        "Principal"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomJobTitle",
    description: "A random job title.",
    getValue: () => {
      const t = [
        "International Creative Liaison",
        "Global Branding Officer",
        "Dynamic Data Specialist",
        "Internal Communications Consultant",
        "Productivity Analyst",
        "Regional Applications Developer"
      ];
      return t[Math.floor(Math.random() * t.length)];
    }
  },
  {
    key: "$randomJobType",
    description: "A random job type.",
    getValue: () => {
      const t = ["Supervisor", "Manager", "Coordinator", "Director"];
      return t[Math.floor(Math.random() * t.length)];
    }
  }
  // TODO: Support various other predefined variables
], gv = i.object({
  v: i.number()
});
Nn({
  latestVersion: 1,
  versionMap: {
    0: gi,
    1: mv
  },
  getVersion(t) {
    const e = gv.safeParse(t);
    return e.success ? e.data.v : gi.schema.safeParse(t).success ? 0 : null;
  }
});
const pi = /<<([^>]*)>>/g, yi = 10, pv = "ENV_EXPAND_LOOP";
function _i(t, e, n = !1, r = !1) {
  if (!e || !t)
    return Bt(t);
  let a = t, u = 0, o = !1;
  for (; a.match(pi) != null && u <= yi && !o; )
    a = decodeURI(encodeURI(a)).replace(pi, (c, f) => {
      const l = vv.find(
        (p) => p.key === f
      );
      if (l)
        return l.getValue();
      const d = e.find((p) => p && p.key === f);
      return d && "value" in d ? d.secret && r ? (o = !0, `<<${f}>>`) : d.secret && n ? "*".repeat(
        d.value.length
      ) : d.value : "";
    }), u++;
  return u > yi ? ye(pv) : Bt(a);
}
const yv = i.array(
  i.union([
    i.object({
      key: i.string(),
      value: i.string(),
      secret: i.literal(!1)
    }),
    i.object({
      key: i.string(),
      secret: i.literal(!0)
    }),
    i.object({
      key: i.string(),
      value: i.string()
    })
  ])
), bi = dt({
  initial: !0,
  schema: yv
}), _v = i.object({
  v: i.literal(1),
  variables: i.array(
    i.union([
      i.object({
        key: i.string(),
        secret: i.literal(!0)
      }),
      i.object({
        key: i.string(),
        value: i.string(),
        secret: i.literal(!1)
      })
    ])
  )
}), bv = dt({
  initial: !1,
  schema: _v,
  up(t) {
    return {
      v: 1,
      variables: t.map((e) => "value" in e ? {
        key: e.key,
        value: e.value,
        secret: !1
      } : {
        key: e.key,
        secret: !0
      })
    };
  }
}), Ov = i.object({
  v: i.number()
});
Nn({
  latestVersion: 1,
  versionMap: {
    0: bi,
    1: bv
  },
  getVersion(t) {
    const e = Ov.safeParse(t);
    return e.success ? e.data.v : bi.schema.safeParse(t).success ? 0 : null;
  }
});
var Ev = function(t) {
  return t._tag === "None";
}, Iv = { _tag: "None" }, Av = function(t) {
  return { _tag: "Some", value: t };
}, wv = function(t) {
  return t._tag === "Left";
}, ja = function(t) {
  return { _tag: "Left", left: t };
}, Pa = function(t) {
  return { _tag: "Right", right: t };
};
function Tv(t) {
  return function(e) {
    return function(n) {
      return t.fromEither(Ev(n) ? ja(e()) : Pa(n.value));
    };
  };
}
var Oi = ja, rc = Pa, Mv = "Either", Ei = function(t) {
  return function(e) {
    return yr(e) ? e : rc(t(e.right));
  };
}, ac = {
  URI: Mv,
  fromEither: Cc
}, Sv = /* @__PURE__ */ Tv(ac), yr = wv, ic = function(t) {
  return function(e) {
    return yr(e) ? t(e.left) : e.right;
  };
}, Ii = ic;
ac.fromEither;
var Rv = Iv, jv = Av, Pv = function(t) {
  return t._tag === "None";
}, kv = function(t, e) {
  return function(n) {
    return Pv(n) ? t() : e(n.value);
  };
}, Nv = kv, Uv = Nv, Cv = function(t) {
  return t == null ? Rv : jv(t);
}, uc = typeof global == "object" && global && global.Object === Object && global, Fv = typeof self == "object" && self && self.Object === Object && self, Dt = uc || Fv || Function("return this")(), Ce = Dt.Symbol, oc = Object.prototype, $v = oc.hasOwnProperty, Lv = oc.toString, ln = Ce ? Ce.toStringTag : void 0;
function Wv(t) {
  var e = $v.call(t, ln), n = t[ln];
  try {
    t[ln] = void 0;
    var r = !0;
  } catch {
  }
  var a = Lv.call(t);
  return r && (e ? t[ln] = n : delete t[ln]), a;
}
var qv = Object.prototype, Dv = qv.toString;
function Kv(t) {
  return Dv.call(t);
}
var Zv = "[object Null]", Vv = "[object Undefined]", Ai = Ce ? Ce.toStringTag : void 0;
function Dn(t) {
  return t == null ? t === void 0 ? Vv : Zv : Ai && Ai in Object(t) ? Wv(t) : Kv(t);
}
function Kn(t) {
  return t != null && typeof t == "object";
}
var ka = Array.isArray;
function Zn(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Bv = "[object AsyncFunction]", zv = "[object Function]", Hv = "[object GeneratorFunction]", Jv = "[object Proxy]";
function cc(t) {
  if (!Zn(t))
    return !1;
  var e = Dn(t);
  return e == zv || e == Hv || e == Bv || e == Jv;
}
var Rr = Dt["__core-js_shared__"], wi = function() {
  var t = /[^.]+$/.exec(Rr && Rr.keys && Rr.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function Gv(t) {
  return !!wi && wi in t;
}
var Yv = Function.prototype, Qv = Yv.toString;
function Oe(t) {
  if (t != null) {
    try {
      return Qv.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var Xv = /[\\^$.*+?()[\]{}|]/g, xv = /^\[object .+?Constructor\]$/, tg = Function.prototype, eg = Object.prototype, ng = tg.toString, rg = eg.hasOwnProperty, ag = RegExp(
  "^" + ng.call(rg).replace(Xv, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ig(t) {
  if (!Zn(t) || Gv(t))
    return !1;
  var e = cc(t) ? ag : xv;
  return e.test(Oe(t));
}
function ug(t, e) {
  return t == null ? void 0 : t[e];
}
function Ee(t, e) {
  var n = ug(t, e);
  return ig(n) ? n : void 0;
}
var Br = Ee(Dt, "WeakMap"), Ti = Object.create, og = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!Zn(e))
      return {};
    if (Ti)
      return Ti(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}();
function cg(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var Mi = function() {
  try {
    var t = Ee(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
function lg(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var fg = 9007199254740991, sg = /^(?:0|[1-9]\d*)$/;
function dg(t, e) {
  var n = typeof t;
  return e = e ?? fg, !!e && (n == "number" || n != "symbol" && sg.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function lc(t, e, n) {
  e == "__proto__" && Mi ? Mi(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
function fc(t, e) {
  return t === e || t !== t && e !== e;
}
var hg = Object.prototype, mg = hg.hasOwnProperty;
function sc(t, e, n) {
  var r = t[e];
  (!(mg.call(t, e) && fc(r, n)) || n === void 0 && !(e in t)) && lc(t, e, n);
}
function _r(t, e, n, r) {
  var a = !n;
  n || (n = {});
  for (var u = -1, o = e.length; ++u < o; ) {
    var c = e[u], f = void 0;
    f === void 0 && (f = t[c]), a ? lc(n, c, f) : sc(n, c, f);
  }
  return n;
}
var vg = 9007199254740991;
function dc(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= vg;
}
function hc(t) {
  return t != null && dc(t.length) && !cc(t);
}
var gg = Object.prototype;
function Na(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || gg;
  return t === n;
}
function pg(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var yg = "[object Arguments]";
function Si(t) {
  return Kn(t) && Dn(t) == yg;
}
var mc = Object.prototype, _g = mc.hasOwnProperty, bg = mc.propertyIsEnumerable, Og = Si(/* @__PURE__ */ function() {
  return arguments;
}()) ? Si : function(t) {
  return Kn(t) && _g.call(t, "callee") && !bg.call(t, "callee");
};
function Eg() {
  return !1;
}
var vc = typeof exports == "object" && exports && !exports.nodeType && exports, Ri = vc && typeof module == "object" && module && !module.nodeType && module, Ig = Ri && Ri.exports === vc, ji = Ig ? Dt.Buffer : void 0, Ag = ji ? ji.isBuffer : void 0, gc = Ag || Eg, wg = "[object Arguments]", Tg = "[object Array]", Mg = "[object Boolean]", Sg = "[object Date]", Rg = "[object Error]", jg = "[object Function]", Pg = "[object Map]", kg = "[object Number]", Ng = "[object Object]", Ug = "[object RegExp]", Cg = "[object Set]", Fg = "[object String]", $g = "[object WeakMap]", Lg = "[object ArrayBuffer]", Wg = "[object DataView]", qg = "[object Float32Array]", Dg = "[object Float64Array]", Kg = "[object Int8Array]", Zg = "[object Int16Array]", Vg = "[object Int32Array]", Bg = "[object Uint8Array]", zg = "[object Uint8ClampedArray]", Hg = "[object Uint16Array]", Jg = "[object Uint32Array]", ot = {};
ot[qg] = ot[Dg] = ot[Kg] = ot[Zg] = ot[Vg] = ot[Bg] = ot[zg] = ot[Hg] = ot[Jg] = !0;
ot[wg] = ot[Tg] = ot[Lg] = ot[Mg] = ot[Wg] = ot[Sg] = ot[Rg] = ot[jg] = ot[Pg] = ot[kg] = ot[Ng] = ot[Ug] = ot[Cg] = ot[Fg] = ot[$g] = !1;
function Gg(t) {
  return Kn(t) && dc(t.length) && !!ot[Dn(t)];
}
function Ua(t) {
  return function(e) {
    return t(e);
  };
}
var pc = typeof exports == "object" && exports && !exports.nodeType && exports, dn = pc && typeof module == "object" && module && !module.nodeType && module, Yg = dn && dn.exports === pc, jr = Yg && uc.process, Fe = function() {
  try {
    var t = dn && dn.require && dn.require("util").types;
    return t || jr && jr.binding && jr.binding("util");
  } catch {
  }
}(), Pi = Fe && Fe.isTypedArray, Qg = Pi ? Ua(Pi) : Gg, Xg = Object.prototype, xg = Xg.hasOwnProperty;
function yc(t, e) {
  var n = ka(t), r = !n && Og(t), a = !n && !r && gc(t), u = !n && !r && !a && Qg(t), o = n || r || a || u, c = o ? pg(t.length, String) : [], f = c.length;
  for (var l in t)
    (e || xg.call(t, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    u && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    dg(l, f))) && c.push(l);
  return c;
}
function _c(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var tp = _c(Object.keys, Object), ep = Object.prototype, np = ep.hasOwnProperty;
function rp(t) {
  if (!Na(t))
    return tp(t);
  var e = [];
  for (var n in Object(t))
    np.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
function Ca(t) {
  return hc(t) ? yc(t) : rp(t);
}
function ap(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var ip = Object.prototype, up = ip.hasOwnProperty;
function op(t) {
  if (!Zn(t))
    return ap(t);
  var e = Na(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !up.call(t, r)) || n.push(r);
  return n;
}
function Fa(t) {
  return hc(t) ? yc(t, !0) : op(t);
}
var Rn = Ee(Object, "create");
function cp() {
  this.__data__ = Rn ? Rn(null) : {}, this.size = 0;
}
function lp(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var fp = "__lodash_hash_undefined__", sp = Object.prototype, dp = sp.hasOwnProperty;
function hp(t) {
  var e = this.__data__;
  if (Rn) {
    var n = e[t];
    return n === fp ? void 0 : n;
  }
  return dp.call(e, t) ? e[t] : void 0;
}
var mp = Object.prototype, vp = mp.hasOwnProperty;
function gp(t) {
  var e = this.__data__;
  return Rn ? e[t] !== void 0 : vp.call(e, t);
}
var pp = "__lodash_hash_undefined__";
function yp(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = Rn && e === void 0 ? pp : e, this;
}
function he(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
he.prototype.clear = cp;
he.prototype.delete = lp;
he.prototype.get = hp;
he.prototype.has = gp;
he.prototype.set = yp;
function _p() {
  this.__data__ = [], this.size = 0;
}
function br(t, e) {
  for (var n = t.length; n--; )
    if (fc(t[n][0], e))
      return n;
  return -1;
}
var bp = Array.prototype, Op = bp.splice;
function Ep(t) {
  var e = this.__data__, n = br(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : Op.call(e, n, 1), --this.size, !0;
}
function Ip(t) {
  var e = this.__data__, n = br(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function Ap(t) {
  return br(this.__data__, t) > -1;
}
function wp(t, e) {
  var n = this.__data__, r = br(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
function Ht(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Ht.prototype.clear = _p;
Ht.prototype.delete = Ep;
Ht.prototype.get = Ip;
Ht.prototype.has = Ap;
Ht.prototype.set = wp;
var jn = Ee(Dt, "Map");
function Tp() {
  this.size = 0, this.__data__ = {
    hash: new he(),
    map: new (jn || Ht)(),
    string: new he()
  };
}
function Mp(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function Or(t, e) {
  var n = t.__data__;
  return Mp(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function Sp(t) {
  var e = Or(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function Rp(t) {
  return Or(this, t).get(t);
}
function jp(t) {
  return Or(this, t).has(t);
}
function Pp(t, e) {
  var n = Or(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
function Ge(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Ge.prototype.clear = Tp;
Ge.prototype.delete = Sp;
Ge.prototype.get = Rp;
Ge.prototype.has = jp;
Ge.prototype.set = Pp;
function bc(t, e) {
  for (var n = -1, r = e.length, a = t.length; ++n < r; )
    t[a + n] = e[n];
  return t;
}
var Oc = _c(Object.getPrototypeOf, Object);
function kp() {
  this.__data__ = new Ht(), this.size = 0;
}
function Np(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
function Up(t) {
  return this.__data__.get(t);
}
function Cp(t) {
  return this.__data__.has(t);
}
var Fp = 200;
function $p(t, e) {
  var n = this.__data__;
  if (n instanceof Ht) {
    var r = n.__data__;
    if (!jn || r.length < Fp - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new Ge(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
function Ye(t) {
  var e = this.__data__ = new Ht(t);
  this.size = e.size;
}
Ye.prototype.clear = kp;
Ye.prototype.delete = Np;
Ye.prototype.get = Up;
Ye.prototype.has = Cp;
Ye.prototype.set = $p;
function Lp(t, e) {
  return t && _r(e, Ca(e), t);
}
function Wp(t, e) {
  return t && _r(e, Fa(e), t);
}
var Ec = typeof exports == "object" && exports && !exports.nodeType && exports, ki = Ec && typeof module == "object" && module && !module.nodeType && module, qp = ki && ki.exports === Ec, Ni = qp ? Dt.Buffer : void 0, Ui = Ni ? Ni.allocUnsafe : void 0;
function Dp(t, e) {
  if (e)
    return t.slice();
  var n = t.length, r = Ui ? Ui(n) : new t.constructor(n);
  return t.copy(r), r;
}
function Kp(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, a = 0, u = []; ++n < r; ) {
    var o = t[n];
    e(o, n, t) && (u[a++] = o);
  }
  return u;
}
function Ic() {
  return [];
}
var Zp = Object.prototype, Vp = Zp.propertyIsEnumerable, Ci = Object.getOwnPropertySymbols, $a = Ci ? function(t) {
  return t == null ? [] : (t = Object(t), Kp(Ci(t), function(e) {
    return Vp.call(t, e);
  }));
} : Ic;
function Bp(t, e) {
  return _r(t, $a(t), e);
}
var zp = Object.getOwnPropertySymbols, Ac = zp ? function(t) {
  for (var e = []; t; )
    bc(e, $a(t)), t = Oc(t);
  return e;
} : Ic;
function Hp(t, e) {
  return _r(t, Ac(t), e);
}
function wc(t, e, n) {
  var r = e(t);
  return ka(t) ? r : bc(r, n(t));
}
function Jp(t) {
  return wc(t, Ca, $a);
}
function Gp(t) {
  return wc(t, Fa, Ac);
}
var zr = Ee(Dt, "DataView"), Hr = Ee(Dt, "Promise"), Jr = Ee(Dt, "Set"), Fi = "[object Map]", Yp = "[object Object]", $i = "[object Promise]", Li = "[object Set]", Wi = "[object WeakMap]", qi = "[object DataView]", Qp = Oe(zr), Xp = Oe(jn), xp = Oe(Hr), ty = Oe(Jr), ey = Oe(Br), Zt = Dn;
(zr && Zt(new zr(new ArrayBuffer(1))) != qi || jn && Zt(new jn()) != Fi || Hr && Zt(Hr.resolve()) != $i || Jr && Zt(new Jr()) != Li || Br && Zt(new Br()) != Wi) && (Zt = function(t) {
  var e = Dn(t), n = e == Yp ? t.constructor : void 0, r = n ? Oe(n) : "";
  if (r)
    switch (r) {
      case Qp:
        return qi;
      case Xp:
        return Fi;
      case xp:
        return $i;
      case ty:
        return Li;
      case ey:
        return Wi;
    }
  return e;
});
var ny = Object.prototype, ry = ny.hasOwnProperty;
function ay(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && ry.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var Di = Dt.Uint8Array;
function La(t) {
  var e = new t.constructor(t.byteLength);
  return new Di(e).set(new Di(t)), e;
}
function iy(t, e) {
  var n = e ? La(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var uy = /\w*$/;
function oy(t) {
  var e = new t.constructor(t.source, uy.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var Ki = Ce ? Ce.prototype : void 0, Zi = Ki ? Ki.valueOf : void 0;
function cy(t) {
  return Zi ? Object(Zi.call(t)) : {};
}
function ly(t, e) {
  var n = e ? La(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var fy = "[object Boolean]", sy = "[object Date]", dy = "[object Map]", hy = "[object Number]", my = "[object RegExp]", vy = "[object Set]", gy = "[object String]", py = "[object Symbol]", yy = "[object ArrayBuffer]", _y = "[object DataView]", by = "[object Float32Array]", Oy = "[object Float64Array]", Ey = "[object Int8Array]", Iy = "[object Int16Array]", Ay = "[object Int32Array]", wy = "[object Uint8Array]", Ty = "[object Uint8ClampedArray]", My = "[object Uint16Array]", Sy = "[object Uint32Array]";
function Ry(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case yy:
      return La(t);
    case fy:
    case sy:
      return new r(+t);
    case _y:
      return iy(t, n);
    case by:
    case Oy:
    case Ey:
    case Iy:
    case Ay:
    case wy:
    case Ty:
    case My:
    case Sy:
      return ly(t, n);
    case dy:
      return new r();
    case hy:
    case gy:
      return new r(t);
    case my:
      return oy(t);
    case vy:
      return new r();
    case py:
      return cy(t);
  }
}
function jy(t) {
  return typeof t.constructor == "function" && !Na(t) ? og(Oc(t)) : {};
}
var Py = "[object Map]";
function ky(t) {
  return Kn(t) && Zt(t) == Py;
}
var Vi = Fe && Fe.isMap, Ny = Vi ? Ua(Vi) : ky, Uy = "[object Set]";
function Cy(t) {
  return Kn(t) && Zt(t) == Uy;
}
var Bi = Fe && Fe.isSet, Fy = Bi ? Ua(Bi) : Cy, $y = 1, Ly = 2, Wy = 4, Tc = "[object Arguments]", qy = "[object Array]", Dy = "[object Boolean]", Ky = "[object Date]", Zy = "[object Error]", Mc = "[object Function]", Vy = "[object GeneratorFunction]", By = "[object Map]", zy = "[object Number]", Sc = "[object Object]", Hy = "[object RegExp]", Jy = "[object Set]", Gy = "[object String]", Yy = "[object Symbol]", Qy = "[object WeakMap]", Xy = "[object ArrayBuffer]", xy = "[object DataView]", t_ = "[object Float32Array]", e_ = "[object Float64Array]", n_ = "[object Int8Array]", r_ = "[object Int16Array]", a_ = "[object Int32Array]", i_ = "[object Uint8Array]", u_ = "[object Uint8ClampedArray]", o_ = "[object Uint16Array]", c_ = "[object Uint32Array]", ut = {};
ut[Tc] = ut[qy] = ut[Xy] = ut[xy] = ut[Dy] = ut[Ky] = ut[t_] = ut[e_] = ut[n_] = ut[r_] = ut[a_] = ut[By] = ut[zy] = ut[Sc] = ut[Hy] = ut[Jy] = ut[Gy] = ut[Yy] = ut[i_] = ut[u_] = ut[o_] = ut[c_] = !0;
ut[Zy] = ut[Mc] = ut[Qy] = !1;
function Bn(t, e, n, r, a, u) {
  var o, c = e & $y, f = e & Ly, l = e & Wy;
  if (o !== void 0)
    return o;
  if (!Zn(t))
    return t;
  var d = ka(t);
  if (d) {
    if (o = ay(t), !c)
      return cg(t, o);
  } else {
    var p = Zt(t), E = p == Mc || p == Vy;
    if (gc(t))
      return Dp(t, c);
    if (p == Sc || p == Tc || E && !a) {
      if (o = f || E ? {} : jy(t), !c)
        return f ? Hp(t, Wp(o, t)) : Bp(t, Lp(o, t));
    } else {
      if (!ut[p])
        return a ? t : {};
      o = Ry(t, p, c);
    }
  }
  u || (u = new Ye());
  var R = u.get(t);
  if (R)
    return R;
  u.set(t, o), Fy(t) ? t.forEach(function(F) {
    o.add(Bn(F, e, n, F, t, u));
  }) : Ny(t) && t.forEach(function(F, J) {
    o.set(J, Bn(F, e, n, J, t, u));
  });
  var U = l ? f ? Gp : Jp : f ? Fa : Ca, q = d ? void 0 : U(t);
  return lg(q || t, function(F, J) {
    q && (J = F, F = t[J]), sc(o, J, Bn(F, e, n, J, t, u));
  }), o;
}
var l_ = 1, f_ = 4;
function Rc(t) {
  return Bn(t, l_ | f_);
}
const zi = (t, e) => Cv(
  e.selected.find((n) => n.key === t) ?? e.global.find((n) => n.key === t)
), ir = (t, e) => e.findIndex(
  (n) => n.key === t
), s_ = (t, e, n) => {
  const { global: r, selected: a } = n, u = ir(t, a), o = ir(t, r);
  if (u >= 0) {
    const c = a[u];
    "value" in c && (c.value = e);
  } else o >= 0 ? "value" in r[o] && (r[o].value = e) : a.push({
    key: t,
    value: e,
    secret: !1
  });
  return {
    global: r,
    selected: a
  };
}, d_ = (t, e) => {
  const { global: n, selected: r } = e, a = ir(t, r), u = ir(t, n);
  return a >= 0 ? r.splice(a, 1) : u >= 0 && n.splice(u, 1), {
    global: n,
    selected: r
  };
}, jc = (t) => {
  let e = t;
  return {
    methods: {
      env: {
        get: (c) => {
          if (typeof c != "string")
            throw new Error("Expected key to be a string");
          return ft.pipe(
            zi(c, e),
            Uv(
              () => {
              },
              (l) => String(l.value)
            )
          );
        },
        getResolve: (c) => {
          if (typeof c != "string")
            throw new Error("Expected key to be a string");
          return ft.pipe(
            zi(c, e),
            Sv(() => "INVALID_KEY"),
            Ei(
              (l) => ft.pipe(
                _i(l.value, [
                  ...e.selected,
                  ...e.global
                ]),
                // If the recursive resolution failed, return the unresolved value
                Ii(() => l.value)
              )
            ),
            Ei((l) => String(l)),
            ic(() => {
            })
          );
        },
        set: (c, f) => {
          if (typeof c != "string")
            throw new Error("Expected key to be a string");
          if (typeof f != "string")
            throw new Error("Expected value to be a string");
          e = s_(c, f, e);
        },
        unset: (c) => {
          if (typeof c != "string")
            throw new Error("Expected key to be a string");
          e = d_(c, e);
        },
        resolve: (c) => {
          if (typeof c != "string")
            throw new Error("Expected value to be a string");
          const f = ft.pipe(
            _i(c, [
              ...e.selected,
              ...e.global
            ]),
            Ii(() => c)
          );
          return String(f);
        }
      }
    },
    updatedEnvs: e
  };
}, h_ = (t) => {
  if (typeof t != "string")
    return t;
  try {
    const e = JSON.parse(t);
    return typeof e == "object" ? e.isStringifiedWithinIsolate !== !0 ? t : Array.isArray(e.arr) ? e.arr : (delete e.isStringifiedWithinIsolate, e) : t;
  } catch {
    return t;
  }
};
function m_(t) {
  let e;
  try {
    e = JSON.stringify(t);
  } catch {
    return Oi("Stringification failed");
  }
  try {
    const n = JSON.parse(e);
    return rc(n);
  } catch {
    return Oi("Parsing failed");
  }
}
const Pc = (t, e, n) => {
  const r = {}, a = h_(t), u = (U) => {
    let q = a === U;
    e && (q = !q);
    const F = q ? "pass" : "fail", J = `Expected '${a}' to${e ? " not" : ""} be '${U}'`;
    n[n.length - 1].expectResults.push({
      status: F,
      message: J
    });
  }, o = (U, q, F) => {
    const J = parseInt(a);
    if (Number.isNaN(J)) {
      const A = `Expected ${U}-level status but could not parse value '${a}'`;
      n[n.length - 1].expectResults.push({
        status: "error",
        message: A
      });
    } else {
      let A = J >= q && J <= F;
      e && (A = !A);
      const b = A ? "pass" : "fail", B = `Expected '${J}' to${e ? " not" : ""} be ${U}-level status`;
      n[n.length - 1].expectResults.push({
        status: b,
        message: B
      });
    }
  }, c = () => o("200", 200, 299), f = () => o("300", 300, 399), l = () => o("400", 400, 499), d = () => o("500", 500, 599), p = (U) => {
    if ([
      "string",
      "boolean",
      "number",
      "object",
      "undefined",
      "bigint",
      "symbol",
      "function"
    ].includes(U)) {
      let q = typeof a === U;
      e && (q = !q);
      const F = q ? "pass" : "fail", J = `Expected '${a}' to${e ? " not" : ""} be type '${U}'`;
      n[n.length - 1].expectResults.push({
        status: F,
        message: J
      });
    } else
      n[n.length - 1].expectResults.push({
        status: "error",
        message: 'Argument for toBeType should be "string", "boolean", "number", "object", "undefined", "bigint", "symbol" or "function"'
      });
  }, E = (U) => {
    if (!(Array.isArray(a) || typeof a == "string")) {
      n[n.length - 1].expectResults.push({
        status: "error",
        message: "Expected toHaveLength to be called for an array or string"
      });
      return;
    }
    if (typeof U == "number" && !Number.isNaN(U)) {
      let q = a.length === U;
      e && (q = !q);
      const F = q ? "pass" : "fail", J = `Expected the array to${e ? " not" : ""} be of length '${U}'`;
      n[n.length - 1].expectResults.push({
        status: F,
        message: J
      });
    } else
      n[n.length - 1].expectResults.push({
        status: "error",
        message: "Argument for toHaveLength should be a number"
      });
  }, R = (U) => {
    if (!(Array.isArray(a) || typeof a == "string")) {
      n[n.length - 1].expectResults.push({
        status: "error",
        message: "Expected toInclude to be called for an array or string"
      });
      return;
    }
    if (U === null) {
      n[n.length - 1].expectResults.push({
        status: "error",
        message: "Argument for toInclude should not be null"
      });
      return;
    }
    if (U === void 0) {
      n[n.length - 1].expectResults.push({
        status: "error",
        message: "Argument for toInclude should not be undefined"
      });
      return;
    }
    let q = a.includes(U);
    e && (q = !q);
    const F = JSON.stringify(a), J = JSON.stringify(U), A = q ? "pass" : "fail", b = `Expected ${F} to${e ? " not" : ""} include ${J}`;
    n[n.length - 1].expectResults.push({
      status: A,
      message: b
    });
  };
  return r.toBe = u, r.toBeLevel2xx = c, r.toBeLevel3xx = f, r.toBeLevel4xx = l, r.toBeLevel5xx = d, r.toBeType = p, r.toHaveLength = E, r.toInclude = R, Object.defineProperties(r, {
    not: {
      get: () => Pc(t, !e, n)
    }
  }), r;
}, v_ = (t) => {
  const { methods: e, updatedEnvs: n } = jc(Rc(t));
  return { pw: e, updatedEnvs: n };
}, g_ = (t) => {
  const e = [
    { descriptor: "root", expectResults: [], children: [] }
  ], n = (c, f) => {
    e.push({
      descriptor: c,
      expectResults: [],
      children: []
    }), f();
    const l = e.pop();
    e[e.length - 1].children.push(l);
  }, r = (c) => Pc(c, !1, e), { methods: a, updatedEnvs: u } = jc(Rc(t));
  return { pw: {
    ...a,
    expect: r,
    test: n
  }, testRunStack: e, updatedEnvs: u };
}, p_ = Gr(import.meta.url), y_ = p_("isolated-vm"), Wa = (t) => {
  const e = {};
  for (const [n, r] of Object.entries(t))
    typeof r == "object" && r !== null && !Array.isArray(r) ? e[n] = Wa(r) : typeof r == "function" ? e[n] = new y_.Reference(r) : e[n] = r;
  return e;
}, __ = Gr(import.meta.url), b_ = __("isolated-vm"), L_ = (t, e) => ce(
  oe.tryCatch(
    async () => {
      const n = new b_.Isolate(), r = await n.createContext();
      return { isolate: n, context: r };
    },
    (n) => `Context initialization failed: ${n}`
  ),
  oe.chain(
    ({ isolate: n, context: r }) => ce(
      oe.tryCatch(
        async () => {
          const a = r.global, { pw: u, updatedEnvs: o } = v_(e), c = Wa(u);
          a.setSync("serializedAPIMethods", c, {
            copy: !0
          }), a.setSync("atob", atob), a.setSync("btoa", btoa);
          const f = `
              const pw = new Proxy(serializedAPIMethods, {
                get: (pwObjTarget, pwObjProp) => {
                  const topLevelEntry = pwObjTarget[pwObjProp]

                  // "pw.env" set of API methods
                    if (topLevelEntry && typeof topLevelEntry === "object") {
                      return new Proxy(topLevelEntry, {
                        get: (subTarget, subProp) => {
                          const subLevelProperty = subTarget[subProp]
                          if (subLevelProperty && subLevelProperty.typeof === "function") {
                            return (...args) => subLevelProperty.applySync(null, args)
                          }
                        },
                      })
                    }
                }
              })

              ${t}
            `;
          return await (await n.compileScript(f)).run(r), o;
        },
        (a) => a
      ),
      oe.fold(
        (a) => oe.left(`Script execution failed: ${a}`),
        (a) => ce(
          oe.tryCatch(
            async () => (await n.dispose(), a),
            (u) => `Isolate disposal failed: ${u}`
          )
        )
      )
    )
  )
);
function O_(t) {
  return function(e, n) {
    return t.chain(e, function(r) {
      return yr(r) ? t.of(r) : n(r.right);
    });
  };
}
var E_ = function(t, e) {
  return ce(t, A_(e));
}, I_ = function(t, e) {
  return ce(t, w_(e));
}, A_ = function(t) {
  return function(e) {
    return function() {
      return Promise.resolve().then(e).then(t);
    };
  };
}, w_ = function(t) {
  return function(e) {
    return function() {
      return Promise.all([Promise.resolve().then(e), Promise.resolve().then(t)]).then(function(n) {
        var r = n[0], a = n[1];
        return r(a);
      });
    };
  };
}, kc = function(t) {
  return function() {
    return Promise.resolve(t);
  };
}, T_ = /* @__PURE__ */ Ji(2, function(t, e) {
  return function() {
    return Promise.resolve().then(t).then(function(n) {
      return e(n)();
    });
  };
}), M_ = "Task", S_ = {
  URI: M_,
  map: E_,
  of: kc,
  ap: I_,
  chain: T_
}, R_ = function(t, e, n, r) {
  function a(u) {
    return u instanceof n ? u : new n(function(o) {
      o(u);
    });
  }
  return new (n || (n = Promise))(function(u, o) {
    function c(d) {
      try {
        l(r.next(d));
      } catch (p) {
        o(p);
      }
    }
    function f(d) {
      try {
        l(r.throw(d));
      } catch (p) {
        o(p);
      }
    }
    function l(d) {
      d.done ? u(d.value) : a(d.value).then(c, f);
    }
    l((r = r.apply(t, e || [])).next());
  });
}, j_ = function(t, e) {
  var n = { label: 0, sent: function() {
    if (u[0] & 1) throw u[1];
    return u[1];
  }, trys: [], ops: [] }, r, a, u, o;
  return o = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function c(l) {
    return function(d) {
      return f([l, d]);
    };
  }
  function f(l) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, l[0] && (n = 0)), n; ) try {
      if (r = 1, a && (u = l[0] & 2 ? a.return : l[0] ? a.throw || ((u = a.return) && u.call(a), 0) : a.next) && !(u = u.call(a, l[1])).done) return u;
      switch (a = 0, u && (l = [l[0] & 2, u.value]), l[0]) {
        case 0:
        case 1:
          u = l;
          break;
        case 4:
          return n.label++, { value: l[1], done: !1 };
        case 5:
          n.label++, a = l[1], l = [0];
          continue;
        case 7:
          l = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (u = n.trys, !(u = u.length > 0 && u[u.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            n = 0;
            continue;
          }
          if (l[0] === 3 && (!u || l[1] > u[0] && l[1] < u[3])) {
            n.label = l[1];
            break;
          }
          if (l[0] === 6 && n.label < u[1]) {
            n.label = u[1], u = l;
            break;
          }
          if (u && n.label < u[2]) {
            n.label = u[2], n.ops.push(l);
            break;
          }
          u[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      l = e.call(t, n);
    } catch (d) {
      l = [6, d], a = 0;
    } finally {
      r = u = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}, P_ = kc, Pr = function(t, e) {
  return function() {
    return R_(void 0, void 0, void 0, function() {
      var n;
      return j_(this, function(r) {
        switch (r.label) {
          case 0:
            return r.trys.push([0, 2, , 3]), [4, t().then(Pa)];
          case 1:
            return [2, r.sent()];
          case 2:
            return n = r.sent(), [2, ja(e(n))];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
}, k_ = /* @__PURE__ */ Ji(2, O_(S_)), N_ = "TaskEither", U_ = {
  URI: N_,
  fromEither: P_
};
U_.fromEither;
var Hi = k_;
const C_ = Gr(import.meta.url), Nc = C_("isolated-vm"), W_ = (t, e, n) => ce(
  Pr(
    async () => {
      const r = new Nc.Isolate(), a = await r.createContext();
      return { isolate: r, context: a };
    },
    (r) => `Context initialization failed: ${r}`
  ),
  Hi(
    ({ isolate: r, context: a }) => ce(
      Pr(
        async () => F_(
          t,
          e,
          n,
          r,
          a
        ),
        (u) => `Script execution failed: ${u}`
      ),
      Hi(
        (u) => Pr(
          async () => (await r.dispose(), u),
          (o) => `Isolate disposal failed: ${o}`
        )
      )
    )
  )
), F_ = (t, e, n, r, a) => new Promise((u, o) => {
  const c = m_(n);
  if (yr(c))
    return o(`Response parsing failed: ${c.left}`);
  const f = a.global, { pw: l, testRunStack: d, updatedEnvs: p } = g_(e), E = Wa({
    ...l,
    response: c.right
  });
  f.setSync("serializedAPIMethods", E, { copy: !0 }), f.setSync("atob", atob), f.setSync("btoa", btoa), f.setSync("ivm", Nc);
  const R = `
    const pw = new Proxy(serializedAPIMethods, {
      get: (pwObj, pwObjProp) => {
        // pw.expect(), pw.env, etc.
        const topLevelEntry = pwObj[pwObjProp]

        // If the entry exists and is a function
        // pw.expect(), pw.test(), etc.
        if (topLevelEntry && topLevelEntry.typeof === "function") {
          // pw.test() just involves invoking the function via "applySync()"
          if (pwObjProp === "test") {
            return (...args) => topLevelEntry.applySync(null, args)
          }

          // pw.expect() returns an object with matcher methods
          return (...args) => {
            // Invoke "pw.expect()" and get access to the object with matcher methods
            const expectFnResult = topLevelEntry.applySync(
              null,
              args.map((expectVal) => {
                if (typeof expectVal === "object") {
                  if (expectVal === null) {
                    return null
                  }

                  // Only arrays and objects stringified here should be parsed from the "pw.expect()" method definition
                  // The usecase is that any JSON string supplied should be preserved
                  // An extra "isStringifiedWithinIsolate" prop is added to indicate it has to be parsed

                  if (Array.isArray(expectVal)) {
                    return JSON.stringify({
                      arr: expectVal,
                      isStringifiedWithinIsolate: true,
                    })
                  }

                  return JSON.stringify({
                    ...expectVal,
                    isStringifiedWithinIsolate: true,
                  })
                }

                return expectVal
              })
            )

            // Matcher methods that can be chained with "pw.expect()"
            // pw.expect().toBe(), etc
            if (expectFnResult.typeof === "object") {
              // Access the getter that points to the negated matcher methods via "{ accessors: true }"
              const matcherMethods = {
                not: expectFnResult.getSync("not", { accessors: true }),
              }

              // Serialize matcher methods for use in the isolate context
              const matcherMethodNames = [
                "toBe",
                "toBeLevel2xx",
                "toBeLevel3xx",
                "toBeLevel4xx",
                "toBeLevel5xx",
                "toBeType",
                "toHaveLength",
                "toInclude",
              ]
              matcherMethodNames.forEach((methodName) => {
                matcherMethods[methodName] = expectFnResult.getSync(methodName)
              })

              return new Proxy(matcherMethods, {
                get: (matcherMethodTarget, matcherMethodProp) => {
                  // pw.expect().not.toBe(), etc
                  const matcherMethodEntry = matcherMethodTarget[matcherMethodProp]

                  if (matcherMethodProp === "not") {
                    return new Proxy(matcherMethodEntry, {
                      get: (negatedObjTarget, negatedObjprop) => {
                        // Return the negated matcher method defn that is invoked from the test script
                        const negatedMatcherMethodDefn = negatedObjTarget.getSync(negatedObjprop)
                        return negatedMatcherMethodDefn
                      },
                    })
                  }

                  // Return the matcher method defn that is invoked from the test script
                  return matcherMethodEntry
                },
              })
            }
          }
        }

        // "pw.env" set of API methods
        if (typeof topLevelEntry === "object" && pwObjProp !== "response") {
          return new Proxy(topLevelEntry, {
            get: (subTarget, subProp) => {
              const subLevelProperty = subTarget[subProp]
              if (
                subLevelProperty &&
                subLevelProperty.typeof === "function"
              ) {
                return (...args) => subLevelProperty.applySync(null, args)
              }
            },
          })
        }

        return topLevelEntry
      },
    })

      ${t}
    `;
  r.compileScript(R).then((q) => q.run(a)).then(() => {
    u({
      tests: d,
      envs: p
    });
  }).catch((q) => {
    o(q);
  });
});
export {
  L_ as runPreRequestScript,
  W_ as runTestScript
};
